import * as i0 from '@angular/core';
import { Injectable, Inject, EventEmitter, Component, Output, Input, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/forms';
import { Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@upr-web-primer/ms-utils';
import { MsUtilsModule } from '@upr-web-primer/ms-utils';
import * as i4 from '@upr-web-primer/storage';
import { each, find, debounce, trimEnd, get, range, padStart } from 'lodash-es';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import * as i3 from '@upr-web-primer/tooltip';
import { TooltipModule } from '@upr-web-primer/tooltip';
import * as i2$2 from '@upr-web-primer/locale';
import * as i4$1 from '@upr-web-primer/ngx-mydatepicker';
import { NgxMyDatePickerModule } from '@upr-web-primer/ngx-mydatepicker';
import * as i2$4 from '@upr-web-primer/card-types';
import { CardTypes, CardTypeImageUrls, CardTypeModule, CardPattern } from '@upr-web-primer/card-types';
import { AvailableGdsThemes } from '@upr-gds-web/components';
import * as i2$3 from '@upr-web-primer/gds-input-helper';
import { gdsRequiredValidator, gdsMaxLengthValidator, gdsPatternValidator, gdsMonthDateValidator, gdsNameValidator, gdsSuffixValidator, gdsPhoneNumericValidator, gdsMinLengthValidator, DateRangeValidator, RequiredLabel, GdsInputHelperModule } from '@upr-web-primer/gds-input-helper';
import * as i5 from '@upr-web-primer/geolocation';
import * as i3$1 from '@angular/router';
const _c0 = a0 => ({
  required: a0
});
function AddressFieldComponent_div_2_small_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.formData.optionalLabel);
  }
}
function AddressFieldComponent_div_2_div_5_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-requiredError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_5_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-maxLengthError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_5_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-patternError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER15, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵtemplate(4, AddressFieldComponent_div_2_div_5_small_4_Template, 1, 4, "small", 10)(5, AddressFieldComponent_div_2_div_5_small_5_Template, 1, 4, "small", 10)(6, AddressFieldComponent_div_2_div_5_small_6_Template, 1, 4, "small", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-describedby", ctx_r1.id + "-field" + " " + ctx_r1.id + "-requiredError" + " " + ctx_r1.id + "-maxLengthError" + " " + ctx_r1.id + "-patternError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.formData.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.address == null ? null : ctx_r1.address.errors == null ? null : ctx_r1.address.errors.required) && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.address == null ? null : ctx_r1.address.errors == null ? null : ctx_r1.address.errors.maxlength) && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.address == null ? null : ctx_r1.address.errors == null ? null : ctx_r1.address.errors.pattern) && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER15));
  }
}
function AddressFieldComponent_div_2_div_6_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-requiredError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_6_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-maxLengthError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER32, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_6_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-patternError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER40, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵtemplate(4, AddressFieldComponent_div_2_div_6_small_4_Template, 1, 4, "small", 10)(5, AddressFieldComponent_div_2_div_6_small_5_Template, 1, 4, "small", 10)(6, AddressFieldComponent_div_2_div_6_small_6_Template, 1, 4, "small", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-describedby", ctx_r1.id + "-field" + " " + ctx_r1.id + "-requiredError" + " " + ctx_r1.id + "-maxLengthError" + " " + ctx_r1.id + "-patternError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.formData.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.zipcode == null ? null : ctx_r1.zipcode.errors == null ? null : ctx_r1.zipcode.errors.required) && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.zipcode == null ? null : ctx_r1.zipcode.errors == null ? null : ctx_r1.zipcode.errors.maxLength) && ctx_r1.country === "US" && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER32));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.zipcode == null ? null : ctx_r1.zipcode.errors == null ? null : ctx_r1.zipcode.errors.pattern) && ctx_r1.country !== "US" && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER40));
  }
}
function AddressFieldComponent_div_2_div_7_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-requiredError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_7_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-patternError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER15, i0.ɵɵsanitizeHtml);
  }
}
function AddressFieldComponent_div_2_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵtemplate(4, AddressFieldComponent_div_2_div_7_small_4_Template, 1, 4, "small", 10)(5, AddressFieldComponent_div_2_div_7_small_5_Template, 1, 4, "small", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-describedby", ctx_r1.id + "-field" + " " + ctx_r1.id + "-requiredError" + " " + ctx_r1.id + "-patternError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.formData.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.city == null ? null : ctx_r1.city.errors == null ? null : ctx_r1.city.errors.required) && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.city == null ? null : ctx_r1.city.errors == null ? null : ctx_r1.city.errors.pattern) && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER15));
  }
}
function AddressFieldComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 3);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, AddressFieldComponent_div_2_small_3_Template, 2, 1, "small", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 5);
    i0.ɵɵtwoWayListener("ngModelChange", function AddressFieldComponent_div_2_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.fieldValue, $event) || (ctx_r1.fieldValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function AddressFieldComponent_div_2_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.updateZipPattern($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AddressFieldComponent_div_2_div_5_Template, 7, 6, "div", 6)(6, AddressFieldComponent_div_2_div_6_Template, 7, 6, "div", 6)(7, AddressFieldComponent_div_2_div_7_Template, 6, 5, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c0, ctx_r1.formData == null ? null : ctx_r1.formData.required));
    i0.ɵɵattribute("data-aui", ctx_r1.formData.key)("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.formData.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formData == null ? null : ctx_r1.formData.optionalLabel);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("formControlName", ctx_r1.formData.key)("required", ctx_r1.formData == null ? null : ctx_r1.formData.required);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.fieldValue);
    i0.ɵɵproperty("name", ctx_r1.formData.key)("maxlength", ctx_r1.formData == null ? null : ctx_r1.formData.maxLength)("id", ctx_r1.id)("type", ctx_r1.formData.controlType);
    i0.ɵɵattribute("inputmode", ctx_r1.formData.inputmode || "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.address.invalid && ctx_r1.address.touched);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.zipcode == null ? null : ctx_r1.zipcode.invalid) && ctx_r1.zipcode.touched);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.city == null ? null : ctx_r1.city.invalid) && ((ctx_r1.city == null ? null : ctx_r1.city.dirty) || (ctx_r1.city == null ? null : ctx_r1.city.touched)));
  }
}
function AddressFieldComponent_div_3_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData.placeholder, " ");
  }
}
function AddressFieldComponent_div_3_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const opt_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", opt_r4.key);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", opt_r4.value, " ");
  }
}
function AddressFieldComponent_div_3_div_6_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r1.id + "-requiredError");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, " ");
  }
}
function AddressFieldComponent_div_3_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵtemplate(4, AddressFieldComponent_div_3_div_6_small_4_Template, 2, 4, "small", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-describedby", ctx_r1.id + "-field" + " " + ctx_r1.id + "-requiredError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.formData.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.stateValue == null ? null : ctx_r1.stateValue.errors == null ? null : ctx_r1.stateValue.errors.required);
  }
}
function AddressFieldComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "select", 13);
    i0.ɵɵtwoWayListener("ngModelChange", function AddressFieldComponent_div_3_Template_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.fieldValue, $event) || (ctx_r1.fieldValue = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function AddressFieldComponent_div_3_Template_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChange($event));
    });
    i0.ɵɵtemplate(4, AddressFieldComponent_div_3_option_4_Template, 2, 1, "option", 14)(5, AddressFieldComponent_div_3_option_5_Template, 2, 2, "option", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AddressFieldComponent_div_3_div_6_Template, 5, 4, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-aui", ctx_r1.formData.key)("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.formData.label);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("id", ctx_r1.id)("formControlName", ctx_r1.formData.key);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.fieldValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formData.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.formData.options);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.stateValue.invalid && (ctx_r1.stateValue.dirty || ctx_r1.stateValue.touched));
  }
}
const _c1 = ["input"];
const _c2 = [[["", "checkbox-text", ""]]];
const _c3 = ["[checkbox-text]"];
const _c4 = a0 => ({
  "inverse-checkmark": a0
});
function CheckboxComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "i", 7)(2, "small", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.error, i0.ɵɵsanitizeHtml);
  }
}
const _c5 = a0 => ({
  "inverse-label": a0
});
function DateFieldComponent_div_7_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function DateFieldComponent_div_7_small_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER4, i0.ɵɵsanitizeHtml);
  }
}
function DateFieldComponent_div_7_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER134, i0.ɵɵsanitizeHtml);
  }
}
function DateFieldComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "i", 8);
    i0.ɵɵtemplate(2, DateFieldComponent_div_7_small_2_Template, 1, 3, "small", 9)(3, DateFieldComponent_div_7_small_3_Template, 1, 3, "small", 9)(4, DateFieldComponent_div_7_small_4_Template, 1, 3, "small", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.date.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.date.errors.pattern);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.date.errors.maxlength);
  }
}
function DateFieldComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 8)(2, "small", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER134, i0.ɵɵsanitizeHtml);
  }
}
function DatepickerComponent_div_4_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", (ctx_r1.errorMessages == null ? null : ctx_r1.errorMessages.InValidDateError) || "Please enter a valid date (mm/dd/yyyy)", i0.ɵɵsanitizeHtml);
  }
}
function DatepickerComponent_div_4_small_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHtml", ctx_r1.errorMessages == null ? null : ctx_r1.errorMessages.CheckoutDateRange, i0.ɵɵsanitizeHtml);
  }
}
function DatepickerComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵtemplate(2, DatepickerComponent_div_4_small_2_Template, 1, 1, "small", 7)(3, DatepickerComponent_div_4_small_3_Template, 1, 1, "small", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("id", ctx_r1.name + "Error");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.calendarDateField == null ? null : ctx_r1.calendarDateField.errors == null ? null : ctx_r1.calendarDateField.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessages == null ? null : ctx_r1.errorMessages.CheckoutDateRange);
  }
}
const _c6 = [[["", "dropdown-label", ""]]];
const _c7 = ["[dropdown-label]"];
function DropdownFieldComponent_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "option", 6);
  }
  if (rf & 2) {
    let tmp_1_0;
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngValue", (tmp_1_0 = ctx_r0.defaultOption == null ? null : ctx_r0.defaultOption.Key) !== null && tmp_1_0 !== undefined ? tmp_1_0 : "default")("innerHTML", (tmp_2_0 = ctx_r0.defaultOption == null ? null : ctx_r0.defaultOption.value) !== null && tmp_2_0 !== undefined ? tmp_2_0 : ctx_r0.defaultOption, i0.ɵɵsanitizeHtml);
  }
}
function DropdownFieldComponent_option_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r2 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", option_r2.code || option_r2.Key);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (option_r2.value || option_r2.Description) + " " + (option_r2.code || ""), " ");
  }
}
function DropdownFieldComponent_div_6_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessages == null ? null : ctx_r0.errorMessages.ER26, " ");
  }
}
function DropdownFieldComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵelement(1, "i", 9);
    i0.ɵɵtemplate(2, DropdownFieldComponent_div_6_small_2_Template, 2, 1, "small", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.dropdown == null ? null : ctx_r0.dropdown.errors == null ? null : ctx_r0.dropdown.errors.required);
  }
}
function EmailFieldComponent_upr_tooltip_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "upr-tooltip")(1, "div", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formData.tooltip, " ");
  }
}
function EmailFieldComponent_div_5_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-requiredError");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER26, " ");
  }
}
function EmailFieldComponent_div_5_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-patternError");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER6, " ");
  }
}
function EmailFieldComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵtemplate(4, EmailFieldComponent_div_5_small_4_Template, 2, 4, "small", 10)(5, EmailFieldComponent_div_5_small_5_Template, 2, 4, "small", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-describedby", ctx_r0.id + "-field" + " " + ctx_r0.id + "-requiredError" + " " + ctx_r0.id + "-patternError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.formData.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.email == null ? null : ctx_r0.email.errors == null ? null : ctx_r0.email.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.email == null ? null : ctx_r0.email.errors == null ? null : ctx_r0.email.errors.pattern);
  }
}
const _c8 = (a0, a1, a2, a3) => ({
  primaryLabel: a0,
  supportingText: a1,
  tooltip: a2,
  describedby: a3
});
const _c9 = a0 => ({
  labelIconTitleText: a0
});
const _c10 = (a0, a1, a2, a3, a4, a5) => ({
  formField: a0,
  dropdownControl: a1,
  options: a2,
  placeholder: a3,
  required: a4,
  requiredSRText: a5
});
function GdsAddressFieldComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "gds-input", 3);
    i0.ɵɵlistener("valueChange", function GdsAddressFieldComponent_div_2_Template_gds_input_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChange($event == null ? null : $event.detail));
    })("blurChange", function GdsAddressFieldComponent_div_2_Template_gds_input_blurChange_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlurChange());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("value", ctx_r1.addressControl == null ? null : ctx_r1.addressControl.value)("theme", ctx_r1.theme)("data", ctx_r1.gdsData)("type", ctx_r1.formData == null ? null : ctx_r1.formData.controlType)("errors", ctx_r1.addressControl == null ? null : ctx_r1.addressControl.errors == null ? null : ctx_r1.addressControl.errors.message);
  }
}
function GdsAddressFieldComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "gds-dropdown", 4);
    i0.ɵɵlistener("valueChange", function GdsAddressFieldComponent_div_3_Template_gds_dropdown_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChange($event == null ? null : $event.detail));
    })("blurChange", function GdsAddressFieldComponent_div_3_Template_gds_dropdown_blurChange_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlurChange());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("data", i0.ɵɵpureFunction6(16, _c10, i0.ɵɵpureFunction4(9, _c8, ctx_r1.formData == null ? null : ctx_r1.formData.label, ctx_r1.formData == null ? null : ctx_r1.formData.supportingText, ctx_r1.formData == null ? null : ctx_r1.formData.tooltip, (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-error"), i0.ɵɵpureFunction1(14, _c9, ctx_r1.formData == null ? null : ctx_r1.formData.iconTitleText), ctx_r1.formData == null ? null : ctx_r1.formData.options, ctx_r1.formData == null ? null : ctx_r1.formData.placeholder, ctx_r1.formData == null ? null : ctx_r1.formData.required, ctx_r1.formData == null ? null : ctx_r1.formData.requiredSRText))("value", ctx_r1.addressControl == null ? null : ctx_r1.addressControl.value)("theme", ctx_r1.theme)("errorMessage", ctx_r1.addressControl == null ? null : ctx_r1.addressControl.errors == null ? null : ctx_r1.addressControl.errors.message)("required", ctx_r1.formData == null ? null : ctx_r1.formData.required)("displayedInModal", ctx_r1.displayedInModal)("isNative", ctx_r1.useNativeStateDropdown);
  }
}
const _c11 = (a0, a1, a2, a3, a4, a5, a6, a7) => ({
  primaryLabel: a0,
  maxLength: a1,
  disabled: a2,
  tooltip: a3,
  placeholder: a4,
  required: a5,
  inputmode: a6,
  describedby: a7
});
const _c12 = (a0, a1, a2, a3, a4, a5, a6, a7, a8) => ({
  primaryLabel: a0,
  supportingText: a1,
  tooltip: a2,
  placeholder: a3,
  maxLength: a4,
  required: a5,
  disabled: a6,
  readonly: a7,
  describedby: a8
});
const _c13 = (a0, a1, a2, a3, a4, a5, a6, a7) => ({
  primaryLabel: a0,
  tooltip: a1,
  maxlength: a2,
  inputmode: a3,
  autocomplete: a4,
  readonly: a5,
  describedby: a6,
  required: a7
});
const _c14 = (a0, a1) => ({
  primaryLabel: a0,
  describedby: a1
});
const _c15 = (a0, a1, a2, a3, a4) => ({
  formField: a0,
  options: a1,
  placeholder: a2,
  required: a3,
  requiredSRText: a4
});
function GdsPaymentCardFieldComponent_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "gds-credit-card-icon-row", 7)(2, "gds-spacer", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("selectedCreditCard", ctx_r1.cardType);
  }
}
function GdsPaymentCardFieldComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, GdsPaymentCardFieldComponent_div_2_div_1_Template, 3, 1, "div", 4);
    i0.ɵɵelementStart(2, "gds-input", 5);
    i0.ɵɵlistener("valueChange", function GdsPaymentCardFieldComponent_div_2_Template_gds_input_valueChange_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChange($event == null ? null : $event.detail));
    })("blurChange", function GdsPaymentCardFieldComponent_div_2_Template_gds_input_blurChange_2_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlurChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "gds-spacer", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.formData == null ? null : ctx_r1.formData.key) === "creditCardTextbox");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("type", ctx_r1.formData == null ? null : ctx_r1.formData.controlType)("data", i0.ɵɵpureFunction8(10, _c13, ctx_r1.formData == null ? null : ctx_r1.formData.label, ctx_r1.formData == null ? null : ctx_r1.formData.tooltip, ctx_r1.cvvMaxLength, (ctx_r1.formData == null ? null : ctx_r1.formData.inputmode) || "text", (ctx_r1.formData == null ? null : ctx_r1.formData.autocomplete) || "off", ctx_r1.formData == null ? null : ctx_r1.formData.readOnly, (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-error", ctx_r1.formData == null ? null : ctx_r1.formData.required))("value", ctx_r1.paymentCardControl == null ? null : ctx_r1.paymentCardControl.value)("theme", ctx_r1.theme)("errors", ctx_r1.paymentCardControl == null ? null : ctx_r1.paymentCardControl.errors == null ? null : ctx_r1.paymentCardControl.errors.message)("hideSpinner", true)("min", 0);
  }
}
function GdsPaymentCardFieldComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "gds-dropdown", 9);
    i0.ɵɵlistener("valueChange", function GdsPaymentCardFieldComponent_div_3_Template_gds_dropdown_valueChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onValueChange($event == null ? null : $event.detail));
    })("blurChange", function GdsPaymentCardFieldComponent_div_3_Template_gds_dropdown_blurChange_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onBlurChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "gds-spacer", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("isNative", true)("data", i0.ɵɵpureFunction5(9, _c15, i0.ɵɵpureFunction2(6, _c14, ctx_r1.formData.label, ctx_r1.formData.key + "-error"), ctx_r1.formData == null ? null : ctx_r1.formData.options, ctx_r1.formData == null ? null : ctx_r1.formData.placeholder, ctx_r1.formData == null ? null : ctx_r1.formData.required, ctx_r1.formData == null ? null : ctx_r1.formData.requiredSRText))("value", ctx_r1.paymentCardControl == null ? null : ctx_r1.paymentCardControl.value)("theme", ctx_r1.theme)("errorMessage", ctx_r1.paymentCardControl == null ? null : ctx_r1.paymentCardControl.errors == null ? null : ctx_r1.paymentCardControl.errors.message)("displayedInModal", ctx_r1.displayedInModal);
  }
}
const _c16 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) => ({
  primaryLabel: a0,
  supportingText: a1,
  secondaryLabel: a2,
  tooltip: a3,
  placeholder: a4,
  pattern: a5,
  required: a6,
  disabled: a7,
  readonly: a8,
  ariaText: a9,
  describedby: a10
});
function NameFieldComponent_div_4_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-requiredError");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER26, " ");
  }
}
function NameFieldComponent_div_4_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-maxLengthError");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER26, " ");
  }
}
function NameFieldComponent_div_4_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-patternError");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER1, " ");
  }
}
function NameFieldComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "span", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 6);
    i0.ɵɵtemplate(4, NameFieldComponent_div_4_small_4_Template, 2, 4, "small", 7)(5, NameFieldComponent_div_4_small_5_Template, 2, 4, "small", 7)(6, NameFieldComponent_div_4_small_6_Template, 2, 4, "small", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-describedby", ctx_r0.id + "-field" + " " + ctx_r0.id + "-requiredError" + " " + ctx_r0.id + "-maxLengthError" + " " + ctx_r0.id + "-patternError");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.formData.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.name == null ? null : ctx_r0.name.errors == null ? null : ctx_r0.name.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.name == null ? null : ctx_r0.name.errors == null ? null : ctx_r0.name.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.name == null ? null : ctx_r0.name.errors == null ? null : ctx_r0.name.errors.pattern);
  }
}
const _c17 = ["*"];
const _c18 = a0 => ({
  "password-with-lock": a0
});
const _c19 = a0 => ({
  "background-color": a0
});
const _c20 = a0 => ({
  color: a0
});
const _c21 = (a0, a1, a2) => ({
  pointer: a0,
  "icon-lock": a1,
  "icon-unlock": a2
});
function PasswordFieldComponent_div_2_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PasswordFieldComponent_div_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PasswordFieldComponent_div_2_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const iconTpl_r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
  }
}
function PasswordFieldComponent_div_2_div_4_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-requiredError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_2_div_4_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "patternError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER9, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_2_div_4_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-capsError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.CONST_PASSWORD_CAP, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_2_div_4_small_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-spaceError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER113, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "span", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 17);
    i0.ɵɵtemplate(4, PasswordFieldComponent_div_2_div_4_small_4_Template, 1, 4, "small", 18)(5, PasswordFieldComponent_div_2_div_4_small_5_Template, 1, 4, "small", 18)(6, PasswordFieldComponent_div_2_div_4_small_6_Template, 2, 2, "small", 12)(7, PasswordFieldComponent_div_2_div_4_small_7_Template, 1, 2, "small", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-describedby", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-field" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-requiredError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-patternError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-capsError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-spaceError" + " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.requiredLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.password == null ? null : ctx_r1.password.errors == null ? null : ctx_r1.password.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.password == null ? null : ctx_r1.password.errors == null ? null : ctx_r1.password.errors.pattern);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCaps);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSpaceExists);
  }
}
function PasswordFieldComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "label", 10);
    i0.ɵɵelementStart(2, "input", 11);
    i0.ɵɵlistener("keypress", function PasswordFieldComponent_div_2_Template_input_keypress_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeyPress($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PasswordFieldComponent_div_2_ng_container_3_Template, 2, 1, "ng-container", 12)(4, PasswordFieldComponent_div_2_div_4_Template, 8, 7, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.formData == null ? null : ctx_r1.formData.key)("innerHtml", ctx_r1.requiredLabel, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("formControlName", ctx_r1.formData == null ? null : ctx_r1.formData.key)("id", ctx_r1.formData == null ? null : ctx_r1.formData.key)("type", ctx_r1.passwordToggle && ctx_r1.showPassword ? "text" : "password")("ngClass", i0.ɵɵpureFunction1(10, _c18, ctx_r1.passwordToggle));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.passwordToggle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.password.invalid || ctx_r1.isSpaceExists) && ctx_r1.password.touched);
  }
}
function PasswordFieldComponent_div_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PasswordFieldComponent_div_3_div_4_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-requiredError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_3_div_4_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-patternError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER9, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_3_div_4_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-repeatedCharsError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER51, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_3_div_4_small_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-capsError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.CONST_PASSWORD_CAP, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_3_div_4_small_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-spaceError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER113, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_3_div_4_small_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-notOnlyUpperError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors["upr.com.errors.form.password.uppercase"], i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_3_div_4_small_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-sameAsEmailError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER60, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_3_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "span", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 17);
    i0.ɵɵtemplate(4, PasswordFieldComponent_div_3_div_4_small_4_Template, 1, 4, "small", 18)(5, PasswordFieldComponent_div_3_div_4_small_5_Template, 1, 4, "small", 18)(6, PasswordFieldComponent_div_3_div_4_small_6_Template, 1, 4, "small", 18)(7, PasswordFieldComponent_div_3_div_4_small_7_Template, 2, 2, "small", 12)(8, PasswordFieldComponent_div_3_div_4_small_8_Template, 1, 2, "small", 18)(9, PasswordFieldComponent_div_3_div_4_small_9_Template, 1, 2, "small", 18)(10, PasswordFieldComponent_div_3_div_4_small_10_Template, 1, 2, "small", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-describedby", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-field" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-requiredError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-patternError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-repeatedCharsError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-capsError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-spaceError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-notOnlyUpperError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-sameAsEmailError" + " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.requiredLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.password == null ? null : ctx_r1.password.errors == null ? null : ctx_r1.password.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.password == null ? null : ctx_r1.password.errors == null ? null : ctx_r1.password.errors.pattern) && !ctx_r1.repeatedChars);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.repeatedChars);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCaps);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSpaceExists);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showNotOnlyUpper);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sameAsEmail);
  }
}
function PasswordFieldComponent_div_3_ng_template_5_li_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 27);
  }
  if (rf & 2) {
    const i_r5 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c19, ctx_r1.strengthIndex.idx > i_r5 ? ctx_r1.Color : ctx_r1.DefaultColor));
  }
}
function PasswordFieldComponent_div_3_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "ul", 25);
    i0.ɵɵtemplate(2, PasswordFieldComponent_div_3_ng_template_5_li_2_Template, 1, 3, "li", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.flagColors);
  }
}
function PasswordFieldComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "label", 10);
    i0.ɵɵelementStart(2, "input", 22);
    i0.ɵɵlistener("ngModelChange", function PasswordFieldComponent_div_3_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkValidPassword($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PasswordFieldComponent_div_3_ng_container_3_Template, 1, 0, "ng-container", 14)(4, PasswordFieldComponent_div_3_div_4_Template, 11, 10, "div", 13)(5, PasswordFieldComponent_div_3_ng_template_5_Template, 3, 1, "ng-template", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const defaultIconTpl_r6 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.formData == null ? null : ctx_r1.formData.key)("innerHtml", ctx_r1.requiredLabel, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.formData == null ? null : ctx_r1.formData.key)("id", ctx_r1.formData == null ? null : ctx_r1.formData.key)("type", ctx_r1.passwordToggle && ctx_r1.showPassword ? "text" : "password");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultIconTpl_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.password.invalid || ctx_r1.isSpaceExists || ctx_r1.sameAsEmail) && ctx_r1.password.touched);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isFirst && ctx_r1.inputVal !== "");
  }
}
function PasswordFieldComponent_div_4_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PasswordFieldComponent_div_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PasswordFieldComponent_div_4_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const iconTpl_r3 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
  }
}
function PasswordFieldComponent_div_4_div_4_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-requiredError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_4_div_4_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-patternError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER9, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_4_div_4_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-spaceError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER113, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_4_div_4_small_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 19);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.label, "-error");
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-repeatedCharsError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER51, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_4_div_4_small_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵelement(1, "span", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-capsError")("innerHtml", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.CONST_PASSWORD_CAP, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_div_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "span", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 17);
    i0.ɵɵtemplate(4, PasswordFieldComponent_div_4_div_4_small_4_Template, 1, 4, "small", 18)(5, PasswordFieldComponent_div_4_div_4_small_5_Template, 1, 4, "small", 18)(6, PasswordFieldComponent_div_4_div_4_small_6_Template, 1, 4, "small", 18)(7, PasswordFieldComponent_div_4_div_4_small_7_Template, 1, 4, "small", 18)(8, PasswordFieldComponent_div_4_div_4_small_8_Template, 2, 2, "small", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-describedby", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-field" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-requiredError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-patternError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-repeatedCharsError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-capsError" + " " + (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-spaceError" + " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", (ctx_r1.formData == null ? null : ctx_r1.formData.key) + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.requiredLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.password == null ? null : ctx_r1.password.errors == null ? null : ctx_r1.password.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.password == null ? null : ctx_r1.password.errors == null ? null : ctx_r1.password.errors.pattern) && !ctx_r1.repeatedChars);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isSpaceExists);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.repeatedChars);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCaps);
  }
}
function PasswordFieldComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "label", 10);
    i0.ɵɵelementStart(2, "input", 28);
    i0.ɵɵlistener("ngModelChange", function PasswordFieldComponent_div_4_Template_input_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PasswordFieldComponent_div_4_ng_container_3_Template, 2, 1, "ng-container", 12)(4, PasswordFieldComponent_div_4_div_4_Template, 9, 8, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.formData == null ? null : ctx_r1.formData.key)("innerHtml", ctx_r1.requiredLabel, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("data-aui", ctx_r1.formData == null ? null : ctx_r1.formData.label);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData == null ? null : ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("formControlName", ctx_r1.formData == null ? null : ctx_r1.formData.key)("id", ctx_r1.formData == null ? null : ctx_r1.formData.key)("type", ctx_r1.passwordToggle && ctx_r1.showPassword ? "text" : "password")("ngClass", i0.ɵɵpureFunction1(11, _c18, ctx_r1.passwordToggle));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.passwordToggle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.password.invalid || ctx_r1.isSpaceExists) && ctx_r1.password.touched);
  }
}
function PasswordFieldComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 29);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(2, _c20, ctx_r1.Color))("innerHTML", ctx_r1.pwdStrength, i0.ɵɵsanitizeHtml);
  }
}
function PasswordFieldComponent_ng_template_7_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PasswordFieldComponent_ng_template_7_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, PasswordFieldComponent_ng_template_7_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const defaultIconTpl_r6 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultIconTpl_r6);
  }
}
function PasswordFieldComponent_ng_template_7_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function PasswordFieldComponent_ng_template_7_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PasswordFieldComponent_ng_template_7_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 14);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const customIconContentTpl_r8 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngTemplateOutlet", customIconContentTpl_r8);
  }
}
function PasswordFieldComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PasswordFieldComponent_ng_template_7_ng_container_0_Template, 2, 1, "ng-container", 30)(1, PasswordFieldComponent_ng_template_7_ng_template_1_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const customIconTpl_r9 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.customIcon)("ngIfElse", customIconTpl_r9);
  }
}
function PasswordFieldComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 31);
    i0.ɵɵlistener("click", function PasswordFieldComponent_ng_template_9_Template_i_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.togglePassword());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(1, _c21, ctx_r1.passwordToggle, !ctx_r1.showPassword, ctx_r1.showPassword));
  }
}
function PasswordFieldComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 32);
    i0.ɵɵlistener("click", function PasswordFieldComponent_ng_template_11_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.togglePassword());
    });
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function PaymentCardFieldComponent_div_2_upr_tooltip_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "upr-tooltip")(1, "div", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData == null ? null : ctx_r1.formData.tooltip, " ");
  }
}
function PaymentCardFieldComponent_div_2_div_5_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, " ");
  }
}
function PaymentCardFieldComponent_div_2_div_5_small_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.isCardDuplicateError, " ");
  }
}
function PaymentCardFieldComponent_div_2_div_5_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData.key === "creditCardTextbox" ? ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER34 : ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER37, " ");
  }
}
function PaymentCardFieldComponent_div_2_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵtemplate(2, PaymentCardFieldComponent_div_2_div_5_small_2_Template, 2, 3, "small", 3)(3, PaymentCardFieldComponent_div_2_div_5_small_3_Template, 2, 3, "small", 3)(4, PaymentCardFieldComponent_div_2_div_5_small_4_Template, 2, 3, "small", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.errors == null ? null : ctx_r1.paymentCard.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isCardDuplicate && ctx_r1.formData.key === "creditCardTextbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.errors == null ? null : ctx_r1.paymentCard.errors.maxlength) || (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.errors == null ? null : ctx_r1.paymentCard.errors.pattern) || (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.touched) && !ctx_r1.cardType && !ctx_r1.imageUrlNo);
  }
}
function PaymentCardFieldComponent_div_2_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "img", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.cardType);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.cardTypeImageUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("data-aui", ctx_r1.cardType);
  }
}
function PaymentCardFieldComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "label", 5);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, PaymentCardFieldComponent_div_2_upr_tooltip_3_Template, 4, 1, "upr-tooltip", 3);
    i0.ɵɵelementStart(4, "input", 6);
    i0.ɵɵlistener("keyup", function PaymentCardFieldComponent_div_2_Template_input_keyup_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onKeyUp($event.target.value));
    })("blur", function PaymentCardFieldComponent_div_2_Template_input_blur_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleBlur(ctx_r1.formData));
    });
    i0.ɵɵtwoWayListener("ngModelChange", function PaymentCardFieldComponent_div_2_Template_input_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.formData.value, $event) || (ctx_r1.formData.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("focus", function PaymentCardFieldComponent_div_2_Template_input_focus_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.handleFocus());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PaymentCardFieldComponent_div_2_div_5_Template, 5, 3, "div", 3)(6, PaymentCardFieldComponent_div_2_div_6_Template, 2, 3, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-aui", ctx_r1.formData.key)("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.formData.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formData == null ? null : ctx_r1.formData.tooltip);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-input");
    i0.ɵɵproperty("formControlName", ctx_r1.formData.key)("id", ctx_r1.id)("placeholder", ctx_r1.formData.placeholder)("type", ctx_r1.formData.controlType)("autocomplete", (ctx_r1.formData == null ? null : ctx_r1.formData.autocomplete) || "off")("maxlength", ctx_r1.cvvMaxLength);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.formData.value);
    i0.ɵɵproperty("placeholder", ctx_r1.formData == null ? null : ctx_r1.formData.placeholder)("ngClass", ctx_r1.formData.key === "creditCardTextbox" && (ctx_r1.isCardDuplicate || (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.touched) && !ctx_r1.cardType && !ctx_r1.imageUrlNo) ? "card-error" : "");
    i0.ɵɵattribute("inputmode", ctx_r1.formData.inputmode || "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.invalid) && (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.touched) || ctx_r1.formData.key === "creditCardTextbox" && (ctx_r1.isCardDuplicate || (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.valid) && (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.touched) && !ctx_r1.cardType && !ctx_r1.imageUrlNo));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.cardType && ctx_r1.imageUrlNo);
  }
}
function PaymentCardFieldComponent_div_3_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData.placeholder, " ");
  }
}
function PaymentCardFieldComponent_div_3_option_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const opt_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", opt_r4.key);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", opt_r4.value, " ");
  }
}
function PaymentCardFieldComponent_div_3_div_8_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, " ");
  }
}
function PaymentCardFieldComponent_div_3_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵtemplate(2, PaymentCardFieldComponent_div_3_div_8_small_2_Template, 2, 3, "small", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.errors == null ? null : ctx_r1.paymentCard.errors.required) && (ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26));
  }
}
function PaymentCardFieldComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "label", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 14);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "select", 15);
    i0.ɵɵtwoWayListener("ngModelChange", function PaymentCardFieldComponent_div_3_Template_select_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedOption, $event) || (ctx_r1.selectedOption = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function PaymentCardFieldComponent_div_3_Template_select_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onChange($event));
    });
    i0.ɵɵtemplate(6, PaymentCardFieldComponent_div_3_option_6_Template, 2, 1, "option", 16)(7, PaymentCardFieldComponent_div_3_option_7_Template, 2, 2, "option", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, PaymentCardFieldComponent_div_3_div_8_Template, 3, 1, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("for", ctx_r1.id)("ngClass", ctx_r1.formData.key);
    i0.ɵɵattribute("data-aui", ctx_r1.formData.key)("aria-label", ctx_r1.formData.key);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.formData == null ? null : ctx_r1.formData.additionalLabel == null ? null : ctx_r1.formData.additionalLabel.label1, " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-aui", ctx_r1.formData.key);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData.label, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id)("name", ctx_r1.formData.key)("formControlName", ctx_r1.formData.key);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedOption);
    i0.ɵɵattribute("data-aui", ctx_r1.formData.key);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.formData.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.formData.options);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.invalid) && ((ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.dirty) || (ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.touched)));
  }
}
function PaymentCardFieldComponent_div_4_div_1_option_6_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, " ");
  }
}
function PaymentCardFieldComponent_div_4_div_1_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PaymentCardFieldComponent_div_4_div_1_option_6_span_2_Template, 2, 3, "span", 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const card_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", card_r6);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", card_r6.value, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", card_r6.isExpired);
  }
}
function PaymentCardFieldComponent_div_4_div_1_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, " ");
  }
}
function PaymentCardFieldComponent_div_4_div_1_div_8_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.formData == null ? null : ctx_r1.formData.errors == null ? null : ctx_r1.formData.errors.ER26, " ");
  }
}
function PaymentCardFieldComponent_div_4_div_1_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "i", 10);
    i0.ɵɵtemplate(2, PaymentCardFieldComponent_div_4_div_1_div_8_small_2_Template, 2, 3, "small", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.paymentCard == null ? null : ctx_r1.paymentCard.errors == null ? null : ctx_r1.paymentCard.errors.required);
  }
}
function PaymentCardFieldComponent_div_4_div_1_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "New Credit Card Form");
    i0.ɵɵelementEnd();
  }
}
function PaymentCardFieldComponent_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4)(1, "label", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "select", 22);
    i0.ɵɵtwoWayListener("ngModelChange", function PaymentCardFieldComponent_div_4_div_1_Template_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.card, $event) || (ctx_r1.card = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function PaymentCardFieldComponent_div_4_div_1_Template_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onCardChange($event));
    });
    i0.ɵɵelementStart(4, "option", 23);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PaymentCardFieldComponent_div_4_div_1_option_6_Template, 3, 3, "option", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, PaymentCardFieldComponent_div_4_div_1_span_7_Template, 2, 3, "span", 25)(8, PaymentCardFieldComponent_div_4_div_1_div_8_Template, 3, 1, "div", 18)(9, PaymentCardFieldComponent_div_4_div_1_div_9_Template, 2, 0, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-aui", ctx_r1.formData.key)("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.formData.label);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r1.formData.key, "-Input");
    i0.ɵɵproperty("id", ctx_r1.id)("name", ctx_r1.formData.key)("formControlName", ctx_r1.formData.key);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.card);
    i0.ɵɵproperty("disabled", ctx_r1.creditCards.length === 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngValue", null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.cardLabel.label1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.creditCards);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isCardExpired && !ctx_r1.showNewCardForm);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showValidationMsg && ctx_r1.paymentCard.invalid && (ctx_r1.paymentCard.dirty || ctx_r1.paymentCard.touched));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showNewCardForm);
  }
}
function PaymentCardFieldComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PaymentCardFieldComponent_div_4_div_1_Template, 10, 16, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "creditCardDropdown");
  }
}
function PhoneFieldComponent_small_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.formData.optionalLabel);
  }
}
function PhoneFieldComponent_div_9_small_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-requiredError")("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER26, i0.ɵɵsanitizeHtml);
  }
}
function PhoneFieldComponent_div_9_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-maxLengthErrorNotUSA")("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER33, i0.ɵɵsanitizeHtml);
  }
}
function PhoneFieldComponent_div_9_small_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-maxLengthErrorUSA")("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER41, i0.ɵɵsanitizeHtml);
  }
}
function PhoneFieldComponent_div_9_small_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-minLengthErrorNotUSA")("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER134, i0.ɵɵsanitizeHtml);
  }
}
function PhoneFieldComponent_div_9_small_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-patternErrorUSA")("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER41, i0.ɵɵsanitizeHtml);
  }
}
function PhoneFieldComponent_div_9_small_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-patternErrorNotUSA")("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER33, i0.ɵɵsanitizeHtml);
  }
}
function PhoneFieldComponent_div_9_small_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "small", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.key, "-error");
    i0.ɵɵproperty("id", ctx_r0.id + "-otherError")("innerHtml", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER5, i0.ɵɵsanitizeHtml);
  }
}
function PhoneFieldComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "span", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "i", 9);
    i0.ɵɵtemplate(4, PhoneFieldComponent_div_9_small_4_Template, 1, 4, "small", 10)(5, PhoneFieldComponent_div_9_small_5_Template, 1, 4, "small", 10)(6, PhoneFieldComponent_div_9_small_6_Template, 1, 4, "small", 10)(7, PhoneFieldComponent_div_9_small_7_Template, 1, 4, "small", 10)(8, PhoneFieldComponent_div_9_small_8_Template, 1, 4, "small", 10)(9, PhoneFieldComponent_div_9_small_9_Template, 1, 4, "small", 10)(10, PhoneFieldComponent_div_9_small_10_Template, 1, 4, "small", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-describedby", ctx_r0.id + "-field" + " " + ctx_r0.id + "-requiredError" + " " + ctx_r0.id + "-maxLengthErrorNotUSA" + " " + ctx_r0.id + "-maxLengthErrorUSA" + " " + ctx_r0.id + "-minLengthErrorNotUSA" + " " + ctx_r0.id + "-patternErrorUSA" + " " + ctx_r0.id + "-patternErrorNotUSA" + " " + ctx_r0.id + "-otherError" + " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r0.id + "-field");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.formData == null ? null : ctx_r0.formData.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.maxlength) && (ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER33) && !(ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.alphaNumeric) && !ctx_r0.isCountryUSA);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.maxlength) && (ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER41) && !(ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.alphaNumeric) && ctx_r0.isCountryUSA);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.minlength) && (ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER134) && !(ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.alphaNumeric) && !ctx_r0.isCountryUSA);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.pattern) && (ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER41) && !(ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.alphaNumeric) && ctx_r0.isCountryUSA);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.pattern) && (ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER33) && !(ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.alphaNumeric) && !ctx_r0.isCountryUSA);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.phone == null ? null : ctx_r0.phone.errors == null ? null : ctx_r0.phone.errors.alphaNumeric) && (ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER5));
  }
}
const _c22 = (a0, a1) => ({
  selected: a0,
  "radio-disabled": a1
});
const _c23 = a0 => ({
  backgroundColor: a0
});
function SuffixFieldComponent_small_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.formData.optionalLabel);
  }
}
function SuffixFieldComponent_div_5_small_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER26, " ");
  }
}
function SuffixFieldComponent_div_5_small_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-aui", "", ctx_r0.formData.label, "-error");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.formData == null ? null : ctx_r0.formData.errors == null ? null : ctx_r0.formData.errors.ER1, " ");
  }
}
function SuffixFieldComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "i", 6);
    i0.ɵɵtemplate(2, SuffixFieldComponent_div_5_small_2_Template, 2, 3, "small", 2)(3, SuffixFieldComponent_div_5_small_3_Template, 2, 3, "small", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.suffix.errors.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.suffix == null ? null : ctx_r0.suffix.errors == null ? null : ctx_r0.suffix.errors.pattern);
  }
}
const _c24 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10) => ({
  primaryLabel: a0,
  supportingText: a1,
  tooltip: a2,
  placeholder: a3,
  required: a4,
  disabled: a5,
  readonly: a6,
  pattern: a7,
  inputmode: a8,
  ariaText: a9,
  describedby: a10
});
const EmailPasswordPattern = {
  // tslint:disable-next-line:max-line-length
  EMAIL: /^(([^<>()[\]\\.,;:\s@]+(\.[^<()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,4}))$/,
  PASSWORD_REGEX: /^(?!^(.)\1*$)(.{8,})$/,
  PASSWORD_REPEATEDCHAR_REGEX: /^(.)\1+$/,
  PASSWORD_LENGTH_REGEX: /^.{8,}$/
};
const NamePattern = {
  NAME: /^[a-z](?![a-z\.\`\'\-\s]*[\.\`\'\-]{2})(?![a-z\.\`\'\-\s]*[\s]{2})[a-z\.\`\'\-\s]*$/i,
  NAME_SUFFIX: /^[a-z](?![a-z\.\`\'\-\s]*[\.\`\'\-]{2})(?![a-z\.\`\'\-\s]*[\s]{2})[a-z\.\`\'\-\s]*$/i
};
const NumberCharPattern = {
  NUMBER: /^[0-9]*$/,
  // Only Number
  BEGIN_WITH_NUMBER: /[^0-9]/,
  NON_NUMBER: /[^0-9]/g,
  LETTER: /^[a-z].*[A-Z]|[A-Z].*[a-z]*$/,
  // Only combination of small & CAPS (aA)
  SPECIAL_CHAR: /^[-!$@#%^&*()_+|~=`{}\[\]:";'<>?,.\/]*$/,
  // only special characters
  WITH_NUMBER: /[0-9]/,
  // number with char & special characters
  WITH_LETTER: /[a-z].*[A-Z]|[A-Z].*[a-z]/,
  // combination of small & CAPS (aA) with number & special char
  WITH_SPECIAL_CHAR: /[-!$@#%^&*()_+|~=`{}\[\]:";'<>?,.\/]/,
  // special characters with char and numbers
  LETTER_NUMBER: /^[a-zA-Z0-9\s,'\-.]*$/,
  // Small & CAPS (aA) with number and spl. char except ! # $ % & ' * + - / = ? ^ _ ` { | } ~
  WITH_LOWER_LETTER: /[a-z]/,
  // combination of small letter(a) with CAPS, number & special char
  WITH_UPPER_LETTER: /[A-Z]/,
  // combination of CAPS letter(A) with small letter, number & special char
  NON_DIGIT: /\D/g,
  START_WITH_PLUS: /^\+/,
  WITH_ONLY_UPPER: /^[A-Z]+$/
};
const MiscPattern = {
  ENDS_WITH_SPACE: /\s+$/,
  BRACKET_DOUBLEQUOTES: /[\[\]'"]/g,
  DATE: /^(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]\d{4}$/,
  ANNUALPASS_DOB: /^(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])$/
};
const ZipCodePattern = {
  ZIP: /^(?:\d{5,9}|\d{5}(?:[-]\d{4})?)$/,
  NON_US_ZIP: /^([a-zA-Z0-9\s-]){0,12}$/
};
const PhonePattern = {
  PHONE: /^(\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4}))+$/,
  NON_US_PHONE: /^[0-9-]+/,
  PHONE_ANY: /^[- +()]*[0-9][- +()0-9]*$/
};
const formFieldRanges = {
  DEFAULT_COUNTRY: 'US',
  MIN: {
    PASSWORD: 8,
    USA_PHONE: 10,
    USA_ZIP: 5,
    NON_USA_PHONE: 7
  },
  MAX: {
    SUFFIX: 25,
    FIRST_NAME: 25,
    MIDDLE_NAME: 25,
    LAST_NAME: 25,
    PASSWORD: 99,
    USA_PHONE: 10,
    PHONE: 15,
    USA_ZIP: 9,
    NON_USA_ZIP: 12,
    CITY: 50,
    EMAIL: 255,
    ZIP_ENTRY: 20,
    CVV: 4,
    PAYMENT_CARD: 20,
    DATE: 11,
    MM_DD: 5,
    ADDRESS_LINE1: 50
  },
  PASSWORDS: {
    PASSWORD_LENGTH_INDEX: 10,
    PASSWORD_FORCE_FACTOR: 10,
    PASSWORD_FLAG_COLORS: ['#F00', '#F90', '#FF0', '#9F0', '#0B0'],
    PASSWORD_FLAG_STRENGTH: ['Very Weak', 'Weak', 'Medium', 'Moderate', 'Strong'],
    DEFAULT_BACKGROUND: '#DDD'
  },
  PHONE: {
    USA_COUNTRY_CODE: 'US',
    ANY_COUNTRY_CODE: 'any'
  }
};
class AddressFieldService {
  constructor(defaultValues) {
    this.defaultValues = defaultValues;
    this.addresses = [];
    this.countries = [];
    this.usStates = [];
  }
  EmptyAddress() {
    return {
      firstName: '',
      lastName: '',
      country: this.defaultValues.DEFAULT_COUNTRY,
      addressLine1: '',
      addressLine2: '',
      addressLine: '',
      postalCode: '',
      city: '',
      state: '',
      phoneNumber: '',
      addressId: '',
      primary: this.defaultValues.NON_PRIMARY_SHIPPING_ADDRESS_INDICATOR
    };
  }
  normalizeAddresses(addresses) {
    const normalizedAddresses = [];
    // Make sure we aren't sending undefined or null for optional values
    each(addresses, address => {
      const normalizedAddress = address;
      if (!address) {
        return;
      }
      each(Object.keys(address), key => {
        if (address[key]) {
          return;
        }
        normalizedAddress[key] = '';
      });
      normalizedAddresses.push(normalizedAddress);
    });
    return normalizedAddresses;
  }
  getPrimaryAddress() {
    let primaryAddress = find(this.addresses, address => {
      return address.primary === this.defaultValues.PRIMARY_SHIPPING_ADDRESS_INDICATOR;
    });
    primaryAddress = primaryAddress || this.EmptyAddress();
    return primaryAddress;
  }
  getCountryCodeByName(name) {
    const matchingCountry = find(this.countries, country => {
      return country.name === name;
    });
    if (matchingCountry) {
      return matchingCountry.id;
    }
    return name;
  }
  prepareAddresses(addressArray) {
    const addresses = [];
    each(addressArray, address => {
      const addressObj = address;
      if (address.addressLine2) {
        addressObj.addressLine = addressObj.addressLine1 + ' ' + addressObj.addressLine2;
      } else {
        addressObj.addressLine = addressObj.addressLine1;
      }
      if (address.countryCode) {
        addressObj.country = address.countryCode;
      } else {
        addressObj.country = this.getCountryCodeByName(address.country);
      }
      if (typeof address.primary === 'string') {
        addressObj.primary = address.primary.toLowerCase() === this.defaultValues.PRIMARY_SHIPPING_ADDRESS_INDICATOR.toLowerCase() ? this.defaultValues.PRIMARY_SHIPPING_ADDRESS_INDICATOR : this.defaultValues.NON_PRIMARY_SHIPPING_ADDRESS_INDICATOR;
      } else {
        addressObj.primary = this.defaultValues.NON_PRIMARY_SHIPPING_ADDRESS_INDICATOR;
      }
      // addressObj.sourceId = this.commonUtilityService.getSourceIdValue('WebEditAddress');
      if (addressObj.addressType === this.defaultValues.GENERIC_ADDRESS) {
        addresses.push(addressObj);
      }
    });
    if (addresses.length === 1) {
      addresses[0].primary = this.defaultValues.PRIMARY_SHIPPING_ADDRESS_INDICATOR;
    }
    this.addresses = this.normalizeAddresses(addresses);
  }
  getAddressById(addressId) {
    let matching = find(this.addresses, address => {
      return addressId === address.addressId;
    });
    matching = matching || this.getPrimaryAddress();
    return matching;
  }
  static {
    this.ɵfac = function AddressFieldService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressFieldService)(i0.ɵɵinject('DefaultValues'));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddressFieldService,
      factory: AddressFieldService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressFieldService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultValues']
    }]
  }], null);
})();
let _nextAddressFieldsUniqueId = 0;
class AddressFieldComponent {
  get fieldValue() {
    if (this.formDataValue) {
      return this.formDataValue;
    } else {
      return this.formData.controlType === 'dropdown' && this.selectedOption || this.formData.value;
    }
  }
  set fieldValue(value) {
    if (this.formDataValue !== undefined) {
      this.formDataValue = value;
    } else if (this.formData.controlType === 'dropdown') {
      this.selectedOption = value;
    } else {
      this.formData.value = value;
    }
  }
  constructor(formBuilder, utilsService, addressService, defaultValues, sessionStorage) {
    this.formBuilder = formBuilder;
    this.utilsService = utilsService;
    this.addressService = addressService;
    this.defaultValues = defaultValues;
    this.sessionStorage = sessionStorage;
    this.formReady = new EventEmitter();
    this.countryChange = new EventEmitter();
    this.stateChange = new EventEmitter();
    this.billAddressFormObj = {};
    this.shipAddressFormObj = {};
    this.countries = [];
    this.states = [];
    this.transformedInput = '';
    this._addressFieldsUniqueId = _nextAddressFieldsUniqueId++;
    this.debounceKeyUp = debounce(() => this.updateZipPattern(''), 500);
  }
  ngOnInit() {
    this.addressGroup = this.initAddress();
    this.formReady.emit(this.getControl(this.formData.key));
    switch (this.formData.key) {
      case 'country':
        if (!this.countries || this.countries.length <= 0) {
          this.sessionStorage.setItem('countryList', '');
          this.sessionStorage.setItem('countriesRequested', 'false');
          this.loadCountryList();
          break;
        } else {
          this.sessionStorage.setItem('countriesRequested', 'false');
          this.setFormOptions();
          break;
        }
      case 'state':
        if (!this.states || this.states.length <= 0) {
          this.sessionStorage.setItem('stateList', '');
          this.sessionStorage.setItem('statesRequested', 'false');
          this.loadUsStateList();
          break;
        } else {
          this.sessionStorage.setItem('statesRequested', 'false');
          this.setFormOptions();
          break;
        }
      default:
        this.setFormOptions();
    }
    this.getControl('country').valueChanges.subscribe(value => {
      this.countryChange.emit(value);
      this.updateZipPattern(value);
    });
    this.getControl('state').valueChanges.subscribe(value => {
      this.stateChange.emit(value);
    });
    if (this.formData.key === 'country') {
      this.formDataValue = this.country;
    }
    if (this.formData.key === 'state') {
      this.formDataValue = this.state;
    }
  }
  ngOnChanges() {
    if (this.formDataValue && this.country && this.addressGroup) {
      this.updateZipPattern(this.formDataValue);
    } else {
      this.updateZipPattern('');
    }
  }
  ngOnDestroy() {
    this._addressFieldsUniqueId = _nextAddressFieldsUniqueId = 0;
  }
  loadCountryList() {
    const localCountryList = this.sessionStorage.getItem('countryList');
    const countriesRequested = this.sessionStorage.getItem('countriesRequested');
    if (countriesRequested && localCountryList && localCountryList.length > 0) {
      this.countries = JSON.parse(localCountryList);
      this.setFormOptions();
      return;
    }
    if (countriesRequested === 'true') {
      return;
    }
    this.sessionStorage.setItem('countriesRequested', 'true');
    this.utilsService.loadCountryList().then(countries => {
      if (!this.billAddressFormObj) {
        this.billAddressFormObj = this.addressService.EmptyAddress();
      }
      if (!this.shipAddressFormObj) {
        this.shipAddressFormObj = this.addressService.EmptyAddress();
      }
      this.billAddressFormObj.country = this.defaultCountry;
      this.shipAddressFormObj.country = this.defaultCountry;
      this.countries = countries;
      this.setFormOptions();
    });
  }
  loadUsStateList() {
    const localStateList = this.sessionStorage.getItem('stateList');
    const statesRequested = this.sessionStorage.getItem('statesRequested');
    if (statesRequested && localStateList && localStateList.length > 0) {
      this.states = JSON.parse(localStateList);
      this.setFormOptions();
      return;
    }
    if (statesRequested === 'true') {
      return;
    }
    this.sessionStorage.setItem('statesRequested', 'true');
    this.utilsService.loadUsStateList().then(states => {
      this.states = states;
      this.sessionStorage.setItem('countryList', JSON.stringify(this.countries));
      this.sessionStorage.setItem('stateList', JSON.stringify(this.states));
      this.setFormOptions();
    });
  }
  setFormOptions() {
    if (this.formData.key === 'country' && this.countries) {
      this.countries.forEach(item => {
        item.key = item.id;
        item.value = item.name;
      });
      this.formData.options = this.countries;
    }
    if (this.formData.key === 'state' && this.states) {
      this.states.forEach(item => {
        item.key = item.id;
        item.value = item.name;
      });
      this.formData.options = this.states;
    }
    this.selectDefaultOption();
  }
  selectDefaultOption() {
    this.selectedOption = this.formData.key === 'country' ? this.defaultValues.DEFAULT_COUNTRY : '';
  }
  updateZipPattern(value) {
    if (this.formData.key === 'city' || this.formData.key === 'state' || this.formData.key === 'zipPostalCode') {
      let validatorObject = [];
      let validatorWOObject = [];
      if (this.formData.key === 'city') {
        validatorObject = [Validators.required, Validators.maxLength(this.cityMaxLength), Validators.pattern(this.formData.pattern1)];
        validatorWOObject = [Validators.maxLength(this.cityMaxLength), Validators.pattern(this.formData.pattern1)];
      }
      if (this.formData.key === 'state') {
        validatorObject = [Validators.required, Validators.pattern(this.formData.pattern1)];
        validatorWOObject = [Validators.pattern(this.formData.pattern1)];
      }
      if (this.formData.key === 'zipPostalCode') {
        this.transformedInput = value ? value.replace(NumberCharPattern.NON_DIGIT, '') : '';
        validatorObject = [Validators.required, Validators.pattern(ZipCodePattern.ZIP)];
        validatorWOObject = [Validators.pattern(ZipCodePattern.NON_US_ZIP)];
      }
      if (this.addressGroup) {
        const control = this.addressGroup.get(this.formData.key);
        if (this.country && this.country.toLowerCase() === 'us') {
          control.setValidators(validatorObject);
          control.setErrors(null);
          this.formData.optionalLabel = '';
          this.formData.required = true;
          if (this.formData.key === 'zipPostalCode') {
            this.formatTransformedInput();
          }
        } else {
          if (this.isAddressComponent || !this.isZipCodeMandiory && this.formData.key === 'zipPostalCode') {
            control.setValidators(validatorWOObject);
            control.setErrors(null);
            this.formData.optionalLabel = this.optionalLabel;
            this.formData.required = false;
          } else if (this.isZipCodeMandiory && this.formData.key === 'zipPostalCode') {
            validatorWOObject = [Validators.pattern(ZipCodePattern.NON_US_ZIP), Validators.required];
            this.formData.optionalLabel = '';
            this.formData.required = true;
            control.setValidators(validatorWOObject);
            control.setErrors(null);
          }
        }
        control.updateValueAndValidity();
      }
    }
    // optional fields should not have the * in the label
    const labelRequired = this.formData.required ? ' *' : '';
    this.formData.label = trimEnd(this.formData.label, '*').trim();
    this.formData.label = `${this.formData.label}${labelRequired}`;
  }
  formatTransformedInput() {
    if (!this.transformedInput) {
      return '';
    }
    this.transformedInput = this.transformedInput.toString().trim().replace(NumberCharPattern.START_WITH_PLUS, '');
    this.transformedInput = this.transformedInput.replace('-', '');
    if (this.transformedInput.match(NumberCharPattern.BEGIN_WITH_NUMBER)) {
      return;
    }
    if (this.transformedInput.length === 9) {
      this.transformedInput = this.transformedInput.slice(0, 5) + '-' + this.transformedInput.slice(5);
    } else if (this.transformedInput.length === 5) {
      return;
    } else if (this.transformedInput.length > 5 && this.transformedInput.length < 9) {
      this.transformedInput = this.transformedInput.slice(0, 5) + '-' + this.transformedInput.slice(5 - this.transformedInput.length);
    } else {
      return;
    }
    this.formDataValue = this.transformedInput;
  }
  initAddress() {
    this.isReadOnly = this.formData.readOnly || false;
    if (this.formData.key === 'city') {
      this.cityMaxLength = this.formData.maxLength || formFieldRanges.MAX.CITY;
    }
    return this.formBuilder.group({
      country: [{
        value: '',
        disabled: this.isReadOnly
      }, Validators.required],
      addressLine1: [{
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.pattern(this.formData.pattern1)])],
      addressLine2: [{
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.pattern(this.formData.pattern1)])],
      zipPostalCode: [{
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.pattern(this.formData.pattern1)])],
      city: [{
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.maxLength(this.cityMaxLength), Validators.pattern(this.formData.pattern1)])],
      state: [{
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.pattern(this.formData.pattern1)])]
    });
  }
  get id() {
    return this.formData.key + '-' + this._addressFieldsUniqueId;
  }
  get address() {
    switch (this.formData.key) {
      case 'addressLine1':
        return this.getControl('addressLine1');
      case 'addressLine2':
        return this.getControl('addressLine2');
      case 'state':
        return this.getControl('state');
      default:
        return this.getControl('addressLine1');
    }
  }
  get zipcode() {
    return this.getControl('zipPostalCode');
  }
  get city() {
    return this.getControl('city');
  }
  get stateValue() {
    return this.getControl('state');
  }
  getControl(control) {
    return this.addressGroup.get(control);
  }
  onChange(newOption) {
    this.selectedOption = newOption;
  }
  static {
    this.ɵfac = function AddressFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AddressFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.UtilsService), i0.ɵɵdirectiveInject(AddressFieldService), i0.ɵɵdirectiveInject('DefaultValues'), i0.ɵɵdirectiveInject(i4.SessionStorageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddressFieldComponent,
      selectors: [["upr-address-field"]],
      inputs: {
        formData: "formData",
        formDataValue: "formDataValue",
        country: "country",
        state: "state",
        isAddressComponent: "isAddressComponent",
        isZipCodeMandiory: "isZipCodeMandiory",
        optionalLabel: "optionalLabel"
      },
      outputs: {
        formReady: "formReady",
        countryChange: "countryChange",
        stateChange: "stateChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 4,
      consts: [[3, "formGroup"], [1, "relative", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "ngClass"], [4, "ngIf"], [3, "ngModelChange", "formControlName", "required", "ngModel", "name", "maxlength", "id", "type"], ["class", "error", "data-aui", "error-message", "role", "alert", 4, "ngIf"], ["data-aui", "error-message", "role", "alert", 1, "error"], [1, "sr-only", 3, "id"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "id", "innerHtml", 4, "ngIf"], [3, "id", "innerHtml"], [1, "required"], ["required", "", 3, "ngModelChange", "id", "formControlName", "ngModel"], ["disabled", "", "selected", "", "value", "", 4, "ngIf"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["disabled", "", "selected", "", "value", ""], [3, "ngValue"], [3, "id", 4, "ngIf"], [3, "id"]],
      template: function AddressFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, AddressFieldComponent_div_2_Template, 8, 20, "div", 2)(3, AddressFieldComponent_div_3_Template, 7, 11, "div", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.addressGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitch", ctx.formData.controlType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "text");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "dropdown");
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgForOf, i2$1.NgIf, i2$1.NgSwitch, i2$1.NgSwitchCase, i1.NgSelectOption, i1.ɵNgSelectMultipleOption, i1.DefaultValueAccessor, i1.SelectControlValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.MaxLengthValidator, i1.FormGroupDirective, i1.FormControlName],
      styles: [".relative[_ngcontent-%COMP%]{position:relative}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddressFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-address-field',
      standalone: false,
      template: "<div [formGroup]=\"addressGroup\">\r\n\t<div class=\"relative\" [ngSwitch]=\"formData.controlType\">\r\n\t\t<div *ngSwitchCase=\"'text'\">\r\n\t\t\t<label\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}\"\r\n\t\t\t\t[attr.for]=\"id\"\r\n\t\t\t\t[ngClass]=\"{ required: formData?.required }\"\r\n\t\t\t\t>{{ formData.label }}\r\n\t\t\t\t<small *ngIf=\"formData?.optionalLabel\">{{\r\n\t\t\t\t\tformData.optionalLabel\r\n\t\t\t\t}}</small>\r\n\t\t\t</label>\r\n\t\t\t<input\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}-input\"\r\n\t\t\t\t[formControlName]=\"formData.key\"\r\n\t\t\t\t[required]=\"formData?.required\"\r\n\t\t\t\t[(ngModel)]=\"fieldValue\"\r\n\t\t\t\t[name]=\"formData.key\"\r\n\t\t\t\t[maxlength]=\"formData?.maxLength\"\r\n\t\t\t\t[id]=\"id\"\r\n\t\t\t\t[type]=\"formData.controlType\"\r\n\t\t\t\t[attr.inputmode]=\"formData.inputmode || 'text'\"\r\n\t\t\t\t(ngModelChange)=\"updateZipPattern($event)\"\r\n\t\t\t/>\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"address.invalid && address.touched\"\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\tdata-aui=\"error-message\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t[attr.aria-describedby]=\"id + '-field' + ' ' + id + '-requiredError' + ' ' + id + '-maxLengthError' + ' ' + id + '-patternError'\"\r\n\t\t\t>\r\n\t\t\t\t<span class=\"sr-only\" [id]=\"id+'-field'\">{{formData.label}} </span>\r\n\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id + '-requiredError'\"\r\n\t\t\t\t\t*ngIf=\"address?.errors?.required && formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id+'-maxLengthError'\"\r\n\t\t\t\t\t*ngIf=\"address?.errors?.maxlength && formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id+'-patternError'\"\r\n\t\t\t\t\t*ngIf=\"address?.errors?.pattern && formData?.errors?.ER15\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER15\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"zipcode?.invalid && zipcode.touched\"\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\tdata-aui=\"error-message\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t[attr.aria-describedby]=\"id + '-field' + ' ' + id + '-requiredError' + ' ' + id + '-maxLengthError' + ' ' + id + '-patternError'\"\r\n\t\t\t>\r\n\t\t\t\t<span class=\"sr-only\" [id]=\"id+'-field'\">{{formData.label}} </span>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id + '-requiredError'\"\r\n\t\t\t\t\t*ngIf=\"zipcode?.errors?.required && formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id + '-maxLengthError'\"\r\n\t\t\t\t\t*ngIf=\"\r\n\t\t\t\t\t\tzipcode?.errors?.maxLength &&\r\n\t\t\t\t\t\tcountry === 'US' &&\r\n\t\t\t\t\t\tformData?.errors?.ER32\r\n\t\t\t\t\t\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER32\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id + '-patternError'\"\r\n\t\t\t\t\t*ngIf=\"\r\n\t\t\t\t\t\tzipcode?.errors?.pattern &&\r\n\t\t\t\t\t\tcountry !== 'US' &&\r\n\t\t\t\t\t\tformData?.errors?.ER40\r\n\t\t\t\t\t\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER40\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"city?.invalid && (city?.dirty || city?.touched)\"\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\tdata-aui=\"error-message\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t[attr.aria-describedby]=\"id + '-field' + ' ' + id + '-requiredError' + ' ' + id + '-patternError'\"\r\n\t\t\t>\r\n\t\t\t\t<span class=\"sr-only\" [id]=\"id+'-field'\">{{formData.label}} </span>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id + '-requiredError'\"\r\n\t\t\t\t\t*ngIf=\"city?.errors?.required && formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id + '-patternError'\"\r\n\t\t\t\t\t*ngIf=\"city?.errors?.pattern && formData?.errors?.ER15\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER15\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<div *ngSwitchCase=\"'dropdown'\">\r\n\t\t\t<label\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}\"\r\n\t\t\t\t[attr.for]=\"id\"\r\n\t\t\t\tclass=\"required\"\r\n\t\t\t\t>{{ formData.label }}</label\r\n\t\t\t>\r\n\t\t\t<select\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}-input\"\r\n\t\t\t\t[id]=\"id\"\r\n\t\t\t\t[formControlName]=\"formData.key\"\r\n\t\t\t\trequired\r\n\t\t\t\t[(ngModel)]=\"fieldValue\"\r\n\t\t\t\t(ngModelChange)=\"onChange($event)\"\r\n\t\t\t>\r\n\t\t\t\t<option *ngIf=\"formData.placeholder\" disabled selected value=\"\">\r\n\t\t\t\t\t{{ formData.placeholder }}\r\n\t\t\t\t</option>\r\n\t\t\t\t<option *ngFor=\"let opt of formData.options\" [ngValue]=\"opt.key\">\r\n\t\t\t\t\t{{ opt.value }}\r\n\t\t\t\t</option>\r\n\t\t\t</select>\r\n\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"stateValue.invalid && (stateValue.dirty || stateValue.touched)\"\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\tdata-aui=\"error-message\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t[attr.aria-describedby]=\"id + '-field' + ' ' + id + '-requiredError'\"\r\n\t\t\t>\r\n\t\t\t\t<span class=\"sr-only\" [id]=\"id+'-field'\">{{formData.label}} </span>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"id + '-requiredError'\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t*ngIf=\"stateValue?.errors?.required\"\r\n\t\t\t\t>\r\n\t\t\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n",
      styles: [".relative{position:relative}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2.UtilsService
  }, {
    type: AddressFieldService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: ['DefaultValues']
    }]
  }, {
    type: i4.SessionStorageService
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    countryChange: [{
      type: Output
    }],
    stateChange: [{
      type: Output
    }],
    formDataValue: [{
      type: Input
    }],
    country: [{
      type: Input
    }],
    state: [{
      type: Input
    }],
    isAddressComponent: [{
      type: Input
    }],
    isZipCodeMandiory: [{
      type: Input
    }],
    optionalLabel: [{
      type: Input
    }]
  });
})();
class CheckboxComponent {
  get required() {
    return this._required;
  }
  set required(value) {
    this._required = value;
  }
  get disabled() {
    return this._disabled;
  }
  set disabled(value) {
    this._disabled = value;
  }
  get checked() {
    return this._checked;
  }
  set checked(value) {
    this._checked = value;
  }
  get inverse() {
    return this._inverse;
  }
  set inverse(value) {
    this._inverse = value;
  }
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.formReady = new EventEmitter();
    this.changes = new EventEmitter();
    this.defaultChecked = false;
    this.checkboxGroup = this.formBuilder.group({
      checkbox: new FormControl(this._checked || false)
    });
  }
  ngOnChanges(changes) {
    if (changes.checked) {
      this.checkboxGroup.controls.checkbox.patchValue(changes.checked.currentValue);
    }
  }
  ngOnInit() {
    if (this._required) {
      this.checkboxGroup.controls.checkbox.setValidators([Validators.required]);
    }
    this.defaultChecked = this.checked;
    this.formReady.emit(this.checkboxGroup);
  }
  toggle() {
    this.checked = this.checkboxGroup.value.checkbox;
    this.changes.emit(this.checkboxGroup.value.checkbox);
  }
  get checkbox() {
    return this.checkboxGroup.get('checkbox');
  }
  static {
    this.ɵfac = function CheckboxComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckboxComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CheckboxComponent,
      selectors: [["upr-checkbox"]],
      viewQuery: function CheckboxComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
        }
      },
      inputs: {
        name: "name",
        error: "error",
        label: "label",
        ariaLabel: "ariaLabel",
        inverseCheckbox: "inverseCheckbox",
        required: "required",
        disabled: "disabled",
        checked: "checked",
        inverse: "inverse"
      },
      outputs: {
        formReady: "formReady",
        changes: "changes"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c3,
      decls: 8,
      vars: 15,
      consts: [["input", ""], [1, "checkbox-container", 3, "formGroup", "ngClass"], ["formControlName", "checkbox", "type", "checkbox", "attr.disabled", "disabled", 3, "change", "id", "required", "checked"], [1, "icon-checkmark", 3, "for", "ngClass"], [1, "sr-only"], ["class", "error", "role", "alert", 4, "ngIf"], ["role", "alert", 1, "error"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "innerHtml"]],
      template: function CheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵprojectionDef(_c2);
          i0.ɵɵelementStart(0, "div", 1)(1, "input", 2, 0);
          i0.ɵɵlistener("change", function CheckboxComponent_Template_input_change_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.toggle());
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "label", 3)(4, "span", 4);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()();
          i0.ɵɵprojection(6);
          i0.ɵɵtemplate(7, CheckboxComponent_div_7_Template, 3, 1, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.checkboxGroup)("ngClass", i0.ɵɵpureFunction1(11, _c0, ctx.required));
          i0.ɵɵattribute("data-aui", ctx.name);
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx.name)("required", ctx.required)("checked", ctx.checked);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("for", ctx.name)("ngClass", i0.ɵɵpureFunction1(13, _c4, ctx.inverse));
          i0.ɵɵattribute("aria-label", ctx.ariaLabel || ctx.label || ctx.name);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate1(" ", ctx.label || ctx.name, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.checkbox.invalid && (ctx.required && ctx.defaultChecked || ctx.checkbox.touched));
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgIf, i1.CheckboxControlValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.CheckboxRequiredValidator, i1.FormGroupDirective, i1.FormControlName],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.checkbox-container[_ngcontent-%COMP%]{cursor:pointer;clear:both;position:relative;margin-bottom:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox-container[_ngcontent-%COMP%]   .icon-checkmark[_ngcontent-%COMP%]{height:22px;width:22px;position:absolute;margin:0;background-color:#fff;color:#fff;border:2px solid #036ce2;border-radius:3px}.checkbox-container[_ngcontent-%COMP%]   .icon-checkmark[_ngcontent-%COMP%]:after{content:\"\";display:none;position:absolute}.checkbox-container[_ngcontent-%COMP%]   .icon-checkmark[_ngcontent-%COMP%]:hover{background-color:#eee}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer;opacity:1;position:absolute}.checkbox-container[_ngcontent-%COMP%]   input[disabled][_ngcontent-%COMP%] ~ .icon-checkmark[_ngcontent-%COMP%]{cursor:not-allowed;background:#eee;border-color:#e3e3e3;color:#e3e3e3}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus ~ .icon-checkmark[_ngcontent-%COMP%]{box-shadow:0 0 1px 2px #3b99fc}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .icon-checkmark[_ngcontent-%COMP%]{background-color:#036ce2}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .icon-checkmark.inverse-checkmark[_ngcontent-%COMP%]{background-color:#fff;color:#162b75;border:2px solid #162b75}.checkbox-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .icon-checkmark[_ngcontent-%COMP%]:after{left:0;bottom:1px;content:\"\\e608\";display:block;font-weight:700}.white-background   [_nghost-%COMP%]   .checkbox-container[_ngcontent-%COMP%]   .icon-checkmark[_ngcontent-%COMP%]{border:2px solid #0368d9}.white-background   [_nghost-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .icon-checkmark[_ngcontent-%COMP%]{background-color:#0368d9}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxComponent, [{
    type: Component,
    args: [{
      selector: 'upr-checkbox',
      standalone: false,
      template: "<div\r\n\t[formGroup]=\"checkboxGroup\"\r\n\tclass=\"checkbox-container\"\r\n\t[ngClass]=\"{ required: required }\"\r\n\tattr.data-aui=\"{{ name }}\"\r\n>\r\n\t<input\r\n\t\t#input\r\n\t\tformControlName=\"checkbox\"\r\n\t\ttype=\"checkbox\"\r\n\t\t[id]=\"name\"\r\n\t\t[required]=\"required\"\r\n\t\t[checked]=\"checked\"\r\n\t\tattr.disabled=\"disabled\"\r\n\t\t(change)=\"toggle()\"\r\n\t/>\r\n\t<label\r\n\t\t[for]=\"name\"\r\n\t\tclass=\"icon-checkmark\"\r\n\t\t[ngClass]=\"{ 'inverse-checkmark': inverse }\"\r\n\t\t[attr.aria-label]=\"ariaLabel || label || name\"\r\n\t>\r\n\t\t<span class=\"sr-only\">\r\n\t\t\t{{ label || name }}\r\n\t\t</span>\r\n\t</label>\r\n\t<ng-content select=\"[checkbox-text]\"></ng-content>\r\n\t<div\r\n\t\tclass=\"error\"\r\n\t\trole=\"alert\"\r\n\t\t*ngIf=\"\r\n\t\t\tcheckbox.invalid && ((required && defaultChecked) || checkbox.touched)\r\n\t\t\"\r\n\t>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small [innerHtml]=\"error\"></small>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.checkbox-container{cursor:pointer;clear:both;position:relative;margin-bottom:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.checkbox-container .icon-checkmark{height:22px;width:22px;position:absolute;margin:0;background-color:#fff;color:#fff;border:2px solid #036ce2;border-radius:3px}.checkbox-container .icon-checkmark:after{content:\"\";display:none;position:absolute}.checkbox-container .icon-checkmark:hover{background-color:#eee}.checkbox-container input{cursor:pointer;opacity:1;position:absolute}.checkbox-container input[disabled]~.icon-checkmark{cursor:not-allowed;background:#eee;border-color:#e3e3e3;color:#e3e3e3}.checkbox-container input:focus~.icon-checkmark{box-shadow:0 0 1px 2px #3b99fc}.checkbox-container input:checked~.icon-checkmark{background-color:#036ce2}.checkbox-container input:checked~.icon-checkmark.inverse-checkmark{background-color:#fff;color:#162b75;border:2px solid #162b75}.checkbox-container input:checked~.icon-checkmark:after{left:0;bottom:1px;content:\"\\e608\";display:block;font-weight:700}.white-background :host-context .checkbox-container .icon-checkmark{border:2px solid #0368d9}.white-background :host-context input:checked~.icon-checkmark{background-color:#0368d9}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    name: [{
      type: Input
    }],
    error: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    ariaLabel: [{
      type: Input
    }],
    inverseCheckbox: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    checked: [{
      type: Input
    }],
    inverse: [{
      type: Input
    }],
    formReady: [{
      type: Output
    }],
    changes: [{
      type: Output
    }],
    _inputElement: [{
      type: ViewChild,
      args: ['input', {
        static: true
      }]
    }]
  });
})();
class DateFieldComponent {
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.dateChange = new EventEmitter();
    this.debounceKeyUp = debounce(value => this.onChange(value), 500);
  }
  ngOnInit() {
    this.isReadOnly = this.formData.readOnly || false;
    this.dateGroup = this.formBuilder.group({
      date: new FormControl('', Validators.compose([Validators.required, Validators.maxLength(formFieldRanges.MAX.DATE), Validators.pattern(this.formData.pattern1)]))
    });
  }
  get date() {
    return this.dateGroup.get(this.formData.key);
  }
  validateLeapYear(value) {
    if (value) {
      const modelValue = value + '-1904';
      const date = moment(modelValue.replace('/', '-'), 'MM-DD-YYYY', true);
      return date.isValid();
    } else {
      return false;
    }
  }
  onChange(value) {
    if (!value && value.length === 2) {
      this.modelValue = value = value + '/';
      return;
    }
    if (value.length >= 3 && value.indexOf('/') === -1) {
      const newValue = value.substr(0, 2) + '/' + value.substr(2);
      this.modelValue = value = newValue;
    }
    if (value.length > 5) {
      this.modelValue = value = value.substr(0, 5);
    }
    this.isDateValid = this.validateLeapYear(value);
    if (this.isDateValid) {
      this.dateChange.emit(value);
    } else {
      this.dateChange.emit('');
    }
  }
  static {
    this.ɵfac = function DateFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DateFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DateFieldComponent,
      selectors: [["upr-date-field"]],
      inputs: {
        inverseLabel: "inverseLabel",
        formData: "formData",
        modelValue: "modelValue"
      },
      outputs: {
        dateChange: "dateChange"
      },
      standalone: false,
      decls: 9,
      vars: 16,
      consts: [[3, "formGroup"], [1, "required", 3, "for", "ngClass"], ["tooltip-box", "", 3, "innerHtml"], ["tooltip", "", 1, "icon", "icon-info", "icon-tooltip"], ["attr.disabled", "isReadOnly", "required", "", 3, "ngModelChange", "formControlName", "id", "type", "maxlength", "placeholder", "ngModel"], ["class", "error", "role", "alert", 4, "ngIf"], [4, "ngIf"], ["role", "alert", 1, "error"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "innerHtml", 4, "ngIf"], [3, "innerHtml"], [1, "error", 3, "innerHtml"]],
      template: function DateFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "upr-tooltip");
          i0.ɵɵelement(4, "div", 2)(5, "i", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(6, "input", 4);
          i0.ɵɵtwoWayListener("ngModelChange", function DateFieldComponent_Template_input_ngModelChange_6_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.modelValue, $event) || (ctx.modelValue = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function DateFieldComponent_Template_input_ngModelChange_6_listener($event) {
            return ctx.debounceKeyUp($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, DateFieldComponent_div_7_Template, 5, 3, "div", 5)(8, DateFieldComponent_div_8_Template, 3, 3, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.dateGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("for", ctx.formData.key)("ngClass", i0.ɵɵpureFunction1(14, _c5, ctx.inverseLabel));
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.formData.label, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("innerHtml", ctx.formData == null ? null : ctx.formData.tooltip, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("formControlName", ctx.formData.key)("id", ctx.formData.key)("type", ctx.formData.controlType)("maxlength", 5)("placeholder", ctx.formData.placeholder);
          i0.ɵɵtwoWayProperty("ngModel", ctx.modelValue);
          i0.ɵɵattribute("data-aui", ctx.formData.label);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.date.invalid && (ctx.date.dirty || ctx.date.touched));
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.date.valid && (ctx.date.dirty || ctx.date.touched) && !ctx.isDateValid);
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.MaxLengthValidator, i1.FormGroupDirective, i1.FormControlName, i3.TooltipComponent],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}label[_ngcontent-%COMP%]{display:inline-flex;margin-top:14px}.inverse-label[_ngcontent-%COMP%]{color:#fff}.tooltip[_ngcontent-%COMP%]{position:absolute;top:-21px}.tooltip[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#fff}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DateFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-date-field',
      standalone: false,
      template: "<div [formGroup]=\"dateGroup\">\r\n\t<label\r\n\t\t[for]=\"formData.key\"\r\n\t\t[ngClass]=\"{ 'inverse-label': inverseLabel }\"\r\n\t\tclass=\"required\"\r\n\t>\r\n\t\t{{ formData.label }}\r\n\t</label>\r\n\r\n\t<upr-tooltip>\r\n\t\t<div tooltip-box [innerHtml]=\"formData?.tooltip\"></div>\r\n\t\t<i class=\"icon icon-info icon-tooltip\" tooltip></i>\r\n\t</upr-tooltip>\r\n\t<input\r\n\t\t[formControlName]=\"formData.key\"\r\n\t\tattr.data-aui=\"{{ formData.label }}\"\r\n\t\t[id]=\"formData.key\"\r\n\t\t[type]=\"formData.controlType\"\r\n\t\t[maxlength]=\"5\"\r\n\t\tattr.disabled=\"isReadOnly\"\r\n\t\t[placeholder]=\"formData.placeholder\"\r\n\t\t[(ngModel)]=\"modelValue\"\r\n\t\t(ngModelChange)=\"debounceKeyUp($event)\"\r\n\t\trequired\r\n\t/>\r\n\r\n\t<div\r\n\t\t*ngIf=\"date.invalid && (date.dirty || date.touched)\"\r\n\t\tclass=\"error\"\r\n\t\trole=\"alert\"\r\n\t>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small\r\n\t\t\t*ngIf=\"date.errors.required\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t>\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t*ngIf=\"date.errors.pattern\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER4\"\r\n\t\t>\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t*ngIf=\"date.errors.maxlength\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER134\"\r\n\t\t>\r\n\t\t</small>\r\n\t</div>\r\n\t<div *ngIf=\"date.valid && (date.dirty || date.touched) && !isDateValid\">\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small\r\n\t\t\tclass=\"error\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER134\"\r\n\t\t>\r\n\t\t</small>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}label{display:inline-flex;margin-top:14px}.inverse-label{color:#fff}.tooltip{position:absolute;top:-21px}.tooltip i{color:#fff}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    dateChange: [{
      type: Output
    }],
    inverseLabel: [{
      type: Input
    }],
    formData: [{
      type: Input
    }],
    modelValue: [{
      type: Input
    }]
  });
})();
const EN = {
  dayLabels: {
    su: 'Su',
    mo: 'Mo',
    tu: 'Tu',
    we: 'We',
    th: 'Th',
    fr: 'Fr',
    sa: 'Sa'
  },
  monthLabels: {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  },
  ariaLabelPrevMonth: 'Previous Month',
  ariaLabelNextMonth: 'Next Month',
  ariaLabelPrevYear: 'Previous Year',
  ariaLabelNextYear: 'Next Year',
  todayBtnTxt: 'Today'
};
const ES = {
  dayLabels: {
    su: 'Do',
    mo: 'Lu',
    tu: 'Ma',
    we: 'Mi',
    th: 'Ju',
    fr: 'Vi',
    sa: 'Sa'
  },
  monthLabels: {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre'
  },
  ariaLabelPrevMonth: 'Mes Anterior',
  ariaLabelNextMonth: 'Próximo mes',
  ariaLabelPrevYear: 'Año anterior',
  ariaLabelNextYear: 'Próximo año',
  todayBtnTxt: 'Hoy'
};
class DatepickerComponent {
  constructor(formBuilder, localeService) {
    this.formBuilder = formBuilder;
    this.localeService = localeService;
    this.formReady = new EventEmitter();
    this.calendarDateChanged = new EventEmitter();
    this.selectedDay = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    };
    this.calendarOptions = {
      dateFormat: 'mm/dd/yyyy',
      showSelectorArrow: false,
      sunHighlight: true,
      markCurrentDay: false,
      selectorWidth: '180px',
      disableUntil: this.selectedDay,
      firstDayOfWeek: 'su',
      yearSelector: false,
      monthSelector: false
    };
    this.isCalendarOpen = false;
    const locale = this.localeService.getFromStorage();
    if (locale.language === 'es') {
      this.calendarOptions.dayLabels = ES.dayLabels;
      this.calendarOptions.monthLabels = ES.monthLabels;
      this.calendarOptions.dayLabels = ES.dayLabels;
      this.calendarOptions.monthLabels = ES.monthLabels;
      this.calendarOptions.dayLabels = ES.dayLabels;
      this.calendarOptions.monthLabels = ES.monthLabels;
      this.calendarOptions.ariaLabelPrevMonth = ES.ariaLabelPrevMonth;
      this.calendarOptions.ariaLabelNextMonth = ES.ariaLabelNextMonth;
      this.calendarOptions.ariaLabelPrevYear = ES.ariaLabelPrevYear;
      this.calendarOptions.ariaLabelNextYear = ES.ariaLabelNextYear;
      this.calendarOptions.todayBtnTxt = ES.todayBtnTxt;
    } else {
      this.calendarOptions.dayLabels = EN.dayLabels;
      this.calendarOptions.monthLabels = EN.monthLabels;
      this.calendarOptions.dayLabels = EN.dayLabels;
      this.calendarOptions.monthLabels = EN.monthLabels;
      this.calendarOptions.ariaLabelPrevMonth = EN.ariaLabelPrevMonth;
      this.calendarOptions.ariaLabelNextMonth = EN.ariaLabelNextMonth;
      this.calendarOptions.ariaLabelPrevYear = EN.ariaLabelPrevYear;
      this.calendarOptions.ariaLabelNextYear = EN.ariaLabelNextYear;
      this.calendarOptions.todayBtnTxt = EN.todayBtnTxt;
    }
  }
  ngOnInit() {
    this.calendarDateGroup = this.formBuilder.group({
      calendarDate: new FormControl('', Validators.compose([Validators.required]))
    });
    this.formReady.emit(this.calendarDateGroup);
  }
  ngOnChanges() {
    this.calendarDateValue = this.date || this.startDate;
    const calendarFormattedDate = get(this.calendarDateGroup, 'controls.calendarDate.value.formatted');
    if (this.startDate && this.startDate !== calendarFormattedDate) {
      const start = new Date(this.startDate);
      this.selectedDay = {
        year: start.getFullYear(),
        month: start.getMonth() + 1,
        day: start.getDate()
      };
      const disableUntilDate = new Date(start);
      disableUntilDate.setDate(disableUntilDate.getDate() - 1);
      const disableUntil = {
        year: disableUntilDate.getFullYear(),
        month: disableUntilDate.getMonth() + 1,
        day: disableUntilDate.getDate()
      };
      this.calendarOptions.disableUntil = disableUntil;
      if (this.calendarDateGroup) {
        this.calendarDateGroup.setValue({
          calendarDate: this.selectedDay
        });
      }
    }
  }
  onDateChanged(event) {
    this.calendarDateChanged.emit(event.formatted);
  }
  setIsCalendarOpen(_reason) {
    this.isCalendarOpen = !this.isCalendarOpen;
  }
  get calendarDateField() {
    return this.calendarDateGroup.get('calendarDate');
  }
  formattedDate(date) {
    if (!date) {
      return '';
    }
    return new Date(date).toDateString();
  }
  static {
    this.ɵfac = function DatepickerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DatepickerComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2$2.LocaleService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DatepickerComponent,
      selectors: [["upr-datepicker"]],
      inputs: {
        errorMessages: "errorMessages",
        label: "label",
        name: "name",
        date: "date",
        buttonAriaLabel: "buttonAriaLabel",
        startDate: "startDate"
      },
      outputs: {
        formReady: "formReady",
        calendarDateChanged: "calendarDateChanged"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 5,
      vars: 11,
      consts: [["dp", "ngx-mydatepicker"], [1, "calendar-date", 3, "formGroup"], [1, "required", 3, "for", "innerHtml"], ["formControlName", "calendarDate", "type", "text", "placeholder", "mm/dd/yyyy", "ngx-mydatepicker", "", "required", "", 3, "calendarToggle", "dateChanged", "id", "value", "options"], ["class", "error", "role", "alert", 4, "ngIf"], ["role", "alert", 1, "error"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "innerHtml", 4, "ngIf"], [3, "innerHtml"]],
      template: function DatepickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵelementStart(0, "div", 1);
          i0.ɵɵelement(1, "label", 2);
          i0.ɵɵelementStart(2, "input", 3, 0);
          i0.ɵɵlistener("calendarToggle", function DatepickerComponent_Template_input_calendarToggle_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.setIsCalendarOpen($event));
          })("dateChanged", function DatepickerComponent_Template_input_dateChanged_2_listener($event) {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.onDateChanged($event));
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, DatepickerComponent_div_4_Template, 4, 3, "div", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.calendarDateGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("for", ctx.name)("innerHtml", ctx.label, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "date-input-", ctx.name, "");
          i0.ɵɵproperty("id", ctx.name)("value", ctx.calendarDateValue)("options", ctx.calendarOptions);
          i0.ɵɵattribute("analytics-title", ctx.formattedDate(ctx.calendarDateValue))("aria-describedby", ctx.name + "Error");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (ctx.errorMessages == null ? null : ctx.errorMessages.CheckoutDateRange) || (ctx.calendarDateField == null ? null : ctx.calendarDateField.invalid) && ((ctx.calendarDateField == null ? null : ctx.calendarDateField.dirty) || (ctx.calendarDateField == null ? null : ctx.calendarDateField.touched)));
        }
      },
      dependencies: [i2$1.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.FormGroupDirective, i1.FormControlName, i4$1.NgxMyDatePickerDirective],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.calendar-date[_ngcontent-%COMP%]{position:relative}.calendar-icon[_ngcontent-%COMP%]{font-size:1.5rem;color:#036ce2;cursor:pointer;position:absolute;top:33px;right:4px;height:0}.white-background   [_nghost-%COMP%]   .calendar-icon[_ngcontent-%COMP%]{color:#0368d9}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerComponent, [{
    type: Component,
    args: [{
      selector: 'upr-datepicker',
      standalone: false,
      template: "<div [formGroup]=\"calendarDateGroup\" class=\"calendar-date\">\r\n\t<label [for]=\"name\" [innerHtml]=\"label\" class=\"required\"></label>\r\n\t<input\r\n\t\tformControlName=\"calendarDate\"\r\n\t\tattr.data-aui=\"date-input-{{ name }}\"\r\n\t\t[id]=\"name\"\r\n\t\ttype=\"text\"\r\n\t\tplaceholder=\"mm/dd/yyyy\"\r\n\t\t[value]=\"calendarDateValue\"\r\n\t\t[options]=\"calendarOptions\"\r\n\t\t#dp=\"ngx-mydatepicker\"\r\n\t\tngx-mydatepicker\r\n\t\trequired\r\n\t\t(calendarToggle)=\"setIsCalendarOpen($event)\"\r\n\t\t(dateChanged)=\"onDateChanged($event)\"\r\n\t\t[attr.analytics-title]=\"formattedDate(calendarDateValue)\"\r\n\t\t[attr.aria-describedby]=\"name + 'Error'\"\r\n\t/>\r\n\r\n\t<div\r\n\t\tclass=\"error\"\r\n\t\trole=\"alert\"\r\n\t\t*ngIf=\"\r\n\t\t\terrorMessages?.CheckoutDateRange ||\r\n\t\t\t(calendarDateField?.invalid &&\r\n\t\t\t\t(calendarDateField?.dirty || calendarDateField?.touched))\r\n\t\t\"\r\n\t\t[attr.id]=\"name + 'Error'\"\r\n\t>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small\r\n\t\t\t*ngIf=\"calendarDateField?.errors?.required\"\r\n\t\t\t[innerHtml]=\"\r\n\t\t\t\terrorMessages?.InValidDateError ||\r\n\t\t\t\t'Please enter a valid date (mm/dd/yyyy)'\r\n\t\t\t\"\r\n\t\t></small>\r\n\t\t<small\r\n\t\t\t*ngIf=\"errorMessages?.CheckoutDateRange\"\r\n\t\t\t[innerHtml]=\"errorMessages?.CheckoutDateRange\"\r\n\t\t></small>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.calendar-date{position:relative}.calendar-icon{font-size:1.5rem;color:#036ce2;cursor:pointer;position:absolute;top:33px;right:4px;height:0}.white-background :host-context .calendar-icon{color:#0368d9}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2$2.LocaleService
  }], {
    errorMessages: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    name: [{
      type: Input
    }],
    date: [{
      type: Input
    }],
    buttonAriaLabel: [{
      type: Input
    }],
    startDate: [{
      type: Input
    }],
    formReady: [{
      type: Output
    }],
    calendarDateChanged: [{
      type: Output
    }]
  });
})();
class DropdownFieldComponent {
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.options = [];
    this.formReady = new EventEmitter();
    this.changeValue = new EventEmitter();
  }
  ngOnInit() {
    // if no options, but min and max values then build options
    if (!this.options.length && this.minValue && this.maxValue) {
      this.buildDropdownOptionsWithMinMax();
    }
    this.dropdownGroup = this.formBuilder.group({
      dropdown: new FormControl('', Validators.required)
    });
    this.formReady.emit(this.dropdownGroup);
    if (this.hasDefaultOption) {
      this.selectedOption = this.defaultOption?.Key ?? 'default';
    } else if (this.selectedKey) {
      this.selectedOption = find(this.options, option => option.Key === Number(this.selectedKey)) ? find(this.options, option => option.Key === Number(this.selectedKey)).Key : get(this.options[0], 'code') ? this.options[0].code : this.options[0].Key;
    } else {
      this.selectedOption = get(this.options[0], 'code') ? this.options[0].code : this.options[0].Key;
    }
  }
  get dropdown() {
    return this.dropdownGroup.get('dropdown');
  }
  onChange(newOption) {
    if (newOption) {
      this.selectedOption = newOption;
      if (this.changeValue && this.changeValue.emit) {
        this.changeValue.emit(newOption);
      }
    }
  }
  buildDropdownOptionsWithMinMax() {
    for (let i = this.minValue; i <= this.maxValue; i++) {
      this.options.push({
        Key: i,
        value: i
      });
    }
  }
  static {
    this.ɵfac = function DropdownFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DropdownFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DropdownFieldComponent,
      selectors: [["upr-dropdown-field"]],
      inputs: {
        name: "name",
        options: "options",
        errorMessages: "errorMessages",
        hasDefaultOption: "hasDefaultOption",
        defaultOption: "defaultOption",
        class: "class",
        analyticsTitle: "analyticsTitle",
        minValue: "minValue",
        maxValue: "maxValue",
        selectedKey: "selectedKey",
        ariaDescribedBy: "ariaDescribedBy"
      },
      outputs: {
        formReady: "formReady",
        changeValue: "changeValue"
      },
      standalone: false,
      ngContentSelectors: _c7,
      decls: 7,
      vars: 13,
      consts: [[3, "formGroup"], [1, "required", 3, "for"], ["data-aui", "dropdown-arrows", "formControlName", "dropdown", 1, "dropdown", 3, "ngModelChange", "id", "ngModel"], [3, "ngValue", "innerHTML", 4, "ngIf"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["class", "error", "role", "alert", 4, "ngIf"], [3, "ngValue", "innerHTML"], [3, "ngValue"], ["role", "alert", 1, "error"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [4, "ngIf"]],
      template: function DropdownFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c6);
          i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "select", 2);
          i0.ɵɵtwoWayListener("ngModelChange", function DropdownFieldComponent_Template_select_ngModelChange_3_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedOption, $event) || (ctx.selectedOption = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function DropdownFieldComponent_Template_select_ngModelChange_3_listener($event) {
            return ctx.onChange($event);
          });
          i0.ɵɵtemplate(4, DropdownFieldComponent_option_4_Template, 1, 2, "option", 3)(5, DropdownFieldComponent_option_5_Template, 2, 2, "option", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, DropdownFieldComponent_div_6_Template, 3, 1, "div", 5);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵclassMapInterpolate1("dropdown-group double-arrows-select ", ctx.class, "");
          i0.ɵɵproperty("formGroup", ctx.dropdownGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("for", ctx.name);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("id", ctx.name);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedOption);
          i0.ɵɵattribute("analytics-title", ctx.analyticsTitle + " | " + ctx.selectedOption)("aria-describedby", ctx.ariaDescribedBy)("data-aui", ctx.selectedOption);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.hasDefaultOption);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngForOf", ctx.options);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx.dropdown == null ? null : ctx.dropdown.invalid) && ((ctx.dropdown == null ? null : ctx.dropdown.dirty) || (ctx.dropdown == null ? null : ctx.dropdown.touched)));
        }
      },
      dependencies: [i2$1.NgForOf, i2$1.NgIf, i1.NgSelectOption, i1.ɵNgSelectMultipleOption, i1.SelectControlValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.dropdown[_ngcontent-%COMP%]{border-radius:5px}.double-arrows-select[_ngcontent-%COMP%]{position:relative;zoom:1;display:block}.double-arrows-select[_ngcontent-%COMP%]:after{content:\"\\e601\";font-family:uo_ui-icons!important;display:inline-block;font-size:32px;line-height:32px;color:#036ce2;background-color:#fff;position:absolute;bottom:20px;right:2px;pointer-events:none}.double-arrows-select[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff}.promo-code[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{font-size:14px}.white-background   [_nghost-%COMP%]   .double-arrows-select[_ngcontent-%COMP%]:after{color:#0368d9}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DropdownFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-dropdown-field',
      standalone: false,
      template: "<div\r\n\t[formGroup]=\"dropdownGroup\"\r\n\tclass=\"dropdown-group double-arrows-select {{ class }}\"\r\n>\r\n\t<label [for]=\"name\" class=\"required\">\r\n\t\t<ng-content select=\"[dropdown-label]\"></ng-content>\r\n\t</label>\r\n\r\n\t<select\r\n\t\t[id]=\"name\"\r\n\t\tdata-aui=\"dropdown-arrows\"\r\n\t\tformControlName=\"dropdown\"\r\n\t\t[(ngModel)]=\"selectedOption\"\r\n\t\t(ngModelChange)=\"onChange($event)\"\r\n\t\tclass=\"dropdown\"\r\n\t\t[attr.analytics-title]=\"analyticsTitle + ' | ' + selectedOption\"\r\n\t\t[attr.aria-describedby]=\"ariaDescribedBy\"\r\n\t\t[attr.data-aui]=\"selectedOption\"\r\n\t>\r\n\t\t<option\r\n\t\t\t[ngValue]=\"defaultOption?.Key ?? 'default'\"\r\n\t\t\t[innerHTML]=\"defaultOption?.value ?? defaultOption\"\r\n\t\t\t*ngIf=\"hasDefaultOption\"\r\n\t\t></option>\r\n\t\t<option\r\n\t\t\t*ngFor=\"let option of options\"\r\n\t\t\t[ngValue]=\"option.code || option.Key\"\r\n\t\t>\r\n\t\t\t{{ (option.value || option.Description) + ' ' + (option.code || '') }}\r\n\t\t</option>\r\n\t</select>\r\n\r\n\t<div\r\n\t\tclass=\"error\"\r\n\t\trole=\"alert\"\r\n\t\t*ngIf=\"dropdown?.invalid && (dropdown?.dirty || dropdown?.touched)\"\r\n\t>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small *ngIf=\"dropdown?.errors?.required\">\r\n\t\t\t{{ errorMessages?.ER26 }}\r\n\t\t</small>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.dropdown{border-radius:5px}.double-arrows-select{position:relative;zoom:1;display:block}.double-arrows-select:after{content:\"\\e601\";font-family:uo_ui-icons!important;display:inline-block;font-size:32px;line-height:32px;color:#036ce2;background-color:#fff;position:absolute;bottom:20px;right:2px;pointer-events:none}.double-arrows-select select{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff}.promo-code select{font-size:14px}.white-background :host-context .double-arrows-select:after{color:#0368d9}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    name: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    errorMessages: [{
      type: Input
    }],
    hasDefaultOption: [{
      type: Input
    }],
    defaultOption: [{
      type: Input
    }],
    class: [{
      type: Input
    }],
    analyticsTitle: [{
      type: Input
    }],
    minValue: [{
      type: Input
    }],
    maxValue: [{
      type: Input
    }],
    selectedKey: [{
      type: Input
    }],
    ariaDescribedBy: [{
      type: Input
    }],
    formReady: [{
      type: Output
    }],
    changeValue: [{
      type: Output
    }]
  });
})();
let _nextEmailFieldUniqueId = 0;
class EmailFieldComponent {
  constructor(fb) {
    this.fb = fb;
    this.formReady = new EventEmitter();
    this._emailFieldUniqueId = _nextEmailFieldUniqueId++;
  }
  ngOnInit() {
    this.emailGroup = this.fb.group({
      email: new FormControl('', Validators.compose([Validators.required, Validators.pattern(this.formData.pattern1)]))
    });
    this.formReady.emit(this.emailGroup);
  }
  ngOnDestroy() {
    this._emailFieldUniqueId = _nextEmailFieldUniqueId = 0;
  }
  onInputChange(value) {
    this.formData.value = value;
  }
  get uid() {
    return this.id ? this.id : this.formData.key + '-' + this._emailFieldUniqueId;
  }
  get email() {
    return this.emailGroup.get(this.formData.key);
  }
  static {
    this.ɵfac = function EmailFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || EmailFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: EmailFieldComponent,
      selectors: [["upr-email-field"]],
      inputs: {
        formData: "formData",
        id: "id",
        showToolTip: "showToolTip"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      decls: 6,
      vars: 13,
      consts: [[3, "formGroup"], [1, "label-with-tooltip", "required"], [4, "ngIf"], ["required", "", 3, "ngModelChange", "formControlName", "id", "placeholder", "type", "ngModel"], ["class", "error", "role", "alert", 4, "ngIf"], ["tooltip-box", ""], ["tooltip", "", 1, "icon", "icon-info", "icon-tooltip"], ["role", "alert", 1, "error"], [1, "sr-only", 3, "id"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "id", 4, "ngIf"], [3, "id"]],
      template: function EmailFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, EmailFieldComponent_upr_tooltip_3_Template, 4, 1, "upr-tooltip", 2);
          i0.ɵɵelementStart(4, "input", 3);
          i0.ɵɵlistener("ngModelChange", function EmailFieldComponent_Template_input_ngModelChange_4_listener($event) {
            return ctx.onInputChange($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, EmailFieldComponent_div_5_Template, 6, 5, "div", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.emailGroup);
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-aui", ctx.formData.label)("for", ctx.uid);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.formData.label);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.showToolTip);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData.key, "-input");
          i0.ɵɵproperty("formControlName", ctx.formData.key)("id", ctx.uid)("placeholder", ctx.formData.placeholder)("type", ctx.formData.controlType)("ngModel", ctx.formData.value);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.email.invalid && ctx.email.touched);
        }
      },
      dependencies: [i2$1.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.FormGroupDirective, i1.FormControlName, i3.TooltipComponent],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EmailFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-email-field',
      standalone: false,
      template: "<div [formGroup]=\"emailGroup\">\r\n\t<label\r\n\t\tclass=\"label-with-tooltip required\"\r\n\t\tattr.data-aui=\"{{ formData.label }}\"\r\n\t\t[attr.for]=\"uid\"\r\n\t\t>{{ formData.label }}</label\r\n\t>\r\n\t<upr-tooltip *ngIf=\"showToolTip\">\r\n\t\t<div tooltip-box>\r\n\t\t\t{{ formData.tooltip }}\r\n\t\t</div>\r\n\t\t<i class=\"icon icon-info icon-tooltip\" tooltip></i>\r\n\t</upr-tooltip>\r\n\t<input\r\n\t\tattr.data-aui=\"{{ formData.key }}-input\"\r\n\t\t[formControlName]=\"formData.key\"\r\n\t\t[id]=\"uid\"\r\n\t\t[placeholder]=\"formData.placeholder\"\r\n\t\t[type]=\"formData.controlType\"\r\n\t\t[ngModel]=\"formData.value\"\r\n\t\t(ngModelChange)=\"onInputChange($event)\"\r\n\t\trequired\r\n\t/>\r\n\t<div class=\"error\" role=\"alert\" *ngIf=\"email.invalid && email.touched\"\r\n\t\t\t [attr.aria-describedby]=\"id + '-field' + ' ' + id + '-requiredError' + ' ' + id + '-patternError'\"\r\n\t>\r\n\t\t<span class=\"sr-only\" [id]=\"id+'-field'\">{{formData.label}} </span>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-requiredError'\"\r\n\t\t\t*ngIf=\"email?.errors?.required\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t\t>{{ formData?.errors?.ER26 }}\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-patternError'\"\r\n\t\t\t*ngIf=\"email?.errors?.pattern\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t\t>{{ formData?.errors?.ER6 }}\r\n\t\t</small>\r\n\t</div>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    showToolTip: [{
      type: Input
    }]
  });
})();
class GdsAddressFieldComponent {
  constructor(formBuilder, utilsService, addressService, sessionStorage, geolocationService) {
    this.formBuilder = formBuilder;
    this.utilsService = utilsService;
    this.addressService = addressService;
    this.sessionStorage = sessionStorage;
    this.geolocationService = geolocationService;
    this.formReady = new EventEmitter();
    this.countryChange = new EventEmitter();
    this.stateChange = new EventEmitter();
    this.displayedInModal = false;
    this.useNativeStateDropdown = false;
    this.isCoBrandCard = false;
    this.theme = AvailableGdsThemes[0];
    this.cityMaxLength = formFieldRanges.MAX.CITY;
    this.billAddressFormObj = {};
    this.shipAddressFormObj = {};
    this.countries = [];
    this.states = [];
    this.transformedInput = '';
    this.gdsData = {};
    this.debounceKeyUp = debounce(() => this.updateZipPattern(''), 500);
  }
  ngOnInit() {
    this.addressGroup = this.initAddress();
    this.formReady.emit(this.addressControl);
    this.gdsData = {
      ...this.gdsData,
      primaryLabel: this.formData?.label,
      supportingText: this.formData?.optionalLabel ?? this.formData?.supportingText,
      tooltip: this.formData?.tooltip,
      placeholder: this.formData?.placeholder,
      maxLength: this.formData?.maxLength,
      inputmode: this.formData?.inputmode ?? 'text',
      describedby: this.formData?.key + '-error'
    };
    switch (this.formData.key) {
      case 'country':
        if (!this.countries || this.countries.length <= 0) {
          this.sessionStorage.setItem('countryList', '');
          this.sessionStorage.setItem('countriesRequested', 'false');
          this.loadCountryList();
          break;
        } else {
          this.sessionStorage.setItem('countriesRequested', 'false');
          this.setFormOptions();
          break;
        }
      case 'state':
        if (!this.states || this.states.length <= 0) {
          this.sessionStorage.setItem('stateList', '');
          this.sessionStorage.setItem('statesRequested', 'false');
          this.loadUsStateList();
          break;
        } else {
          this.sessionStorage.setItem('statesRequested', 'false');
          this.setFormOptions();
          break;
        }
      default:
        this.setFormOptions();
    }
    this.getControl('country').valueChanges.subscribe(value => {
      this.countryChange.emit(value);
      this.updateZipPattern(value);
    });
    this.getControl('state').valueChanges.subscribe(value => {
      this.stateChange.emit(value);
    });
    this.onValueChange(this.formDataValue || this.formData?.value || '');
  }
  ngOnChanges(changes) {
    if (changes.country?.currentValue === changes.country?.previousValue) return;
    if (this.addressGroup && this.addressControl?.value && this.country) {
      this.updateZipPattern(this.addressControl.value);
    } else {
      this.updateZipPattern('');
    }
  }
  loadCountryList() {
    const localCountryList = this.sessionStorage.getItem('countryList');
    const countriesRequested = this.sessionStorage.getItem('countriesRequested');
    if (countriesRequested && localCountryList && localCountryList.length > 0) {
      this.countries = JSON.parse(localCountryList);
      this.setFormOptions();
      return;
    }
    if (countriesRequested === 'true') {
      return;
    }
    this.sessionStorage.setItem('countriesRequested', 'true');
    this.utilsService.loadCountryList().then(countries => {
      if (!this.billAddressFormObj) {
        this.billAddressFormObj = this.addressService.EmptyAddress();
      }
      if (!this.shipAddressFormObj) {
        this.shipAddressFormObj = this.addressService.EmptyAddress();
      }
      this.billAddressFormObj.country = this.defaultCountry;
      this.shipAddressFormObj.country = this.defaultCountry;
      this.countries = countries;
      this.setFormOptions();
    });
  }
  loadUsStateList() {
    const localStateList = this.sessionStorage.getItem('stateList');
    const statesRequested = this.sessionStorage.getItem('statesRequested');
    if (statesRequested && localStateList && localStateList.length > 0) {
      this.states = JSON.parse(localStateList);
      this.setFormOptions();
      return;
    }
    if (statesRequested === 'true') {
      return;
    }
    this.sessionStorage.setItem('statesRequested', 'true');
    this.utilsService.loadUsStateList().then(states => {
      this.states = states;
      this.sessionStorage.setItem('countryList', JSON.stringify(this.countries));
      this.sessionStorage.setItem('stateList', JSON.stringify(this.states));
      this.setFormOptions();
    });
  }
  setFormOptions() {
    if (this.formData.key === 'country' && this.countries) {
      this.countries.forEach(item => {
        item.id = item.id;
        item.value = item.name;
      });
      this.formData.options = this.countries.map(country => {
        return {
          label: country.name,
          value: country.id
        };
      });
      this.addressControl.setValue(this.country || this.geolocationService.getGeoCountry().toUpperCase() || '');
    }
    if (this.formData.key === 'state' && this.states) {
      if (this.isCoBrandCard) {
        const state = this.states.find(x => x.id === this.formData.value);
        this.addressControl.setValue(state?.name);
        return;
      }
      this.states.forEach(item => {
        item.id = item.id;
        item.value = item.name;
      });
      this.formData.options = this.states.map(state => {
        return {
          label: state.name,
          value: state.id
        };
      });
    }
  }
  updateZipPattern(value) {
    if (this.formData.key === 'city' || this.formData.key === 'state' || this.formData.key === 'zipPostalCode') {
      let validatorObject = [];
      let validatorWOObject = [];
      if (this.formData.key === 'city') {
        validatorObject = [...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsMaxLengthValidator(this.cityMaxLength, this.formData?.errors?.maxLengthError), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)];
        validatorWOObject = [gdsMaxLengthValidator(this.cityMaxLength, this.formData?.errors?.maxLengthError), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)];
      }
      if (this.formData.key === 'state') {
        validatorObject = [...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)];
        validatorWOObject = [gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)];
      }
      if (this.formData.key === 'zipPostalCode') {
        this.transformedInput = value ? value.replace(NumberCharPattern.NON_DIGIT, '') : '';
        validatorObject = [...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsPatternValidator(ZipCodePattern.ZIP, this.formData?.errors?.ER32)];
        validatorWOObject = [gdsPatternValidator(ZipCodePattern.NON_US_ZIP, this.formData?.errors?.ER40)];
      }
      if (this.addressGroup) {
        const control = this.addressGroup.get(this.formData.key);
        if (this.country && this.country.toLowerCase() === 'us') {
          control.setValidators(validatorObject);
          control.setErrors(null);
          this.formData.optionalLabel = '';
          this.formData.required = true;
          if (this.formData.key === 'zipPostalCode') {
            this.formatTransformedInput();
          }
        } else {
          if (this.isAddressComponent || !this.isZipCodeMandiory && this.formData.key === 'zipPostalCode') {
            control.setValidators(validatorWOObject);
            control.setErrors(null);
            this.formData.optionalLabel = this.optionalLabel;
            this.formData.required = false;
          } else if (this.isZipCodeMandiory && this.formData.key === 'zipPostalCode') {
            validatorWOObject = [gdsPatternValidator(ZipCodePattern.NON_US_ZIP, this.formData?.errors?.ER40), ...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : [])];
            this.formData.optionalLabel = '';
            this.formData.required = true;
            control.setValidators(validatorWOObject);
            control.setErrors(null);
          }
        }
        control.updateValueAndValidity();
      }
    }
    const labelRequired = this.formData.required ? ' *' : '';
    this.formData.label = trimEnd(this.formData.label, '*').trim();
    this.formData.label = `${this.formData.label}${labelRequired}`;
    this.gdsData = {
      ...this.gdsData,
      primaryLabel: this.formData?.label,
      supportingText: this.formData?.optionalLabel,
      maxLength: this.formData?.maxLength,
      inputmode: this.formData?.inputmode || 'text',
      required: this.formData?.required
    };
  }
  formatTransformedInput() {
    if (!this.transformedInput) {
      return '';
    }
    this.transformedInput = this.transformedInput.toString().trim().replace(NumberCharPattern.START_WITH_PLUS, '');
    this.transformedInput = this.transformedInput.replace('-', '');
    if (this.transformedInput.match(NumberCharPattern.BEGIN_WITH_NUMBER)) {
      return;
    }
    if (this.transformedInput.length === 9) {
      this.transformedInput = this.transformedInput.slice(0, 5) + '-' + this.transformedInput.slice(5);
    } else if (this.transformedInput.length === 5) {
      return;
    } else if (this.transformedInput.length > 5 && this.transformedInput.length < 9) {
      this.transformedInput = this.transformedInput.slice(0, 5) + '-' + this.transformedInput.slice(5 - this.transformedInput.length);
    } else {
      return;
    }
    this.formDataValue = this.transformedInput;
    this.addressControl.setValue(this.formDataValue);
  }
  initAddress() {
    this.isReadOnly = this.formData.readOnly || false;
    this.gdsData['readonly'] = this.isReadOnly;
    if (this.formData.key === 'city') {
      this.cityMaxLength = this.formData.maxLength ?? formFieldRanges.MAX.CITY;
    }
    return this.formBuilder.group({
      country: ['', ...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : [])],
      addressLine1: ['', Validators.compose([...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsMaxLengthValidator(this.formData.maxLength || formFieldRanges.MAX.ADDRESS_LINE1, this.formData?.errors?.maxLengthError || ''), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)])],
      addressLine2: ['', Validators.compose([gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)])],
      zipPostalCode: ['', Validators.compose([...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER32)])],
      city: ['', Validators.compose([...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsMaxLengthValidator(this.formData.maxLength || formFieldRanges.MAX.CITY, this.formData?.errors?.maxLengthError || ''), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)])],
      state: ['', Validators.compose([...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER15)])]
    });
  }
  get address() {
    return this.formData.key === 'addressLine1' ? this.getControl('addressLine1') : this.getControl('addressLine2');
  }
  get zipcode() {
    return this.getControl('zipPostalCode');
  }
  get city() {
    return this.getControl('city');
  }
  get stateValue() {
    return this.getControl('state');
  }
  get addressControl() {
    return this.getControl(this.formData.key);
  }
  getControl(control) {
    return this.addressGroup.get(control);
  }
  onValueChange(value) {
    this.addressControl?.setValue(value);
    this.updateZipPattern(value);
  }
  onBlurChange() {
    this.addressControl?.markAsTouched();
    this.addressControl?.setValue(this.addressControl.value);
  }
  static {
    this.ɵfac = function GdsAddressFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsAddressFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.UtilsService), i0.ɵɵdirectiveInject(AddressFieldService), i0.ɵɵdirectiveInject(i4.SessionStorageService), i0.ɵɵdirectiveInject(i5.GeolocationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsAddressFieldComponent,
      selectors: [["upr-gds-address-field"]],
      inputs: {
        formData: "formData",
        formDataValue: "formDataValue",
        country: "country",
        state: "state",
        isAddressComponent: "isAddressComponent",
        isZipCodeMandiory: "isZipCodeMandiory",
        optionalLabel: "optionalLabel",
        displayedInModal: "displayedInModal",
        useNativeStateDropdown: "useNativeStateDropdown",
        isCoBrandCard: "isCoBrandCard",
        theme: "theme"
      },
      outputs: {
        formReady: "formReady",
        countryChange: "countryChange",
        stateChange: "stateChange"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 4,
      vars: 4,
      consts: [[3, "formGroup"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "valueChange", "blurChange", "value", "theme", "data", "type", "errors"], [3, "valueChange", "blurChange", "data", "value", "theme", "errorMessage", "required", "displayedInModal", "isNative"]],
      template: function GdsAddressFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, GdsAddressFieldComponent_div_2_Template, 2, 7, "div", 2)(3, GdsAddressFieldComponent_div_3_Template, 2, 23, "div", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.addressGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitch", ctx.formData == null ? null : ctx.formData.controlType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "text");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "dropdown");
        }
      },
      dependencies: [i2$1.NgSwitch, i2$1.NgSwitchCase, i1.NgControlStatusGroup, i1.FormGroupDirective, i2$3.GdsInputHelperDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsAddressFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-address-field',
      standalone: false,
      template: "<div [formGroup]=\"addressGroup\">\r\n\t<div [ngSwitch]=\"formData?.controlType\">\r\n\t\t<div *ngSwitchCase=\"'text'\">\r\n\t\t\t<gds-input\r\n\t\t\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t\t\t[value]=\"addressControl?.value\"\r\n\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t[data]=\"gdsData\"\r\n\t\t\t\t[type]=\"formData?.controlType\"\r\n\t\t\t\t[errors]=\"addressControl?.errors?.message\"\r\n\t\t\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t\t\t(blurChange)=\"onBlurChange()\"\r\n\t\t\t>\r\n\t\t\t</gds-input>\r\n\t\t</div>\r\n\r\n\t\t<div *ngSwitchCase=\"'dropdown'\">\r\n\t\t\t<gds-dropdown\r\n\t\t\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t\t\t[data]=\"{\r\n\t\t\t\t\tformField: {\r\n\t\t\t\t\t\tprimaryLabel: formData?.label,\r\n\t\t\t\t\t\tsupportingText: formData?.supportingText,\r\n\t\t\t\t\t\ttooltip: formData?.tooltip,\r\n\t\t\t\t\t\tdescribedby: formData?.key + '-error'\r\n\t\t\t\t\t},\r\n\t\t\t\t\tdropdownControl: { labelIconTitleText: formData?.iconTitleText },\r\n\t\t\t\t\toptions: formData?.options,\r\n\t\t\t\t\tplaceholder: formData?.placeholder,\r\n\t\t\t\t\trequired: formData?.required,\r\n\t\t\t\t\trequiredSRText: formData?.requiredSRText\r\n\t\t\t\t}\"\r\n\t\t\t\t[value]=\"addressControl?.value\"\r\n\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t[errorMessage]=\"addressControl?.errors?.message\"\r\n\t\t\t\t[required]=\"formData?.required\"\r\n\t\t\t\t[displayedInModal]=\"displayedInModal\"\r\n\t\t\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t\t\t(blurChange)=\"onBlurChange()\"\r\n\t\t\t\t[isNative]=\"useNativeStateDropdown\"\r\n\t\t\t>\r\n\t\t\t</gds-dropdown>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2.UtilsService
  }, {
    type: AddressFieldService
  }, {
    type: i4.SessionStorageService
  }, {
    type: i5.GeolocationService
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    countryChange: [{
      type: Output
    }],
    stateChange: [{
      type: Output
    }],
    formDataValue: [{
      type: Input
    }],
    country: [{
      type: Input
    }],
    state: [{
      type: Input
    }],
    isAddressComponent: [{
      type: Input
    }],
    isZipCodeMandiory: [{
      type: Input
    }],
    optionalLabel: [{
      type: Input
    }],
    displayedInModal: [{
      type: Input
    }],
    useNativeStateDropdown: [{
      type: Input
    }],
    isCoBrandCard: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
class GdsDateFieldComponent {
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.dateChange = new EventEmitter();
    this.theme = AvailableGdsThemes[0];
    this.debounceKeyUp = debounce(value => this.onValueChange(value), 500);
    this.formFieldRanges = formFieldRanges;
  }
  ngOnInit() {
    this.isReadOnly = this.formData.readOnly || false;
    this.dateGroup = this.formBuilder.group({
      date: new FormControl('', Validators.compose([gdsMaxLengthValidator(formFieldRanges.MAX.MM_DD, this.formData?.errors?.ER4), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER4), gdsMonthDateValidator(this.formData?.errors?.ER4)]))
    });
    if (this.formData?.required) {
      this.dateGroup.addValidators(gdsRequiredValidator(this.formData?.errors?.ER26));
    }
    this.onValueChange(this.modelValue);
  }
  get dateControl() {
    return this.dateGroup.get(this.formData.key);
  }
  onValueChange(value) {
    let formattedValue = value;
    if (!!value && value.length === 2) {
      formattedValue += '/';
    }
    if (value.length >= 3 && value.indexOf('/') === -1) {
      formattedValue = value.substring(0, 2) + '/' + value.substring(2);
    }
    if (value.length > 5) {
      formattedValue = value.substring(0, 5);
    }
    this.dateControl.setValue(formattedValue);
    if (this.dateControl.valid) {
      this.dateChange.emit(formattedValue);
    } else {
      this.dateChange.emit('');
    }
  }
  onBlurChange() {
    this.dateControl?.markAsTouched();
    this.dateControl?.setValue(this.dateControl?.value);
  }
  static {
    this.ɵfac = function GdsDateFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDateFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsDateFieldComponent,
      selectors: [["upr-gds-date-field"]],
      inputs: {
        inverseLabel: "inverseLabel",
        formData: "formData",
        modelValue: "modelValue",
        theme: "theme"
      },
      outputs: {
        dateChange: "dateChange"
      },
      standalone: false,
      decls: 2,
      vars: 16,
      consts: [[3, "formGroup"], [3, "valueChange", "blurChange", "data", "value", "theme", "errors", "type"]],
      template: function GdsDateFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "gds-input", 1);
          i0.ɵɵlistener("valueChange", function GdsDateFieldComponent_Template_gds_input_valueChange_1_listener($event) {
            return ctx.onValueChange($event == null ? null : $event.detail);
          })("blurChange", function GdsDateFieldComponent_Template_gds_input_blurChange_1_listener() {
            return ctx.onBlurChange();
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.dateGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("data", i0.ɵɵpureFunction8(7, _c11, ctx.formData == null ? null : ctx.formData.label, ctx.formFieldRanges.MAX.MM_DD, ctx.isReadOnly, ctx.formData == null ? null : ctx.formData.tooltip, ctx.formData == null ? null : ctx.formData.placeholder, ctx.formData == null ? null : ctx.formData.required, (ctx.formData == null ? null : ctx.formData.inputmode) || "text", (ctx.formData == null ? null : ctx.formData.key) + "-error"))("value", ctx.dateControl == null ? null : ctx.dateControl.value)("theme", ctx.theme)("errors", ctx.dateControl == null ? null : ctx.dateControl.errors == null ? null : ctx.dateControl.errors.message)("type", ctx.formData == null ? null : ctx.formData.controlType);
          i0.ɵɵattribute("data-aui", ctx.formData == null ? null : ctx.formData.label);
        }
      },
      dependencies: [i1.NgControlStatusGroup, i1.FormGroupDirective, i2$3.GdsInputHelperDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDateFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-date-field',
      standalone: false,
      template: "<div [formGroup]=\"dateGroup\">\r\n\t<gds-input\r\n\t\tattr.data-aui=\"{{ formData?.label }}\"\r\n\t\t[data]=\"{\r\n\t\t\tprimaryLabel: formData?.label,\r\n\t\t\tmaxLength: formFieldRanges.MAX.MM_DD,\r\n\t\t\tdisabled: isReadOnly,\r\n\t\t\ttooltip: formData?.tooltip,\r\n\t\t\tplaceholder: formData?.placeholder,\r\n\t\t\trequired: formData?.required,\r\n\t\t\tinputmode: formData?.inputmode || 'text',\r\n\t\t\tdescribedby: formData?.key + '-error'\r\n\t\t}\"\r\n\t\t[value]=\"dateControl?.value\"\r\n\t\t[theme]=\"theme\"\r\n\t\t[errors]=\"dateControl?.errors?.message\"\r\n\t\t[type]=\"formData?.controlType\"\r\n\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t(blurChange)=\"onBlurChange()\"\r\n\t></gds-input>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    dateChange: [{
      type: Output
    }],
    inverseLabel: [{
      type: Input
    }],
    formData: [{
      type: Input
    }],
    modelValue: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
class GdsNameFieldComponent {
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.formReady = new EventEmitter();
    this.theme = AvailableGdsThemes[0];
  }
  ngOnInit() {
    this.isReadOnly = this.formData.readOnly || false;
    const labelRequired = this.formData.required ? ' *' : '';
    this.formData.label = trimEnd(this.formData.label, '*').trim();
    this.formData.label = `${this.formData.label}${labelRequired}`;
    this.nameGroup = this.formBuilder.group({
      firstName: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, this.formData?.required ? gdsNameValidator(this.formData?.errors?.ER26, this.formData?.errors?.maxLengthError, this.formData?.errors?.ER1) : gdsSuffixValidator(this.formData?.errors?.ER26, this.formData?.errors?.ER1)),
      middleName: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([gdsMaxLengthValidator(formFieldRanges.MAX.MIDDLE_NAME, this.formData?.errors?.maxLengthError), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER1)])),
      lastName: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, this.formData?.required ? gdsNameValidator(this.formData?.errors?.ER26, this.formData?.errors?.maxLengthError, this.formData?.errors?.ER1) : gdsSuffixValidator(this.formData?.errors?.maxLengthError, this.formData?.errors?.ER1)),
      suffix: new FormControl('', Validators.compose([gdsMaxLengthValidator(formFieldRanges.MAX.SUFFIX, this.formData?.errors?.maxLengthError), gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER1)]))
    });
    this.nameControl.setValue(this.formDataValue || this.formData?.value || '');
    this.formReady.emit(this.nameControl);
  }
  get nameControl() {
    return this.nameGroup.get(this.formData.key);
  }
  onValueChange(name) {
    const value = name ?? '';
    this.nameControl?.setValue(value);
  }
  onBlurChange() {
    this.nameControl?.markAsTouched();
    this.nameControl?.setValue(this.nameControl.value);
  }
  static {
    this.ɵfac = function GdsNameFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsNameFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsNameFieldComponent,
      selectors: [["upr-gds-name-field"]],
      inputs: {
        formData: "formData",
        formDataValue: "formDataValue",
        theme: "theme"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      decls: 2,
      vars: 18,
      consts: [[3, "formGroup"], [3, "valueChange", "blurChange", "data", "value", "theme", "errors", "type"]],
      template: function GdsNameFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "gds-input", 1);
          i0.ɵɵlistener("valueChange", function GdsNameFieldComponent_Template_gds_input_valueChange_1_listener($event) {
            return ctx.onValueChange($event == null ? null : $event.detail);
          })("blurChange", function GdsNameFieldComponent_Template_gds_input_blurChange_1_listener() {
            return ctx.onBlurChange();
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.nameGroup);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData == null ? null : ctx.formData.key, "-input");
          i0.ɵɵproperty("data", i0.ɵɵpureFunctionV(8, _c12, [ctx.formData == null ? null : ctx.formData.label, ctx.formData == null ? null : ctx.formData.supportingText, ctx.formData == null ? null : ctx.formData.tooltip, ctx.formData == null ? null : ctx.formData.placeholder, ctx.formData == null ? null : ctx.formData.maxLength, ctx.formData == null ? null : ctx.formData.required, ctx.isReadOnly, ctx.isReadOnly, (ctx.formData == null ? null : ctx.formData.key) + "-error"]))("value", ctx.nameControl == null ? null : ctx.nameControl.value)("theme", ctx.theme)("errors", ctx.nameControl == null ? null : ctx.nameControl.errors == null ? null : ctx.nameControl.errors.message)("type", ctx.formData == null ? null : ctx.formData.controlType);
        }
      },
      dependencies: [i1.NgControlStatusGroup, i1.FormGroupDirective, i2$3.GdsInputHelperDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsNameFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-name-field',
      standalone: false,
      template: "<div [formGroup]=\"nameGroup\">\r\n\t<gds-input\r\n\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t[data]=\"{\r\n\t\t\tprimaryLabel: formData?.label,\r\n\t\t\tsupportingText: formData?.supportingText,\r\n\t\t\ttooltip: formData?.tooltip,\r\n\t\t\tplaceholder: formData?.placeholder,\r\n\t\t\tmaxLength: formData?.maxLength,\r\n\t\t\trequired: formData?.required,\r\n\t\t\tdisabled: isReadOnly,\r\n\t\t\treadonly: isReadOnly,\r\n\t\t\tdescribedby: formData?.key + '-error'\r\n\t\t}\"\r\n\t\t[value]=\"nameControl?.value\"\r\n\t\t[theme]=\"theme\"\r\n\t\t[errors]=\"nameControl?.errors?.message\"\r\n\t\t[type]=\"formData?.controlType\"\r\n\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t(blurChange)=\"onBlurChange()\"\r\n\t></gds-input>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    formDataValue: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
class GdsPaymentCardFieldComponent {
  constructor(formBuilder, pipe, route, sessionStorage) {
    this.formBuilder = formBuilder;
    this.pipe = pipe;
    this.route = route;
    this.sessionStorage = sessionStorage;
    this.formReady = new EventEmitter();
    this.handleFocusEvent = new EventEmitter();
    this.handleMonthYearChange = new EventEmitter();
    this.handleInputChange = new EventEmitter();
    this.displayedInModal = false;
    this.isCoBrandCard = false;
    this.theme = AvailableGdsThemes[0];
    this.card = null;
    this.showNewCardForm = false;
    this.isSignedIn = false;
  }
  ngOnInit() {
    this.pageLabels = get(this.route.snapshot.data, 'pageLabels', []);
    this.setFormOptions();
    this.setMonthYearSelection();
    this.setCardDetailSelectionControlType('text');
    this.cardlabel = this.formData.key === 'creditCardDropdown' ? this.formData.additionalLabel : null;
    // set credit card logo for each card on page load
    this.cardType = this.sourceCardType;
    this.isReadOnly = this.formData.readOnly || false;
    this.paymentCardGroup = this.initPaymentCard();
    this.onValueChange(this.formDataValue || this.formData?.value || '');
    this.formReady.emit(this.paymentCardControl);
  }
  initPaymentCard() {
    this.requiredCardType = this.sessionStorage.getItem('required-payment-card-type');
    if (this.formData.key === 'securityCode') {
      this.cvvMaxLength = this.formData.maxLength || formFieldRanges.MAX.CVV;
      this.formData.class = 'security-code';
    }
    const pattern = this.formData.pattern1 instanceof Array ? this.formData.pattern1.join('|').replace(/[/]/g, '') : this.formData.pattern1;
    this.pattern = !!this.requiredCardType && this.requiredCardType === CardTypes.AMEX ? this.formData.pattern3_AMEX : pattern;
    return this.formBuilder.group({
      creditCardTextbox: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([gdsRequiredValidator(this.formData?.errors?.ER26), gdsMaxLengthValidator(20, this.formData?.errors?.ER34), gdsPatternValidator(this.pattern, this.formData?.errors?.ER34)])),
      creditCardDropdown: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, gdsRequiredValidator(this.formData?.errors?.ER26)),
      month: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, gdsRequiredValidator(this.formData?.errors?.ER26)),
      year: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, gdsRequiredValidator(this.formData?.errors?.ER26)),
      securityCode: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([gdsRequiredValidator(this.formData?.errors?.ER26), gdsMaxLengthValidator(20, this.formData?.errors?.ER37), gdsPatternValidator(this.pattern, this.formData?.errors?.ER37)]))
    });
  }
  setFormOptions() {
    if (this.formData.key === 'year') {
      const minYear = moment().year();
      const maxYear = minYear + 15;
      this.years = range(minYear, maxYear).map(year => {
        return {
          label: year.toString(),
          value: year.toString()
        };
      });
      this.formData.options = this.years;
    }
    if (this.formData.key === 'month') {
      this.months = range(1, 13).map(month => {
        return {
          label: padStart(month, 2, '0'),
          value: padStart(month, 2, '0')
        };
      });
      this.formData.options = this.months;
    }
  }
  transformCardType(value) {
    if (value === '' && this.formData.key === 'creditCardTextbox') {
      this.cardType = this.pipe.transform(value);
    }
    if (value !== '' && this.formData.key === 'creditCardTextbox') {
      this.cardType = this.isCoBrandCard ? CardTypes.VISA_COBRAND : this.pipe.transform(value);
      this.sessionStorage.setItem('payment-card-type', this.cardType);
    }
    if (value !== '' && this.formData.key === 'securityCode') {
      const securityCodeControl = this.paymentCardGroup.get('securityCode');
      const storedCardType = this.sourceCardType || this.sessionStorage.getItem('payment-card-type');
      if (this.cardType === CardTypes.AMEX || storedCardType === CardTypes.AMEX) {
        // amex
        const newPattern = this.formData.pattern2;
        securityCodeControl.setValidators([gdsRequiredValidator(this.formData?.errors?.ER26), gdsMaxLengthValidator(5, this.formData?.errors?.ER37), gdsPatternValidator(newPattern, this.formData?.errors?.ER37)]);
      } else {
        // not amex
        securityCodeControl.setValidators([gdsRequiredValidator(this.formData?.errors?.ER26), gdsMaxLengthValidator(5, this.formData?.errors?.ER37), gdsPatternValidator(this.pattern, this.formData?.errors?.ER37)]);
      }
      securityCodeControl.updateValueAndValidity();
    }
  }
  onCardChange(selectedCard) {
    this.card = selectedCard;
    if (!selectedCard) {
      this.showNewCardForm = true;
      return;
    }
    this.showNewCardForm = false;
    this.isCardExpired = selectedCard.isExpired;
  }
  setMonthYearSelection() {
    if (this.formData.key === 'month' || this.formData.key === 'year') {
      this.handleMonthYearChange.emit();
    }
  }
  setCardDetailSelectionControlType(type) {
    if (this.formData.key === 'securityCode' || this.formData.key === 'creditCardTextbox') {
      if (this.formData.value) {
        this.formData.controlType = type;
      }
    }
  }
  isTextOrTelField() {
    return this.formData.controlType === 'text' ? 'text' : 'tel';
  }
  get paymentCardControl() {
    return this.paymentCardGroup.get(this.formData.key);
  }
  onValueChange(value) {
    this.handleInputChange.emit(value);
    this.paymentCardControl?.setValue(value);
    this.transformCardType(value);
    this.setMonthYearSelection();
  }
  onBlurChange() {
    this.paymentCardControl?.markAsTouched();
    this.paymentCardControl?.setValue(this.paymentCardControl.value);
  }
  static {
    this.ɵfac = function GdsPaymentCardFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsPaymentCardFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2$4.CardTypePipe), i0.ɵɵdirectiveInject(i3$1.ActivatedRoute), i0.ɵɵdirectiveInject(i4.SessionStorageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsPaymentCardFieldComponent,
      selectors: [["upr-gds-payment-card-field"]],
      inputs: {
        formData: "formData",
        sourceCardType: "sourceCardType",
        displayedInModal: "displayedInModal",
        formDataValue: "formDataValue",
        isCoBrandCard: "isCoBrandCard",
        theme: "theme"
      },
      outputs: {
        formReady: "formReady",
        handleFocusEvent: "handleFocusEvent",
        handleMonthYearChange: "handleMonthYearChange",
        handleInputChange: "handleInputChange"
      },
      standalone: false,
      decls: 4,
      vars: 7,
      consts: [[3, "formGroup"], [1, "relative", 3, "ngSwitch"], ["class", "form-group", 4, "ngSwitchCase"], [1, "form-group"], [4, "ngIf"], ["data-cardinal-field", "AccountNumber", 3, "valueChange", "blurChange", "type", "data", "value", "theme", "errors", "hideSpinner", "min"], ["classes", "spacer-70"], [3, "selectedCreditCard"], ["classes", "spacer-30"], [3, "valueChange", "blurChange", "isNative", "data", "value", "theme", "errorMessage", "displayedInModal"]],
      template: function GdsPaymentCardFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, GdsPaymentCardFieldComponent_div_2_Template, 4, 19, "div", 2)(3, GdsPaymentCardFieldComponent_div_3_Template, 3, 15, "div", 2);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.formData == null ? null : ctx.formData.class);
          i0.ɵɵproperty("formGroup", ctx.paymentCardGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitch", ctx.formData == null ? null : ctx.formData.controlType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", ctx.isTextOrTelField());
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "dropdown");
        }
      },
      dependencies: [i2$1.NgIf, i2$1.NgSwitch, i2$1.NgSwitchCase, i1.NgControlStatusGroup, i1.FormGroupDirective, i2$3.GdsInputHelperDirective],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.security-code[_ngcontent-%COMP%]{display:flex;width:100%}@media screen and (min-width: 75em){.security-code[_ngcontent-%COMP%]{max-width:312px}}.group-field[_ngcontent-%COMP%]{display:inline-block;margin-right:16px;width:100%;vertical-align:top}@media screen and (min-width: 75em){.group-field[_ngcontent-%COMP%]{max-width:312px;display:inline-block;margin-right:16px}}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsPaymentCardFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-payment-card-field',
      standalone: false,
      template: "<div [formGroup]=\"paymentCardGroup\" class=\"{{ formData?.class }}\">\r\n\t<div class=\"relative\" [ngSwitch]=\"formData?.controlType\">\r\n\t\t<div class=\"form-group\" *ngSwitchCase=\"isTextOrTelField()\">\r\n\t\t\t<div *ngIf=\"formData?.key === 'creditCardTextbox'\">\r\n\t\t\t\t<gds-credit-card-icon-row\r\n\t\t\t\t\t[selectedCreditCard]=\"cardType\"\r\n\t\t\t\t></gds-credit-card-icon-row>\r\n\t\t\t\t<gds-spacer classes=\"spacer-30\"></gds-spacer>\r\n\t\t\t</div>\r\n\r\n\t\t\t<gds-input\r\n\t\t\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t\t\tdata-cardinal-field=\"AccountNumber\"\r\n\t\t\t\t[type]=\"formData?.controlType\"\r\n\t\t\t\t[data]=\"{\r\n\t\t\t\t\tprimaryLabel: formData?.label,\r\n\t\t\t\t\ttooltip: formData?.tooltip,\r\n\t\t\t\t\tmaxlength: cvvMaxLength,\r\n\t\t\t\t\tinputmode: formData?.inputmode || 'text',\r\n\t\t\t\t\tautocomplete: formData?.autocomplete || 'off',\r\n\t\t\t\t\treadonly: formData?.readOnly,\r\n\t\t\t\t\tdescribedby: formData?.key + '-error',\r\n\t\t\t\t\trequired: formData?.required\r\n\t\t\t\t}\"\r\n\t\t\t\t[value]=\"paymentCardControl?.value\"\r\n\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t[errors]=\"paymentCardControl?.errors?.message\"\r\n\t\t\t\t[hideSpinner]=\"true\"\r\n\t\t\t\t[min]=\"0\"\r\n\t\t\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t\t\t(blurChange)=\"onBlurChange()\"\r\n\t\t\t></gds-input>\r\n\r\n\t\t\t<gds-spacer classes=\"spacer-70\"></gds-spacer>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"form-group\" *ngSwitchCase=\"'dropdown'\">\r\n\t\t\t<gds-dropdown\r\n\t\t\t\t[isNative]=\"true\"\r\n\t\t\t\t[data]=\"{\r\n\t\t\t\t\tformField: {\r\n\t\t\t\t\t\tprimaryLabel: formData.label,\r\n\t\t\t\t\t\tdescribedby: formData.key + '-error'\r\n\t\t\t\t\t},\r\n\t\t\t\t\toptions: formData?.options,\r\n\t\t\t\t\tplaceholder: formData?.placeholder,\r\n\t\t\t\t\trequired: formData?.required,\r\n\t\t\t\t\trequiredSRText: formData?.requiredSRText\r\n\t\t\t\t}\"\r\n\t\t\t\t[value]=\"paymentCardControl?.value\"\r\n\t\t\t\t[theme]=\"theme\"\r\n\t\t\t\t[errorMessage]=\"paymentCardControl?.errors?.message\"\r\n\t\t\t\t[displayedInModal]=\"displayedInModal\"\r\n\t\t\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t\t\t(blurChange)=\"onBlurChange()\"\r\n\t\t\t></gds-dropdown>\r\n\t\t\t<gds-spacer classes=\"spacer-70\"></gds-spacer>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.security-code{display:flex;width:100%}@media screen and (min-width: 75em){.security-code{max-width:312px}}.group-field{display:inline-block;margin-right:16px;width:100%;vertical-align:top}@media screen and (min-width: 75em){.group-field{max-width:312px;display:inline-block;margin-right:16px}}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2$4.CardTypePipe
  }, {
    type: i3$1.ActivatedRoute
  }, {
    type: i4.SessionStorageService
  }], {
    formReady: [{
      type: Output
    }],
    handleFocusEvent: [{
      type: Output
    }],
    handleMonthYearChange: [{
      type: Output
    }],
    handleInputChange: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    sourceCardType: [{
      type: Input
    }],
    displayedInModal: [{
      type: Input
    }],
    formDataValue: [{
      type: Input
    }],
    isCoBrandCard: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
class GdsPhoneFieldComponent {
  constructor(fb) {
    this.fb = fb;
    this.formReady = new EventEmitter();
    this.theme = AvailableGdsThemes[0];
    this.transformedInput = '';
  }
  ngOnInit() {
    this.isReadOnly = this.formData.readOnly || false;
    const validators = [gdsPatternValidator(this.formData.pattern1, this.formData?.errors?.ER41)];
    if (!!this.formData.required) {
      validators.push(gdsRequiredValidator(this.formData?.errors?.ER26));
    }
    this.requiredLabel();
    this.phoneGroup = this.fb.group({
      phone: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose(validators))
    });
    this.onValueChange(this.formDataValue || this.formData?.value || '');
    this.formReady.emit(this.phoneControl);
  }
  ngOnChanges(changes) {
    this.requiredLabel();
    if (this.phoneGroup && this.phoneControl && this.phoneControl.value && this.countryName && changes.countryName?.currentValue !== changes.countryName?.previousValue) {
      this.updatePhonePattern(this.phoneControl.value);
    }
  }
  updatePhonePattern(value) {
    if (!value) {
      return;
    }
    const phoneControl = this.phoneGroup.get('phone');
    this.transformedInput = value.replace(/[\(\)\ \-]/g, '');
    const validators = [gdsPhoneNumericValidator(this.countryName, this.formData?.errors?.ER5)];
    this.isCountryUSA = !!this.countryName && this.countryName.toString().toLowerCase() === 'us';
    if (value && !!this.countryName && this.countryName.toString().toLowerCase() === 'us' || this.country === formFieldRanges.PHONE.USA_COUNTRY_CODE) {
      validators.push(gdsPatternValidator(PhonePattern.PHONE, this.formData?.errors?.ER41));
      validators.push(gdsMinLengthValidator(formFieldRanges.MIN.USA_PHONE, this.formData?.errors?.ER41));
      this.formatTransformedInput(this.transformedInput);
    } else if (this.country === formFieldRanges.PHONE.ANY_COUNTRY_CODE) {
      validators.push(gdsMaxLengthValidator(formFieldRanges.MAX.PHONE, this.formData?.errors?.ER41));
      validators.push(gdsMinLengthValidator(formFieldRanges.MIN.NON_USA_PHONE, this.formData?.errors?.minLengthError));
      validators.push(gdsPatternValidator(PhonePattern.PHONE_ANY, this.formData?.errors?.nonUSNumberError));
    } else {
      validators.push(gdsMaxLengthValidator(formFieldRanges.MAX.PHONE, this.formData?.errors?.maxLengthError));
      validators.push(gdsMinLengthValidator(formFieldRanges.MIN.NON_USA_PHONE, this.formData?.errors?.minLengthError));
      validators.push(gdsPatternValidator(PhonePattern.NON_US_PHONE, this.formData?.errors?.nonUSNumberError));
    }
    if (!!this.formData.required) {
      validators.push(gdsRequiredValidator(this.formData?.errors?.ER26));
    }
    phoneControl.setValidators(validators);
    phoneControl.updateValueAndValidity();
  }
  formatTransformedInput(value) {
    const inputValue = value.toString().trim().replace(NumberCharPattern.START_WITH_PLUS, '');
    let city = '';
    let numberValue = '';
    if (inputValue.match(NumberCharPattern.NUMBER)) {
      this.transformedInput = value;
    }
    switch (inputValue.length) {
      case 1:
      case 2:
      case 3:
        city = inputValue;
        break;
      default:
        city = inputValue.slice(0, 3);
        numberValue = inputValue.slice(3);
        break;
    }
    if (!numberValue) {
      this.transformedInput = `(${city}`;
      return;
    }
    if (numberValue.length > 3 && inputValue.length < 11) {
      numberValue = numberValue.slice(0, 3) + `-` + numberValue.slice(3, 7);
      const cityValue = `(${city})`;
      this.transformedInput = `${(cityValue + ' ' + numberValue).trim()}`;
    } else if (numberValue.length > 0 && numberValue.length <= 3 && inputValue.length < 11) {
      numberValue = numberValue.slice(0, numberValue.length);
      const cityValue = `(${city})`;
      this.transformedInput = `${(cityValue + ' ' + numberValue).trim()}`;
    } else {
      this.transformedInput = value;
    }
    this.phoneControl.setValue(this.transformedInput);
  }
  get phoneControl() {
    return this.phoneGroup.get(this.formData.key);
  }
  onValueChange(value) {
    this.phoneControl?.setValue(value);
    this.updatePhonePattern(value);
  }
  onBlurChange() {
    this.phoneControl?.markAsTouched();
    this.phoneControl?.setValue(this.phoneControl.value);
    this.phoneControl.updateValueAndValidity();
  }
  requiredLabel() {
    const labelRequired = this.formData.required ? ' *' : '';
    this.formData.label = trimEnd(this.formData.label, '*').trim();
    this.formData.label = `${this.formData.label}${labelRequired}`;
  }
  static {
    this.ɵfac = function GdsPhoneFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsPhoneFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsPhoneFieldComponent,
      selectors: [["upr-gds-phone-field"]],
      inputs: {
        formData: "formData",
        countryName: "countryName",
        formDataValue: "formDataValue",
        minLength: "minLength",
        pattern: "pattern",
        theme: "theme"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 20,
      consts: [[1, "phone-group", 3, "formGroup"], [3, "valueChange", "blurChange", "data", "type", "value", "theme", "errors"]],
      template: function GdsPhoneFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "gds-input", 1);
          i0.ɵɵlistener("valueChange", function GdsPhoneFieldComponent_Template_gds_input_valueChange_1_listener($event) {
            return ctx.onValueChange($event == null ? null : $event.detail);
          })("blurChange", function GdsPhoneFieldComponent_Template_gds_input_blurChange_1_listener() {
            return ctx.onBlurChange();
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.phoneGroup);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData == null ? null : ctx.formData.key, "-input");
          i0.ɵɵproperty("data", i0.ɵɵpureFunctionV(8, _c16, [ctx.formData == null ? null : ctx.formData.label, ctx.formData == null ? null : ctx.formData.supportingText, ctx.formData == null ? null : ctx.formData.optionalLabel, ctx.formData == null ? null : ctx.formData.tooltip, ctx.formData == null ? null : ctx.formData.placeholder, ctx.pattern, ctx.formData == null ? null : ctx.formData.required, ctx.isReadOnly, ctx.isReadOnly, ((ctx.formData == null ? null : ctx.formData.optionalLabel) ? (ctx.formData == null ? null : ctx.formData.label) + " " + (ctx.formData == null ? null : ctx.formData.optionalLabel) : ctx.formData == null ? null : ctx.formData.label) || "Phone", (ctx.formData == null ? null : ctx.formData.key) + "-error"]))("type", ctx.formData == null ? null : ctx.formData.controlType)("value", ctx.phoneControl == null ? null : ctx.phoneControl.value)("theme", ctx.theme)("errors", ctx.phoneControl == null ? null : ctx.phoneControl.errors == null ? null : ctx.phoneControl.errors.message);
        }
      },
      dependencies: [i1.NgControlStatusGroup, i1.FormGroupDirective, i2$3.GdsInputHelperDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsPhoneFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-phone-field',
      standalone: false,
      template: "<div [formGroup]=\"phoneGroup\" class=\"phone-group\">\r\n\t<gds-input\r\n\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t[data]=\"{\r\n\t\t\tprimaryLabel: formData?.label,\r\n\t\t\tsupportingText: formData?.supportingText,\r\n\t\t\tsecondaryLabel: formData?.optionalLabel,\r\n\t\t\ttooltip: formData?.tooltip,\r\n\t\t\tplaceholder: formData?.placeholder,\r\n\t\t\tpattern: pattern,\r\n\t\t\trequired: formData?.required,\r\n\t\t\tdisabled: isReadOnly,\r\n\t\t\treadonly: isReadOnly,\r\n\t\t\tariaText:\r\n\t\t\t\t(formData?.optionalLabel\r\n\t\t\t\t\t? formData?.label + ' ' + formData?.optionalLabel\r\n\t\t\t\t\t: formData?.label) || 'Phone',\r\n\t\t\tdescribedby: formData?.key + '-error'\r\n\t\t}\"\r\n\t\t[type]=\"formData?.controlType\"\r\n\t\t[value]=\"phoneControl?.value\"\r\n\t\t[theme]=\"theme\"\r\n\t\t[errors]=\"phoneControl?.errors?.message\"\r\n\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t(blurChange)=\"onBlurChange()\"\r\n\t></gds-input>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    countryName: [{
      type: Input
    }],
    formDataValue: [{
      type: Input
    }],
    minLength: [{
      type: Input
    }],
    pattern: [{
      type: Input
    }],
    theme: [{
      type: Input
    }]
  });
})();
let _nextNameFieldUniqueId = 0;
class NameFieldComponent {
  get fieldValue() {
    return this.formDataValue || this.formData.value;
  }
  set fieldValue(value) {
    if (this.formDataValue !== undefined) {
      this.formDataValue = value;
    } else {
      this.formData.value = value;
    }
  }
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.formReady = new EventEmitter();
    this._nameFieldUniqueId = _nextNameFieldUniqueId++;
  }
  ngOnInit() {
    this.isReadOnly = this.formData.readOnly || false;
    this.nameGroup = this.formBuilder.group({
      firstName: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.maxLength(formFieldRanges.MAX.FIRST_NAME), Validators.pattern(this.formData.pattern1)])),
      middleName: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.maxLength(formFieldRanges.MAX.MIDDLE_NAME), Validators.pattern(this.formData.pattern1)])),
      lastName: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.maxLength(formFieldRanges.MAX.LAST_NAME), Validators.pattern(this.formData.pattern1)]))
    });
    this.formReady.emit(this.getControl(this.formData.key));
  }
  ngOnDestroy() {
    this._nameFieldUniqueId = _nextNameFieldUniqueId = 0;
  }
  get name() {
    return this.nameGroup.get(this.formData.key);
  }
  get id() {
    return this.formData.key + '-' + this._nameFieldUniqueId;
  }
  getControl(control) {
    return this.nameGroup.get(control);
  }
  updateNameFieldValue(name) {
    this.formDataValue = this.formData.value = (name || '').trim();
  }
  static {
    this.ɵfac = function NameFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || NameFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NameFieldComponent,
      selectors: [["upr-name-field"]],
      inputs: {
        formData: "formData",
        formDataValue: "formDataValue"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      decls: 5,
      vars: 15,
      consts: [[3, "formGroup"], [1, "required"], [3, "ngModelChange", "formControlName", "id", "type", "placeholder", "maxlength", "minlength", "required", "ngModel"], ["class", "error", "role", "alert", "data-aui", "error-message", 4, "ngIf"], ["role", "alert", "data-aui", "error-message", 1, "error"], [1, "sr-only", 3, "id"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "id", 4, "ngIf"], [3, "id"]],
      template: function NameFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
          i0.ɵɵtext(2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "input", 2);
          i0.ɵɵtwoWayListener("ngModelChange", function NameFieldComponent_Template_input_ngModelChange_3_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.fieldValue, $event) || (ctx.fieldValue = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function NameFieldComponent_Template_input_ngModelChange_3_listener($event) {
            return ctx.updateNameFieldValue($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(4, NameFieldComponent_div_4_Template, 7, 6, "div", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.nameGroup);
          i0.ɵɵadvance();
          i0.ɵɵattribute("data-aui", ctx.formData.label)("for", ctx.id);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.formData.label);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData.key, "-input");
          i0.ɵɵproperty("formControlName", ctx.formData.key)("id", ctx.id)("type", ctx.formData.controlType)("placeholder", ctx.formData.placeholder)("maxlength", ctx.formData == null ? null : ctx.formData.maxLength)("minlength", ctx.formData == null ? null : ctx.formData.minLength)("required", ctx.formData == null ? null : ctx.formData.required);
          i0.ɵɵtwoWayProperty("ngModel", ctx.fieldValue);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx.name == null ? null : ctx.name.invalid) && (ctx.name == null ? null : ctx.name.touched));
        }
      },
      dependencies: [i2$1.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.MinLengthValidator, i1.MaxLengthValidator, i1.FormGroupDirective, i1.FormControlName],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NameFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-name-field',
      standalone: false,
      template: "<div [formGroup]=\"nameGroup\">\r\n\t<label\r\n\t\tattr.data-aui=\"{{ formData.label }}\"\r\n\t\t[attr.for]=\"id\"\r\n\t\tclass=\"required\"\r\n\t\t>{{ formData.label }}</label\r\n\t>\r\n\t<input\r\n\t\tattr.data-aui=\"{{ formData.key }}-input\"\r\n\t\t[formControlName]=\"formData.key\"\r\n\t\t[id]=\"id\"\r\n\t\t[type]=\"formData.controlType\"\r\n\t\t[placeholder]=\"formData.placeholder\"\r\n\t\t[maxlength]=\"formData?.maxLength\"\r\n\t\t[minlength]=\"formData?.minLength\"\r\n\t\t[required]=\"formData?.required\"\r\n\t\t[(ngModel)]=\"fieldValue\"\r\n\t\t(ngModelChange)=\"updateNameFieldValue($event)\"\r\n\t/>\r\n\t<div\r\n\t\tclass=\"error\"\r\n\t\trole=\"alert\"\r\n\t\t*ngIf=\"name?.invalid && name?.touched\"\r\n\t\tdata-aui=\"error-message\"\r\n\t\t[attr.aria-describedby]=\"id + '-field' + ' ' + id + '-requiredError' + ' ' + id + '-maxLengthError' + ' ' + id + '-patternError'\"\r\n\t>\r\n\t\t<span class=\"sr-only\" [id]=\"id+'-field'\">{{formData.label}} </span>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small\r\n\t\t\t[id]=\"id+'-requiredError'\"\r\n\t\t\t*ngIf=\"name?.errors?.required\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t>\r\n\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t[id]=\"id+'-maxLengthError'\"\r\n\t\t\t*ngIf=\"name?.errors?.maxlength\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t>\r\n\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t[id]=\"id+'-patternError'\"\r\n\t\t\t*ngIf=\"name?.errors?.pattern\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t>\r\n\t\t\t{{ formData?.errors?.ER1 }}\r\n\t\t</small>\r\n\t</div>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    formDataValue: [{
      type: Input
    }]
  });
})();
class PasswordFieldComponent {
  constructor(fb) {
    this.fb = fb;
    this.minLength = formFieldRanges.MIN.PASSWORD;
    this.maxLength = formFieldRanges.MAX.PASSWORD;
    this.repeatedChars = false;
    this.requiredLabel = '';
    this.formReady = new EventEmitter();
    this.customIconClick = new EventEmitter();
    this.sameAsEmail = false;
    this.showPassword = false;
    this.showNotOnlyUpper = false;
  }
  ngOnInit() {
    this.getLabel();
    this.flagColors = this.formData.colors;
    this.flagStrength = this.formData.strength;
    this.passwordGroup = this.fb.group({
      passwordText: new FormControl('', Validators.compose([Validators.required, Validators.pattern(this.formData.pattern1)])),
      passwordExt: new FormControl('', Validators.compose([Validators.required, Validators.pattern(this.formData.pattern1)])),
      passwordValid: new FormControl('', Validators.compose([Validators.required, Validators.pattern(this.formData.pattern1)]))
    });
    this.formReady.emit(this.password);
  }
  getLabel() {
    if (!this.formData) {
      this.requiredLabel = '';
      return;
    }
    if (this.formData.required) {
      // avoid multiple *
      const label = trimEnd(this.formData.label, '*');
      this.requiredLabel = `${label} *`;
      return;
    }
    this.requiredLabel = this.formData.label;
  }
  isCapsOn(e) {
    const code = String.fromCharCode(e.which);
    if (code.toUpperCase() === code && code.toLowerCase() !== code && !e.shiftKey) {
      return true;
    }
    return false;
  }
  togglePassword() {
    if (this.passwordToggle) {
      this.showPassword = !this.showPassword;
      if (this.customIcon) {
        this.customIconClick.emit(this.showPassword);
      }
    }
  }
  onKeyPress(event) {
    let charCode = false;
    if (event.which) {
      charCode = event.which;
    } else if (event.keyCode) {
      charCode = event.keyCode;
    }
    if (charCode >= 97 && charCode <= 122 || charCode >= 65 && charCode <= 90) {
      this.showCaps = this.isCapsOn(event);
    }
  }
  checkValidPassword(event) {
    this.inputVal = event;
    this.isSpaceExists = this.checkSpace(this.inputVal);
    const withLetterRegex = new RegExp(NumberCharPattern.WITH_LETTER),
      withNumberRegex = new RegExp(NumberCharPattern.WITH_NUMBER),
      withSymbolRegex = new RegExp(NumberCharPattern.WITH_SPECIAL_CHAR),
      withLowerLetterRegex = new RegExp(NumberCharPattern.WITH_LOWER_LETTER),
      withUpperLetterRegex = new RegExp(NumberCharPattern.WITH_UPPER_LETTER),
      withOnlyUpperRegex = new RegExp(NumberCharPattern.WITH_ONLY_UPPER);
    this.showValidationLetter = withLetterRegex.test(this.inputVal);
    this.showValidationNumber = withNumberRegex.test(this.inputVal);
    this.showValidationSymbol = withSymbolRegex.test(this.inputVal);
    this.showValidationLower = withLowerLetterRegex.test(this.inputVal);
    this.showValidationUpper = withUpperLetterRegex.test(this.inputVal);
    this.showNotOnlyUpper = withOnlyUpperRegex.test(this.inputVal);
    const flagCount = [this.showValidationLower, this.showValidationNumber, this.showValidationSymbol, this.showValidationUpper];
    this.sameAsEmail = !!this.emailValue && this.emailValue === this.inputVal;
    this.strengthIndex = this.measurePasswordStrength(this.inputVal, flagCount);
    this.pwdStrength = this.strengthIndex.passwordStrength;
    this.strengthCol = this.strengthIndex.col;
    if (this.strengthCol && this.pwdStrength) {
      this.isFirst = true;
    } else {
      this.isFirst = false;
    }
    if (this.isSpaceExists || this.sameAsEmail || this.showNotOnlyUpper) {
      this.password.setErrors({
        pattern: true
      });
      this.passwordGroup.updateValueAndValidity();
    }
    this.validateRepeatedChars(this.inputVal);
  }
  measurePasswordStrength(passwordValue, flagCount) {
    let passedMatches = 0,
      pwdForce = 0,
      strengthIdx = 0;
    const flagColors = this.flagColors;
    const flagStrength = this.flagStrength;
    for (const val of flagCount) {
      if (val === true) {
        passedMatches++;
      }
    }
    pwdForce += 2 * passwordValue.length + (passwordValue.length >= formFieldRanges.PASSWORDS.PASSWORD_LENGTH_INDEX ? 1 : 0);
    pwdForce += passedMatches * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR;
    pwdForce = passwordValue.length < formFieldRanges.MIN.PASSWORD ? Math.min(pwdForce, 10) : pwdForce;
    pwdForce = passedMatches === 1 ? Math.min(pwdForce, 1 * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR) : pwdForce;
    pwdForce = passedMatches === 2 ? Math.min(pwdForce, 2 * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR) : pwdForce;
    pwdForce = passedMatches === 3 ? Math.min(pwdForce, 4 * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR) : pwdForce;
    if (pwdForce <= 1 * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR) {
      strengthIdx = 0;
    } else if (pwdForce <= 2 * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR) {
      strengthIdx = 1;
    } else if (pwdForce <= 3 * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR) {
      strengthIdx = 2;
    } else if (pwdForce <= 4 * formFieldRanges.PASSWORDS.PASSWORD_FORCE_FACTOR) {
      strengthIdx = 3;
    } else {
      strengthIdx = 4;
    }
    return {
      idx: strengthIdx + 1,
      col: flagColors[strengthIdx],
      passwordStrength: flagStrength[strengthIdx]
    };
  }
  onChange(event) {
    const inputVal = event;
    this.isSpaceExists = this.checkSpace(inputVal);
    this.validateRepeatedChars(inputVal);
  }
  onChangeEvent(val) {
    if (val !== '') {
      for (let i = 0; i < val.length; i++) {
        this.repeatedChars = val.indexOf(val[i] === val.lastIndexOf(val[i]));
      }
    } else {
      this.repeatedChars = false;
    }
  }
  validateRepeatedChars(val) {
    const repeatedCharsRegex = new RegExp(EmailPasswordPattern.PASSWORD_REPEATEDCHAR_REGEX);
    this.repeatedChars = repeatedCharsRegex.test(val);
    if (this.repeatedChars) {
      this.password.setErrors({
        RepeatedChars: true
      });
    } else {
      this.passwordGroup.updateValueAndValidity();
    }
  }
  get Color() {
    return this.strengthCol;
  }
  get DefaultColor() {
    return formFieldRanges.PASSWORDS.DEFAULT_BACKGROUND;
  }
  get password() {
    return this.passwordGroup.get(this.formData.key);
  }
  checkSpace(inputVal) {
    return !!inputVal && inputVal.indexOf(' ') > -1;
  }
  static {
    this.ɵfac = function PasswordFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PasswordFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PasswordFieldComponent,
      selectors: [["upr-password-field"]],
      inputs: {
        formData: "formData",
        emailValue: "emailValue",
        passwordToggle: "passwordToggle",
        customIcon: "customIcon"
      },
      outputs: {
        formReady: "formReady",
        customIconClick: "customIconClick"
      },
      standalone: false,
      ngContentSelectors: _c17,
      decls: 13,
      vars: 6,
      consts: [["iconTpl", ""], ["defaultIconTpl", ""], ["customIconContentTpl", ""], ["customIconTpl", ""], [3, "formGroup"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["class", "create-account-password", 4, "ngSwitchCase"], ["aria-live", "polite", "id", "strength-info"], ["class", "green", 3, "ngStyle", "innerHTML", 4, "ngIf"], [1, "required", 3, "for", "innerHtml"], ["aria-controls", "strength-info", "required", "", 3, "keypress", "formControlName", "id", "type", "ngClass"], [4, "ngIf"], ["class", "error", "role", "alert", 4, "ngIf"], [4, "ngTemplateOutlet"], ["role", "alert", 1, "error"], [1, "sr-only", 3, "id"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "id", "innerHtml", 4, "ngIf"], [3, "id", "innerHtml"], ["for", "password", 3, "id", "innerHtml"], [1, "create-account-password"], ["data-aui", "create-account-password-input", "aria-controls", "strength-info", "required", "", 1, "password-with-lock", 3, "ngModelChange", "formControlName", "id", "type"], [3, "ngIf"], ["id", "elementMeter"], [1, "password-strength"], ["class", "strength-meter", 3, "ngStyle", 4, "ngFor", "ngForOf"], [1, "strength-meter", 3, "ngStyle"], ["required", "", 3, "ngModelChange", "formControlName", "id", "type", "ngClass"], [1, "green", 3, "ngStyle", "innerHTML"], [4, "ngIf", "ngIfElse"], [1, "icon", "password-lock", 3, "click", "ngClass"], [1, "custom-icon", 3, "click"]],
      template: function PasswordFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
          i0.ɵɵtemplate(2, PasswordFieldComponent_div_2_Template, 5, 12, "div", 6)(3, PasswordFieldComponent_div_3_Template, 6, 8, "div", 7)(4, PasswordFieldComponent_div_4_Template, 5, 13, "div", 6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 8);
          i0.ɵɵtemplate(6, PasswordFieldComponent_div_6_Template, 1, 4, "div", 9);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(7, PasswordFieldComponent_ng_template_7_Template, 3, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, PasswordFieldComponent_ng_template_9_Template, 1, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, PasswordFieldComponent_ng_template_11_Template, 2, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.passwordGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitch", ctx.formData == null ? null : ctx.formData.key);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "passwordText");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "passwordExt");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "passwordValid");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.isFirst && ctx.inputVal !== "");
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgForOf, i2$1.NgIf, i2$1.NgTemplateOutlet, i2$1.NgStyle, i2$1.NgSwitch, i2$1.NgSwitchCase, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.FormGroupDirective, i1.FormControlName],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.field-validation-error[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline-block;margin-right:-15px;margin-right:-.9375rem;padding:10px 15px;padding:.625rem .9375rem;background:#e61b23;clear:both;color:#fff;position:relative;font-size:12px;font-size:.75rem;line-height:15px;line-height:.9375rem}.pointer[_ngcontent-%COMP%]{cursor:pointer}.strength-meter[_ngcontent-%COMP%]{background:#ddd;border-radius:4px;display:inline-block;height:6px;margin-right:3px;width:12%}.custom-icon[_ngcontent-%COMP%], .password-lock[_ngcontent-%COMP%]{position:relative;font-size:1.2em;float:right;color:#797a7d;top:-56px;right:10px}.password-lock[_ngcontent-%COMP%]{margin:10px 0 0 -25px;pointer-events:none}.password-section[_ngcontent-%COMP%]{position:relative}.password-strength[_ngcontent-%COMP%]{margin:0}.create-account-password[_ngcontent-%COMP%]{margin-bottom:10px}.create-account-password[_ngcontent-%COMP%]   .password-with-lock[_ngcontent-%COMP%]{margin-bottom:0!important}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PasswordFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-password-field',
      standalone: false,
      template: "<div [formGroup]=\"passwordGroup\">\r\n\t<div [ngSwitch]=\"formData?.key\">\r\n\t\t<div *ngSwitchCase=\"'passwordText'\">\r\n\t\t\t<label\r\n\t\t\t\t[for]=\"formData?.key\"\r\n\t\t\t\t[innerHtml]=\"requiredLabel\"\r\n\t\t\t\tclass=\"required\"\r\n\t\t\t></label>\r\n\t\t\t<input\r\n\t\t\t\t[formControlName]=\"formData?.key\"\r\n\t\t\t\t[id]=\"formData?.key\"\r\n\t\t\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t\t\t[type]=\"passwordToggle && showPassword ? 'text' : 'password'\"\r\n\t\t\t\t(keypress)=\"onKeyPress($event)\"\r\n\t\t\t\t[ngClass]=\"{ 'password-with-lock': passwordToggle }\"\r\n\t\t\t\taria-controls=\"strength-info\"\r\n\t\t\t\trequired\r\n\t\t\t/>\r\n\r\n\t\t\t<ng-container *ngIf=\"passwordToggle\">\r\n\t\t\t\t<ng-container *ngTemplateOutlet=\"iconTpl\"></ng-container>\r\n\t\t\t</ng-container>\r\n\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"(password.invalid || isSpaceExists) && password.touched\"\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t[attr.aria-describedby]=\"formData?.key + '-field' + ' '\r\n+ formData?.key + '-requiredError' + ' '\r\n+ formData?.key + '-patternError' + ' '\r\n+ formData?.key + '-capsError' + ' '\r\n+ formData?.key + '-spaceError' + ' '\r\n\"\r\n\t\t\t>\r\n\t\t\t\t<span class=\"sr-only\" [id]=\"formData?.key+'-field'\">{{requiredLabel}} </span>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"formData?.key + '-requiredError'\"\r\n\t\t\t\t\t*ngIf=\"password?.errors?.required\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t[id]=\"formData?.key + 'patternError'\"\r\n\t\t\t\t\t*ngIf=\"password?.errors?.pattern\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER9\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small *ngIf=\"showCaps\">\r\n\t\t\t\t\t<span\r\n\t\t\t\t\t\t[id]=\"formData?.key + '-capsError'\"\r\n\t\t\t\t\t\tfor=\"password\"\r\n\t\t\t\t\t\t[innerHtml]=\"formData?.errors?.CONST_PASSWORD_CAP\"\r\n\t\t\t\t\t></span>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small *ngIf=\"isSpaceExists\" [id]=\"formData?.key + '-spaceError'\" [innerHtml]=\"formData?.errors?.ER113\">\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div *ngSwitchCase=\"'passwordExt'\" class=\"create-account-password\">\r\n\t\t\t<label\r\n\t\t\t\t[for]=\"formData?.key\"\r\n\t\t\t\t[innerHtml]=\"requiredLabel\"\r\n\t\t\t\tclass=\"required\"\r\n\t\t\t></label>\r\n\t\t\t<input\r\n\t\t\t\t[formControlName]=\"formData?.key\"\r\n\t\t\t\t[id]=\"formData?.key\"\r\n\t\t\t\t[type]=\"passwordToggle && showPassword ? 'text' : 'password'\"\r\n\t\t\t\tdata-aui=\"create-account-password-input\"\r\n\t\t\t\t(ngModelChange)=\"checkValidPassword($event)\"\r\n\t\t\t\tclass=\"password-with-lock\"\r\n\t\t\t\taria-controls=\"strength-info\"\r\n\t\t\t\trequired\r\n\t\t\t/>\r\n\t\t\t<ng-container *ngTemplateOutlet=\"defaultIconTpl\"></ng-container>\r\n\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"\r\n\t\t\t\t\t(password.invalid || isSpaceExists || sameAsEmail) && password.touched\r\n\t\t\t\t\"\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t[attr.aria-describedby]=\"formData?.key + '-field' + ' '\r\n+ formData?.key + '-requiredError' + ' '\r\n+ formData?.key + '-patternError' + ' '\r\n+ formData?.key + '-repeatedCharsError' + ' '\r\n+ formData?.key + '-capsError' + ' '\r\n+ formData?.key + '-spaceError' + ' '\r\n+ formData?.key + '-notOnlyUpperError' + ' '\r\n+ formData?.key + '-sameAsEmailError' + ' '\r\n\"\r\n\t\t\t>\r\n\t\t\t\t<span class=\"sr-only\" [id]=\"formData?.key+'-field'\">{{requiredLabel}} </span>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"password?.errors?.required\"\r\n\t\t\t\t\t[id]=\"formData?.key + '-requiredError'\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"password?.errors?.pattern && !repeatedChars\"\r\n\t\t\t\t\t[id]=\"formData?.key + '-patternError'\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER9\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"repeatedChars\"\r\n\t\t\t\t\t[id]=\"formData?.key + '-repeatedCharsError'\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER51\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small *ngIf=\"showCaps\">\r\n\t\t\t\t\t<span\r\n\t\t\t\t\t\tfor=\"password\"\r\n\t\t\t\t\t\t[id]=\"formData?.key + '-capsError'\"\r\n\t\t\t\t\t\t[innerHtml]=\"formData?.errors?.CONST_PASSWORD_CAP\"\r\n\t\t\t\t\t></span>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small *ngIf=\"isSpaceExists\"  [id]=\"formData?.key + '-spaceError'\" [innerHtml]=\"formData?.errors?.ER113\">\r\n\t\t\t\t</small>\r\n\t\t\t\t<small *ngIf=\"showNotOnlyUpper\" [id]=\"formData?.key + '-notOnlyUpperError'\" [innerHtml]=\"formData?.errors?.['upr.com.errors.form.password.uppercase']\">\r\n\t\t\t\t</small>\r\n\t\t\t\t<small *ngIf=\"sameAsEmail\" [id]=\"formData?.key + '-sameAsEmailError'\" [innerHtml]=\"formData?.errors?.ER60\">\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\r\n\t\t\t<ng-template [ngIf]=\"isFirst && inputVal !== ''\">\r\n\t\t\t\t<div id=\"elementMeter\">\r\n\t\t\t\t\t<ul class=\"password-strength\">\r\n\t\t\t\t\t\t<li\r\n\t\t\t\t\t\t\t*ngFor=\"let color of flagColors; let i = index\"\r\n\t\t\t\t\t\t\tclass=\"strength-meter\"\r\n\t\t\t\t\t\t\t[ngStyle]=\"{\r\n\t\t\t\t\t\t\t\t'background-color': strengthIndex.idx > i ? Color : DefaultColor\r\n\t\t\t\t\t\t\t}\"\r\n\t\t\t\t\t\t></li>\r\n\t\t\t\t\t</ul>\r\n\t\t\t\t</div>\r\n\t\t\t</ng-template>\r\n\t\t</div>\r\n\t\t<div *ngSwitchCase=\"'passwordValid'\">\r\n\t\t\t<label\r\n\t\t\t\tattr.data-aui=\"{{ formData?.label }}\"\r\n\t\t\t\t[for]=\"formData?.key\"\r\n\t\t\t\t[innerHtml]=\"requiredLabel\"\r\n\t\t\t\tclass=\"required\"\r\n\t\t\t></label>\r\n\t\t\t<input\r\n\t\t\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t\t\t[formControlName]=\"formData?.key\"\r\n\t\t\t\t[id]=\"formData?.key\"\r\n\t\t\t\t[type]=\"passwordToggle && showPassword ? 'text' : 'password'\"\r\n\t\t\t\t(ngModelChange)=\"onChange($event)\"\r\n\t\t\t\t[ngClass]=\"{ 'password-with-lock': passwordToggle }\"\r\n\t\t\t\trequired\r\n\t\t\t/>\r\n\r\n\t\t\t<ng-container *ngIf=\"passwordToggle\">\r\n\t\t\t\t<ng-container *ngTemplateOutlet=\"iconTpl\"></ng-container>\r\n\t\t\t</ng-container>\r\n\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"(password.invalid || isSpaceExists) && password.touched\"\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t[attr.aria-describedby]=\"formData?.key + '-field' + ' '\r\n+ formData?.key + '-requiredError' + ' '\r\n+ formData?.key + '-patternError' + ' '\r\n+ formData?.key + '-repeatedCharsError' + ' '\r\n+ formData?.key + '-capsError' + ' '\r\n+ formData?.key + '-spaceError' + ' '\r\n\"\r\n\t\t\t>\r\n\t\t\t\t<span class=\"sr-only\" [id]=\"formData?.key+'-field'\">{{requiredLabel}} </span>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"password?.errors?.required\"\r\n\t\t\t\t\t[id]=\"formData?.key + '-requiredError'\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"password?.errors?.pattern && !repeatedChars\"\r\n\t\t\t\t\t[id]=\"formData?.key + '-patternError'\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER9\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"isSpaceExists\"\r\n\t\t\t\t\t[id]=\"formData?.key + '-spaceError'\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER113\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"repeatedChars\"\r\n\t\t\t\t\t[id]=\"formData?.key + '-repeatedCharsError'\"\r\n\t\t\t\t\t[innerHtml]=\"formData?.errors?.ER51\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData?.label }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t</small>\r\n\t\t\t\t<small *ngIf=\"showCaps\">\r\n\t\t\t\t\t<span\r\n\t\t\t\t\t\tfor=\"password\"\r\n\t\t\t\t\t\t[id]=\"formData?.key + '-capsError'\"\r\n\t\t\t\t\t\t[innerHtml]=\"formData?.errors?.CONST_PASSWORD_CAP\"\r\n\t\t\t\t\t></span>\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t<div aria-live=\"polite\" id=\"strength-info\">\r\n\t\t<div\r\n\t\t\t*ngIf=\"isFirst && inputVal !== ''\"\r\n\t\t\tclass=\"green\"\r\n\t\t\t[ngStyle]=\"{ color: Color }\"\r\n\t\t\t[innerHTML]=\"pwdStrength\"\r\n\t\t></div>\r\n\t</div>\r\n</div>\r\n\r\n<ng-template #iconTpl>\r\n\t<ng-container *ngIf=\"!customIcon; else customIconTpl\">\r\n\t\t<ng-container *ngTemplateOutlet=\"defaultIconTpl\"></ng-container>\r\n\t</ng-container>\r\n\r\n\t<ng-template #customIconTpl>\r\n\t\t<ng-container *ngTemplateOutlet=\"customIconContentTpl\"></ng-container>\r\n\t</ng-template>\r\n</ng-template>\r\n\r\n<ng-template #defaultIconTpl>\r\n\t<i\r\n\t\tclass=\"icon password-lock\"\r\n\t\t[ngClass]=\"{\r\n\t\t\tpointer: passwordToggle,\r\n\t\t\t'icon-lock': !showPassword,\r\n\t\t\t'icon-unlock': showPassword\r\n\t\t}\"\r\n\t\t(click)=\"togglePassword()\"\r\n\t></i>\r\n</ng-template>\r\n\r\n<ng-template #customIconContentTpl>\r\n\t<span class=\"custom-icon\" (click)=\"togglePassword()\"\r\n\t\t><ng-content></ng-content\r\n\t></span>\r\n</ng-template>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.field-validation-error span{display:inline-block;margin-right:-15px;margin-right:-.9375rem;padding:10px 15px;padding:.625rem .9375rem;background:#e61b23;clear:both;color:#fff;position:relative;font-size:12px;font-size:.75rem;line-height:15px;line-height:.9375rem}.pointer{cursor:pointer}.strength-meter{background:#ddd;border-radius:4px;display:inline-block;height:6px;margin-right:3px;width:12%}.custom-icon,.password-lock{position:relative;font-size:1.2em;float:right;color:#797a7d;top:-56px;right:10px}.password-lock{margin:10px 0 0 -25px;pointer-events:none}.password-section{position:relative}.password-strength{margin:0}.create-account-password{margin-bottom:10px}.create-account-password .password-with-lock{margin-bottom:0!important}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    emailValue: [{
      type: Input
    }],
    passwordToggle: [{
      type: Input
    }],
    customIcon: [{
      type: Input
    }],
    customIconClick: [{
      type: Output
    }]
  });
})();
let _nextPaymentCardFieldUniqueId = 0;
class PaymentCardFieldComponent {
  constructor(formBuilder, pipe, route, sessionStorage) {
    this.formBuilder = formBuilder;
    this.pipe = pipe;
    this.route = route;
    this.sessionStorage = sessionStorage;
    this.formReady = new EventEmitter();
    this.handleFocusEvent = new EventEmitter();
    this.handleMonthYearChange = new EventEmitter();
    this.handleInputChange = new EventEmitter();
    this.handleCardTypeChange = new EventEmitter();
    this.replaceCobrandLogo = false;
    this._paymentCardFieldUniqueId = _nextPaymentCardFieldUniqueId++;
  }
  ngOnInit() {
    this.pageLabels = get(this.route.snapshot.data, 'pageLabels', []);
    this.setFormOptions();
    this.setMonthYearSelection();
    this.setCardDetailSelectionControlType('tel');
    this.cardLabel = this.formData.key === 'creditCardDropdown' ? this.formData.additionalLabel : null;
    // set credit card logo for each card on page load
    this.cardType = this.sourceCardType;
    if (this.cardType && this.formData.key === 'creditCardTextbox') {
      CardTypeImageUrls.forEach(card => {
        if (card.cardType === this.cardType) {
          this.imageUrlNo = card.imageUrlNo;
        }
      });
      this.cardTypeImageUrl = this.pageLabels['pmt-card-icon-packages' + this.imageUrlNo] || this.defaultImageUrl + this.pageLabels['pmt-card-card' + this.imageUrlNo];
    }
    this.card = null;
    this.showNewCardForm = false;
    this.showValidationMsg = false;
    this.isReadOnly = this.formData.readOnly || false;
    this.paymentCardGroup = this.initPaymentCard();
    this.formReady.emit(this.getControl(this.formData.key));
    this.isSignedIn = false;
  }
  ngOnDestroy() {
    this._paymentCardFieldUniqueId = _nextPaymentCardFieldUniqueId = 0;
  }
  initPaymentCard() {
    this.requiredCardType = this.sessionStorage.getItem('required-payment-card-type');
    if (this.formData.key === 'securityCode') {
      this.cvvMaxLength = this.formData.maxLength || formFieldRanges.MAX.CVV;
    }
    const pattern = this.formData.pattern1 instanceof Array ? this.formData.pattern1.join('|').replace(/[/]/g, '') : this.formData.pattern1;
    this.pattern = !!this.requiredCardType && this.requiredCardType === CardTypes.AMEX ? this.formData.pattern3_AMEX : pattern;
    return this.formBuilder.group({
      creditCardTextbox: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.maxLength(20), Validators.pattern(this.pattern)])),
      creditCardDropdown: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.required),
      month: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.required),
      year: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.required),
      securityCode: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose([Validators.required, Validators.maxLength(5), Validators.pattern(this.pattern)]))
    });
  }
  setFormOptions() {
    if (this.formData.key === 'year') {
      const minYear = moment().year();
      const maxYear = minYear + 15;
      this.years = range(minYear, maxYear).map(year => {
        return {
          key: year.toString(),
          value: year.toString()
        };
      });
      this.formData.options = this.years;
    }
    if (this.formData.key === 'month') {
      this.months = range(1, 13).map(month => {
        return {
          key: month,
          value: padStart(month, 2, '0')
        };
      });
      this.formData.options = this.months;
    }
  }
  get paymentCard() {
    return this.paymentCardGroup.get(this.formData.key);
  }
  get id() {
    return this.formData.key + '-' + this._paymentCardFieldUniqueId;
  }
  onKeyUp(value) {
    if (value === '' && this.formData.key === 'creditCardTextbox') {
      this.cardType = this.pipe.transform(value);
    }
    if (value !== '' && this.formData.key === 'creditCardTextbox') {
      this.cardType = this.pipe.transform(value);
      if (this.replaceCobrandLogo && this.cardType === CardTypes.VISA_COBRAND) {
        this.cardType = CardTypes.VISA;
      }
      this.sessionStorage.setItem('payment-card-type', this.cardType);
      this.imageUrlNo = '';
      if (this.cardType) {
        CardTypeImageUrls.forEach(card => {
          if (card.cardType === this.cardType) {
            this.imageUrlNo = card.imageUrlNo;
          }
        });
        this.handleCardTypeChange.emit(this.cardType);
        this.cardTypeImageUrl = this.pageLabels['pmt-card-icon-packages' + this.imageUrlNo] || this.defaultImageUrl + this.pageLabels['pmt-card-card' + this.imageUrlNo];
      }
    }
    if (value !== '' && this.formData.key === 'securityCode') {
      const securityCodeControl = this.paymentCardGroup.get('securityCode');
      const storedCardType = this.sourceCardType || this.sessionStorage.getItem('payment-card-type');
      if (this.cardType === CardTypes.AMEX || storedCardType === CardTypes.AMEX) {
        // amex
        const newPattern = this.formData.pattern2;
        securityCodeControl.setValidators([Validators.required, Validators.maxLength(5), Validators.pattern(newPattern)]);
      } else {
        // not amex
        securityCodeControl.setValidators([Validators.required, Validators.maxLength(5), Validators.pattern(this.pattern)]);
      }
      securityCodeControl.updateValueAndValidity();
    }
  }
  handleBlur(event) {
    this.showValidationMsg = true;
    this.handleInputChange.emit(event);
  }
  onChange(newOption) {
    this.selectedOption = newOption;
    if (this.formData.key === 'month' || this.formData.key === 'year') {
      this.handleMonthYearChange.emit();
    }
  }
  onCardChange(selectedCard) {
    this.card = selectedCard;
    if (!selectedCard) {
      this.showNewCardForm = true;
      return;
    }
    this.showNewCardForm = false;
    this.isCardExpired = selectedCard.isExpired;
  }
  getControl(control) {
    return this.paymentCardGroup.get(control);
  }
  setMonthYearSelection() {
    if (this.formData.key === 'month' || this.formData.key === 'year') {
      this.selectedOption = this.formData.value ? parseInt(this.formData.value, 10).toString() : '';
    }
  }
  setCardDetailSelectionControlType(type) {
    if (this.formData.key === 'securityCode' || this.formData.key === 'creditCardTextbox') {
      if (this.formData.value) {
        this.formData.controlType = type;
      }
    }
  }
  isTextOrTelField() {
    return this.formData.controlType === 'text' ? 'text' : 'tel';
  }
  handleFocus() {
    this.setCardDetailSelectionControlType('tel');
  }
  static {
    this.ɵfac = function PaymentCardFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PaymentCardFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2$4.CardTypePipe), i0.ɵɵdirectiveInject(i3$1.ActivatedRoute), i0.ɵɵdirectiveInject(i4.SessionStorageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PaymentCardFieldComponent,
      selectors: [["upr-payment-card-field"]],
      inputs: {
        formData: "formData",
        defaultImageUrl: "defaultImageUrl",
        sourceCardType: "sourceCardType",
        isCardDuplicateError: "isCardDuplicateError",
        isCardDuplicate: "isCardDuplicate",
        replaceCobrandLogo: "replaceCobrandLogo"
      },
      outputs: {
        formReady: "formReady",
        handleFocusEvent: "handleFocusEvent",
        handleMonthYearChange: "handleMonthYearChange",
        handleInputChange: "handleInputChange",
        handleCardTypeChange: "handleCardTypeChange"
      },
      standalone: false,
      decls: 5,
      vars: 8,
      consts: [[3, "formGroup"], [1, "relative", 3, "ngSwitch"], ["class", "form-group", 4, "ngSwitchCase"], [4, "ngIf"], [1, "form-group"], [1, "label-with-tooltip", "required"], ["data-cardinal-field", "AccountNumber", 3, "keyup", "blur", "ngModelChange", "focus", "formControlName", "id", "placeholder", "type", "autocomplete", "maxlength", "ngModel", "ngClass"], ["class", "card-type", 4, "ngIf"], ["tooltip-box", ""], ["tooltip", "", 1, "icon", "icon-info", "icon-tooltip"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [1, "card-type"], [1, "pmt-card-image", 3, "alt", "src"], [1, "pointer-text", 3, "for", "ngClass"], [1, "required"], ["aria-required", "true", 3, "ngModelChange", "id", "name", "formControlName", "ngModel"], ["disabled", "", "selected", "", "value", "", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], ["class", "error", "role", "alert", 4, "ngIf"], ["disabled", "", "selected", "", "value", ""], [3, "value"], ["role", "alert", 1, "error"], [3, "ngModelChange", "id", "name", "formControlName", "ngModel", "disabled"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["class", "expired-card error", "role", "alert", 4, "ngIf"], ["class", "expired-card", 4, "ngIf"], [1, "expired-card"], ["role", "alert", 1, "expired-card", "error"], ["class", "form-error", 4, "ngIf"], [1, "form-error"]],
      template: function PaymentCardFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵtemplate(2, PaymentCardFieldComponent_div_2_Template, 7, 18, "div", 2)(3, PaymentCardFieldComponent_div_3_Template, 9, 15, "div", 2)(4, PaymentCardFieldComponent_div_4_Template, 2, 1, "div", 3);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.formData.class);
          i0.ɵɵproperty("formGroup", ctx.paymentCardGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitch", ctx.formData.controlType);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", ctx.isTextOrTelField());
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngSwitchCase", "dropdown");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isSignedIn);
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgForOf, i2$1.NgIf, i2$1.NgSwitch, i2$1.NgSwitchCase, i1.NgSelectOption, i1.ɵNgSelectMultipleOption, i1.DefaultValueAccessor, i1.SelectControlValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.MaxLengthValidator, i1.FormGroupDirective, i1.FormControlName, i3.TooltipComponent],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}input[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.card-type[_ngcontent-%COMP%]{margin-top:-14px;padding-bottom:8px}@media print,screen and (min-width: 64em){.group-field[_ngcontent-%COMP%]{display:inline-block;width:50%;padding-right:15px;vertical-align:top}}.form-group[_ngcontent-%COMP%]{position:relative}input.error.ng-touched[_ngcontent-%COMP%], input.card-error[_ngcontent-%COMP%]{border-color:#e61b23}input.card-error[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]{color:#e61b23;margin-top:-20px;padding-bottom:10px}input.ng-invalid.ng-touched[_ngcontent-%COMP%] + div[_ngcontent-%COMP%], select.ng-invalid.ng-touched[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]{color:#e61b23}select.ng-invalid.ng-touched[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]{position:relative}.relative[_ngcontent-%COMP%]{position:relative}input[type=number][_ngcontent-%COMP%]{-moz-appearance:textfield}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaymentCardFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-payment-card-field',
      standalone: false,
      template: "<div [formGroup]=\"paymentCardGroup\" class=\"{{ formData.class }}\">\r\n\t<div class=\"relative\" [ngSwitch]=\"formData.controlType\">\r\n\t\t<div class=\"form-group\" *ngSwitchCase=\"isTextOrTelField()\">\r\n\t\t\t<label\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}\"\r\n\t\t\t\tclass=\"label-with-tooltip required\"\r\n\t\t\t\t[attr.for]=\"id\"\r\n\t\t\t\t>{{ formData.label }}</label\r\n\t\t\t>\r\n\r\n\t\t\t<upr-tooltip *ngIf=\"formData?.tooltip\">\r\n\t\t\t\t<div tooltip-box>\r\n\t\t\t\t\t{{ formData?.tooltip }}\r\n\t\t\t\t</div>\r\n\t\t\t\t<i class=\"icon icon-info icon-tooltip\" tooltip></i>\r\n\t\t\t</upr-tooltip>\r\n\r\n\t\t\t<input\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}-input\"\r\n\t\t\t\t[formControlName]=\"formData.key\"\r\n\t\t\t\t[id]=\"id\"\r\n\t\t\t\t[placeholder]=\"formData.placeholder\"\r\n\t\t\t\t[type]=\"formData.controlType\"\r\n\t\t\t\t[attr.inputmode]=\"formData.inputmode || 'text'\"\r\n\t\t\t\t(keyup)=\"onKeyUp($event.target.value)\"\r\n\t\t\t\t(blur)=\"handleBlur(formData)\"\r\n\t\t\t\t[autocomplete]=\"formData?.autocomplete || 'off'\"\r\n\t\t\t\t[maxlength]=\"cvvMaxLength\"\r\n\t\t\t\tdata-cardinal-field=\"AccountNumber\"\r\n\t\t\t\t[(ngModel)]=\"formData.value\"\r\n\t\t\t\t(focus)=\"handleFocus()\"\r\n\t\t\t\t[placeholder]=\"formData?.placeholder\"\r\n\t\t\t\t[ngClass]=\"\r\n\t\t\t\t\tformData.key === 'creditCardTextbox' &&\r\n\t\t\t\t\t(isCardDuplicate ||\r\n\t\t\t\t\t\t(paymentCard?.touched && !cardType && !imageUrlNo))\r\n\t\t\t\t\t\t? 'card-error'\r\n\t\t\t\t\t\t: ''\r\n\t\t\t\t\"\r\n\t\t\t/>\r\n\t\t\t<div\r\n\t\t\t\t*ngIf=\"\r\n\t\t\t\t\t(paymentCard?.invalid && paymentCard?.touched) ||\r\n\t\t\t\t\t(formData.key === 'creditCardTextbox' &&\r\n\t\t\t\t\t\t(isCardDuplicate ||\r\n\t\t\t\t\t\t\t(paymentCard?.valid &&\r\n\t\t\t\t\t\t\t\tpaymentCard?.touched &&\r\n\t\t\t\t\t\t\t\t!cardType &&\r\n\t\t\t\t\t\t\t\t!imageUrlNo)))\r\n\t\t\t\t\"\r\n\t\t\t>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"paymentCard?.errors?.required\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"isCardDuplicate && formData.key === 'creditCardTextbox'\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t\t{{ isCardDuplicateError }}\r\n\t\t\t\t</small>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"\r\n\t\t\t\t\t\tpaymentCard?.errors?.maxlength ||\r\n\t\t\t\t\t\tpaymentCard?.errors?.pattern ||\r\n\t\t\t\t\t\t(paymentCard?.touched && !cardType && !imageUrlNo)\r\n\t\t\t\t\t\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t\t{{\r\n\t\t\t\t\t\tformData.key === 'creditCardTextbox'\r\n\t\t\t\t\t\t\t? formData?.errors?.ER34\r\n\t\t\t\t\t\t\t: formData?.errors?.ER37\r\n\t\t\t\t\t}}\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"card-type\" *ngIf=\"cardType && imageUrlNo\">\r\n\t\t\t\t<img\r\n\t\t\t\t\tclass=\"pmt-card-image\"\r\n\t\t\t\t\talt=\"{{ cardType }}\"\r\n\t\t\t\t\tsrc=\"{{ cardTypeImageUrl }}\"\r\n\t\t\t\t\tattr.data-aui=\"{{ cardType }}\"\r\n\t\t\t\t/>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"form-group\" *ngSwitchCase=\"'dropdown'\">\r\n\t\t\t<label\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}\"\r\n\t\t\t\t[for]=\"id\"\r\n\t\t\t\tclass=\"pointer-text\"\r\n\t\t\t\t[ngClass]=\"formData.key\"\r\n\t\t\t\t[attr.aria-label]=\"formData.key\"\r\n\t\t\t\t>{{ formData?.additionalLabel?.label1 }}\r\n\t\t\t\t<span attr.data-aui=\"{{ formData.key }}\" class=\"required\">\r\n\t\t\t\t\t{{ formData.label }}</span\r\n\t\t\t\t></label\r\n\t\t\t>\r\n\r\n\t\t\t<select\r\n\t\t\t\tattr.data-aui=\"{{ formData.key }}\"\r\n\t\t\t\t[id]=\"id\"\r\n\t\t\t\t[name]=\"formData.key\"\r\n\t\t\t\t[formControlName]=\"formData.key\"\r\n\t\t\t\t[(ngModel)]=\"selectedOption\"\r\n\t\t\t\taria-required=\"true\"\r\n\t\t\t\t(ngModelChange)=\"onChange($event)\"\r\n\t\t\t>\r\n\t\t\t\t<option *ngIf=\"formData.placeholder\" disabled selected value=\"\">\r\n\t\t\t\t\t{{ formData.placeholder }}\r\n\t\t\t\t</option>\r\n\t\t\t\t<option *ngFor=\"let opt of formData.options\" [value]=\"opt.key\">\r\n\t\t\t\t\t{{ opt.value }}\r\n\t\t\t\t</option>\r\n\t\t\t</select>\r\n\r\n\t\t\t<div\r\n\t\t\t\tclass=\"error\"\r\n\t\t\t\trole=\"alert\"\r\n\t\t\t\t*ngIf=\"\r\n\t\t\t\t\tpaymentCard?.invalid && (paymentCard?.dirty || paymentCard?.touched)\r\n\t\t\t\t\"\r\n\t\t\t>\r\n\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t<small\r\n\t\t\t\t\t*ngIf=\"paymentCard?.errors?.required && formData?.errors?.ER26\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t\t\t</small>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<div *ngIf=\"isSignedIn\">\r\n\t\t\t<div class=\"form-group\" *ngSwitchCase=\"'creditCardDropdown'\">\r\n\t\t\t\t<label\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}\"\r\n\t\t\t\t\t[attr.for]=\"id\"\r\n\t\t\t\t\tclass=\"required\"\r\n\t\t\t\t\t>{{ formData.label }}</label\r\n\t\t\t\t>\r\n\t\t\t\t<select\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-Input\"\r\n\t\t\t\t\t[id]=\"id\"\r\n\t\t\t\t\t[name]=\"formData.key\"\r\n\t\t\t\t\t[formControlName]=\"formData.key\"\r\n\t\t\t\t\t[(ngModel)]=\"card\"\r\n\t\t\t\t\t(ngModelChange)=\"onCardChange($event)\"\r\n\t\t\t\t\t[disabled]=\"creditCards.length === 1\"\r\n\t\t\t\t>\r\n\t\t\t\t\t<option [ngValue]=\"null\">{{ cardLabel.label1 }}</option>\r\n\t\t\t\t\t<option *ngFor=\"let card of creditCards\" [ngValue]=\"card\">\r\n\t\t\t\t\t\t{{ card.value }}\r\n\t\t\t\t\t\t<span\r\n\t\t\t\t\t\t\tclass=\"expired-card\"\r\n\t\t\t\t\t\t\t*ngIf=\"card.isExpired\"\r\n\t\t\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t\t>\r\n\t\t\t\t\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t\t\t\t\t</span>\r\n\t\t\t\t\t</option>\r\n\t\t\t\t</select>\r\n\t\t\t\t<span\r\n\t\t\t\t\tclass=\"expired-card error\"\r\n\t\t\t\t\trole=\"alert\"\r\n\t\t\t\t\t*ngIf=\"isCardExpired && !showNewCardForm\"\r\n\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t>\r\n\t\t\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t\t\t</span>\r\n\r\n\t\t\t\t<div\r\n\t\t\t\t\tclass=\"error\"\r\n\t\t\t\t\trole=\"alert\"\r\n\t\t\t\t\t*ngIf=\"\r\n\t\t\t\t\t\tshowValidationMsg &&\r\n\t\t\t\t\t\tpaymentCard.invalid &&\r\n\t\t\t\t\t\t(paymentCard.dirty || paymentCard.touched)\r\n\t\t\t\t\t\"\r\n\t\t\t\t>\r\n\t\t\t\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t\t\t\t<small\r\n\t\t\t\t\t\t*ngIf=\"paymentCard?.errors?.required\"\r\n\t\t\t\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t\t\t\tclass=\"form-error\"\r\n\t\t\t\t\t>\r\n\t\t\t\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t\t\t\t</small>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<div *ngIf=\"showNewCardForm\">New Credit Card Form</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.card-type{margin-top:-14px;padding-bottom:8px}@media print,screen and (min-width: 64em){.group-field{display:inline-block;width:50%;padding-right:15px;vertical-align:top}}.form-group{position:relative}input.error.ng-touched,input.card-error{border-color:#e61b23}input.card-error+div{color:#e61b23;margin-top:-20px;padding-bottom:10px}input.ng-invalid.ng-touched+div,select.ng-invalid.ng-touched+div{color:#e61b23}select.ng-invalid.ng-touched+div{position:relative}.relative{position:relative}input[type=number]{-moz-appearance:textfield}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2$4.CardTypePipe
  }, {
    type: i3$1.ActivatedRoute
  }, {
    type: i4.SessionStorageService
  }], {
    formReady: [{
      type: Output
    }],
    handleFocusEvent: [{
      type: Output
    }],
    handleMonthYearChange: [{
      type: Output
    }],
    handleInputChange: [{
      type: Output
    }],
    handleCardTypeChange: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    defaultImageUrl: [{
      type: Input
    }],
    sourceCardType: [{
      type: Input
    }],
    isCardDuplicateError: [{
      type: Input
    }],
    isCardDuplicate: [{
      type: Input
    }],
    replaceCobrandLogo: [{
      type: Input
    }]
  });
})();
function NumericValidator(countryName) {
  return control => {
    let transformedInput = control.value;
    const inProcessInput = [];
    if (countryName && countryName.toLowerCase() === 'us') {
      control.value.split('').forEach((item, index) => {
        if (index === 0 && item === '(' || index === 4 && item === ')' || index === 8 && item === '-') return;
        inProcessInput.push(item);
      });
    } else {
      control.value.split('').forEach(item => {
        if (item === '-') return;
        inProcessInput.push(item);
      });
    }
    transformedInput = inProcessInput.join('');
    const validationRegex = new RegExp(NumberCharPattern.NUMBER);
    if (!validationRegex.test(transformedInput) || !transformedInput && control.value.length > 0 && transformedInput.length > 0) {
      return {
        alphaNumeric: true
      };
    }
    return null;
  };
}
let _nextPhoneFieldUniqueId = 0;
class PhoneFieldComponent {
  get fieldValue() {
    return this.formDataValue || this.formData.value;
  }
  set fieldValue(value) {
    if (this.formDataValue !== undefined) {
      this.formDataValue = value;
    } else {
      this.formData.value = value;
    }
  }
  constructor(fb) {
    this.fb = fb;
    this.formReady = new EventEmitter();
    this._phoneFieldUniqueId = _nextPhoneFieldUniqueId++;
  }
  ngOnInit() {
    const validators = [Validators.pattern(this.formData.pattern1)];
    if (!!this.formData.required) {
      validators.push(Validators.required);
    }
    this.phoneGroup = this.fb.group({
      phone: new FormControl({
        value: '',
        disabled: !!this.formData.readOnly
      }, Validators.compose(validators))
    });
    this.formReady.emit(this.getControl(this.formData.key));
    this.transformedInput = '';
  }
  ngOnChanges() {
    if (this.phone?.value && this.phone.value != this.formDataValue) {
      this.formDataValue = this.phone.value;
    }
    if (this.formDataValue && this.countryName && this.phoneGroup) {
      this.updatePhonePattern(this.formDataValue);
    }
  }
  ngOnDestroy() {
    this._phoneFieldUniqueId = _nextPhoneFieldUniqueId = 0;
  }
  updatePhonePattern(value) {
    if (!value) {
      return;
    }
    const phoneControl = this.phoneGroup.get('phone');
    this.transformedInput = value.replace(NumberCharPattern.NON_DIGIT, '');
    const validators = [NumericValidator(this.countryName)];
    this.isCountryUSA = !!this.countryName && this.countryName.toString().toLowerCase() === 'us';
    if (value && !!this.countryName && this.countryName.toString().toLowerCase() === 'us' || this.country === formFieldRanges.PHONE.USA_COUNTRY_CODE) {
      validators.push(Validators.pattern(PhonePattern.PHONE));
      validators.push(Validators.minLength(formFieldRanges.MIN.USA_PHONE));
      this.formatTransformedInput(this.transformedInput);
    } else if (this.country === formFieldRanges.PHONE.ANY_COUNTRY_CODE) {
      validators.push(Validators.maxLength(formFieldRanges.MAX.PHONE));
      validators.push(Validators.minLength(formFieldRanges.MIN.NON_USA_PHONE));
      validators.push(Validators.pattern(PhonePattern.PHONE_ANY));
    } else {
      validators.push(Validators.maxLength(formFieldRanges.MAX.PHONE));
      validators.push(Validators.minLength(formFieldRanges.MIN.NON_USA_PHONE));
      validators.push(Validators.pattern(PhonePattern.NON_US_PHONE));
    }
    if (!!this.formData.required) {
      validators.push(Validators.required);
    }
    phoneControl.setValidators(validators);
    phoneControl.updateValueAndValidity();
  }
  formatTransformedInput(value) {
    const inputValue = value.toString().trim().replace(NumberCharPattern.START_WITH_PLUS, '');
    let city;
    let numberValue;
    if (inputValue.match(NumberCharPattern.NUMBER)) {
      this.transformedInput = value;
    }
    switch (inputValue.length) {
      case 1:
      case 2:
      case 3:
        city = inputValue;
        break;
      default:
        city = inputValue.slice(0, 3);
        numberValue = inputValue.slice(3);
        break;
    }
    if (!numberValue) {
      this.transformedInput = `(${city}`;
      return;
    }
    if (numberValue.length > 3 && inputValue.length < 11) {
      numberValue = numberValue.slice(0, 3) + `-` + numberValue.slice(3, 7);
      const cityValue = `(${city})`;
      this.transformedInput = `${(cityValue + numberValue).trim()}`;
    } else if (numberValue.length > 0 && numberValue.length <= 3 && inputValue.length < 11) {
      numberValue = numberValue.slice(0, numberValue.length);
      const cityValue = `(${city})`;
      this.transformedInput = `${(cityValue + numberValue).trim()}`;
    } else {
      this.transformedInput = value;
    }
    this.formDataValue = this.transformedInput;
  }
  get phone() {
    return this.phoneGroup?.get(this.formData.key);
  }
  get id() {
    return this.formData.key + '-' + this._phoneFieldUniqueId;
  }
  getControl(control) {
    return this.phoneGroup.get(control);
  }
  static {
    this.ɵfac = function PhoneFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PhoneFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: PhoneFieldComponent,
      selectors: [["upr-phone-field"]],
      inputs: {
        formData: "formData",
        countryName: "countryName",
        formDataValue: "formDataValue",
        minLength: "minLength",
        pattern: "pattern"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 10,
      vars: 21,
      consts: [[1, "phone-group", 3, "formGroup"], [1, "label-with-tooltip", 3, "ngClass"], [4, "ngIf"], ["tooltip-box", ""], ["tooltip", "", 1, "icon", "icon-info", "icon-tooltip"], [3, "ngModelChange", "formControlName", "id", "placeholder", "type", "required", "ngModel", "pattern", "minlength"], ["class", "error", "data-aui", "error-message", "role", "alert", 4, "ngIf"], ["data-aui", "error-message", "role", "alert", 1, "error"], [1, "sr-only", 3, "id"], ["aria-hidden", "true", 1, "icon", "icon-alert"], [3, "id", "innerHtml", 4, "ngIf"], [3, "id", "innerHtml"]],
      template: function PhoneFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
          i0.ɵɵtext(2);
          i0.ɵɵtemplate(3, PhoneFieldComponent_small_3_Template, 2, 1, "small", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "upr-tooltip")(5, "div", 3);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(7, "i", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(8, "input", 5);
          i0.ɵɵlistener("ngModelChange", function PhoneFieldComponent_Template_input_ngModelChange_8_listener($event) {
            return ctx.updatePhonePattern($event);
          });
          i0.ɵɵtwoWayListener("ngModelChange", function PhoneFieldComponent_Template_input_ngModelChange_8_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.fieldValue, $event) || (ctx.fieldValue = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(9, PhoneFieldComponent_div_9_Template, 11, 10, "div", 6);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.phoneGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c0, ctx.formData == null ? null : ctx.formData.required));
          i0.ɵɵattribute("data-aui", ctx.formData == null ? null : ctx.formData.key)("for", ctx.id);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1("", ctx.formData == null ? null : ctx.formData.label, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.formData == null ? null : ctx.formData.optionalLabel);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1(" ", ctx.formData.tooltip, " ");
          i0.ɵɵadvance(2);
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData.key, "-input");
          i0.ɵɵproperty("formControlName", ctx.formData.key)("id", ctx.id)("placeholder", ctx.formData.placeholder)("type", ctx.formData.controlType)("required", ctx.formData == null ? null : ctx.formData.required);
          i0.ɵɵtwoWayProperty("ngModel", ctx.fieldValue);
          i0.ɵɵproperty("pattern", ctx.pattern)("minlength", ctx.minLength);
          i0.ɵɵattribute("aria-label", ((ctx.formData == null ? null : ctx.formData.optionalLabel) ? (ctx.formData == null ? null : ctx.formData.label) + " " + (ctx.formData == null ? null : ctx.formData.optionalLabel) : ctx.formData == null ? null : ctx.formData.label) || "Phone");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.phone.invalid && ctx.phone.touched);
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.RequiredValidator, i1.MinLengthValidator, i1.PatternValidator, i1.FormGroupDirective, i1.FormControlName, i3.TooltipComponent],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.divbox[_ngcontent-%COMP%]{width:24px;height:24px}.divbox[_ngcontent-%COMP%]   .icon.icon-info[_ngcontent-%COMP%]{float:right}.phone-icon-display[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{float:left}.phone-icon-display[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{float:right;position:relative}.phone-icon-display[_ngcontent-%COMP%]   .tooltip[_ngcontent-%COMP%]{visibility:hidden;background-color:#036ce2;color:#fff;z-index:10;left:-135px;top:20px}.phone-icon-display[_ngcontent-%COMP%]:hover   .tooltip[_ngcontent-%COMP%]{visibility:visible}.white-background   [_nghost-%COMP%]   .phone-icon-display[_ngcontent-%COMP%]   .tooltip[_ngcontent-%COMP%]{background-color:#0368d9}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PhoneFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-phone-field',
      standalone: false,
      template: "<div [formGroup]=\"phoneGroup\" class=\"phone-group\">\r\n\t<label\r\n\t\tattr.data-aui=\"{{ formData?.key }}\"\r\n\t\t[attr.for]=\"id\"\r\n\t\tclass=\"label-with-tooltip\"\r\n\t\t[ngClass]=\"{ required: formData?.required }\"\r\n\t\t>{{ formData?.label }}\r\n\t\t<small *ngIf=\"formData?.optionalLabel\">{{ formData.optionalLabel }}</small>\r\n\t</label>\r\n\r\n\t<upr-tooltip>\r\n\t\t<div tooltip-box>\r\n\t\t\t{{ formData.tooltip }}\r\n\t\t</div>\r\n\t\t<i class=\"icon icon-info icon-tooltip\" tooltip></i>\r\n\t</upr-tooltip>\r\n\r\n\t<input\r\n\t\tattr.data-aui=\"{{ formData.key }}-input\"\r\n\t\t[formControlName]=\"formData.key\"\r\n\t\t[id]=\"id\"\r\n\t\t[placeholder]=\"formData.placeholder\"\r\n\t\t[type]=\"formData.controlType\"\r\n\t\t(ngModelChange)=\"updatePhonePattern($event)\"\r\n\t\t[required]=\"formData?.required\"\r\n\t\t[(ngModel)]=\"fieldValue\"\r\n\t\t[pattern]=\"pattern\"\r\n\t\t[minlength]=\"minLength\"\r\n\t\t[attr.aria-label]=\"\r\n\t\t\t(formData?.optionalLabel\r\n\t\t\t\t? formData?.label + ' ' + formData?.optionalLabel\r\n\t\t\t\t: formData?.label) || 'Phone'\r\n\t\t\"\r\n\t/>\r\n\t<div\r\n\t\t*ngIf=\"phone.invalid && phone.touched\"\r\n\t\tclass=\"error\"\r\n\t\tdata-aui=\"error-message\"\r\n\t\trole=\"alert\"\r\n\t\t[attr.aria-describedby]=\"id + '-field' + ' '\r\n\t\t+ id + '-requiredError' + ' '\r\n\t\t+ id + '-maxLengthErrorNotUSA' + ' '\r\n\t\t+ id + '-maxLengthErrorUSA' + ' '\r\n\t\t+ id + '-minLengthErrorNotUSA' + ' '\r\n\t\t+ id + '-patternErrorUSA' + ' '\r\n\t\t+ id + '-patternErrorNotUSA' + ' '\r\n\t\t+ id + '-otherError' + ' '\r\n\"\r\n\t>\r\n\t\t<span class=\"sr-only\" [id]=\"id+'-field'\">{{formData?.label}} </span>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-requiredError'\"\r\n\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t*ngIf=\"phone?.errors?.required\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER26\"\r\n\t\t>\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-maxLengthErrorNotUSA'\"\r\n\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t*ngIf=\"\r\n\t\t\t\tphone?.errors?.maxlength &&\r\n\t\t\t\tformData?.errors?.ER33 &&\r\n\t\t\t\t!phone?.errors?.alphaNumeric &&\r\n\t\t\t\t!isCountryUSA\r\n\t\t\t\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER33\"\r\n\t\t>\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-maxLengthErrorUSA'\"\r\n\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t*ngIf=\"\r\n\t\t\t\tphone?.errors?.maxlength &&\r\n\t\t\t\tformData?.errors?.ER41 &&\r\n\t\t\t\t!phone?.errors?.alphaNumeric &&\r\n\t\t\t\tisCountryUSA\r\n\t\t\t\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER41\"\r\n\t\t>\r\n\t\t</small>\r\n\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-minLengthErrorNotUSA'\"\r\n\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t*ngIf=\"\r\n\t\t\t\tphone?.errors?.minlength &&\r\n\t\t\t\tformData?.errors?.ER134 &&\r\n\t\t\t\t!phone?.errors?.alphaNumeric &&\r\n\t\t\t\t!isCountryUSA\r\n\t\t\t\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER134\"\r\n\t\t>\r\n\t\t</small>\r\n\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-patternErrorUSA'\"\r\n\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t*ngIf=\"\r\n\t\t\t\tphone?.errors?.pattern &&\r\n\t\t\t\tformData?.errors?.ER41 &&\r\n\t\t\t\t!phone?.errors?.alphaNumeric &&\r\n\t\t\t\tisCountryUSA\r\n\t\t\t\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER41\"\r\n\t\t>\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-patternErrorNotUSA'\"\r\n\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t*ngIf=\"\r\n\t\t\t\tphone?.errors?.pattern &&\r\n\t\t\t\tformData?.errors?.ER33 &&\r\n\t\t\t\t!phone?.errors?.alphaNumeric &&\r\n\t\t\t\t!isCountryUSA\r\n\t\t\t\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER33\"\r\n\t\t>\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t[id]=\"id + '-otherError'\"\r\n\t\t\tattr.data-aui=\"{{ formData.key }}-error\"\r\n\t\t\t*ngIf=\"phone?.errors?.alphaNumeric && formData?.errors?.ER5\"\r\n\t\t\t[innerHtml]=\"formData?.errors?.ER5\"\r\n\t\t>\r\n\t\t</small>\r\n\t</div>\r\n</div>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.divbox{width:24px;height:24px}.divbox .icon.icon-info{float:right}.phone-icon-display label{float:left}.phone-icon-display div{float:right;position:relative}.phone-icon-display .tooltip{visibility:hidden;background-color:#036ce2;color:#fff;z-index:10;left:-135px;top:20px}.phone-icon-display:hover .tooltip{visibility:visible}.white-background :host-context .phone-icon-display .tooltip{background-color:#0368d9}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }],
    countryName: [{
      type: Input
    }],
    formDataValue: [{
      type: Input
    }],
    minLength: [{
      type: Input
    }],
    pattern: [{
      type: Input
    }]
  });
})();
class RadioButtonComponent {
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.formReady = new EventEmitter();
  }
  ngOnInit() {
    this.radioButtonGroup = this.formBuilder.group({
      radioButton: new FormControl('', Validators.required)
    });
    this.formReady.emit(this.radioButtonGroup);
  }
  static {
    this.ɵfac = function RadioButtonComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || RadioButtonComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: RadioButtonComponent,
      selectors: [["upr-radio-button"]],
      inputs: {
        radioName: "radioName",
        selectedValue: "selectedValue",
        value: "value",
        radioIndex: "radioIndex",
        bgColor: "bgColor",
        label: "label",
        disabled: "disabled",
        analyticsTitle: "analyticsTitle"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      ngContentSelectors: _c17,
      decls: 8,
      vars: 18,
      consts: [["role", "radiogroup", 1, "radio-button", 3, "formGroup", "ngClass"], ["role", "radio", "type", "radio", "formControlName", "radioButton", "attr.disabled", "disabled", 3, "id", "ngModel", "value"], [1, "radio-mark", 3, "for"], [1, "radio-dot", 3, "ngStyle"], [1, "sr-only"], [1, "radio-text"]],
      template: function RadioButtonComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "span", 0);
          i0.ɵɵelement(1, "input", 1);
          i0.ɵɵelementStart(2, "label", 2)(3, "span", 3)(4, "span", 4);
          i0.ɵɵtext(5);
          i0.ɵɵelementEnd()()();
          i0.ɵɵelementStart(6, "div", 5);
          i0.ɵɵprojection(7);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.radioButtonGroup)("ngClass", i0.ɵɵpureFunction2(13, _c22, ctx.selectedValue === ctx.value, ctx.disabled));
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate1("id", "radio-", ctx.radioName, "");
          i0.ɵɵproperty("ngModel", ctx.selectedValue)("value", ctx.value);
          i0.ɵɵattribute("tabindex", ctx.selectedValue ? ctx.selectedValue === ctx.value ? 0 : -1 : 0)("aria-checked", ctx.selectedValue === ctx.value)("analytics-title", ctx.analyticsTitle + " | " + (ctx.label || ctx.value));
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate1("for", "radio-", ctx.radioName, "");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(16, _c23, ctx.bgColor ? ctx.bgColor : ""));
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.label || ctx.value);
        }
      },
      dependencies: [i2$1.NgClass, i2$1.NgStyle, i1.DefaultValueAccessor, i1.RadioControlValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName],
      styles: [".outline-style-primary-blue[_ngcontent-%COMP%]{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white[_ngcontent-%COMP%]{outline:1px dashed #fff;outline-offset:2px}.font-12[_ngcontent-%COMP%]{font-size:12px!important}.font-14[_ngcontent-%COMP%]{font-size:14px!important}.font-16[_ngcontent-%COMP%]{font-size:16px!important}.font-18[_ngcontent-%COMP%]{font-size:18px!important}.font-20[_ngcontent-%COMP%]{font-size:20px!important}.font-22[_ngcontent-%COMP%]{font-size:22px!important}.font-24[_ngcontent-%COMP%]{font-size:24px!important}.font-26[_ngcontent-%COMP%]{font-size:26px!important}.font-28[_ngcontent-%COMP%]{font-size:28px!important}.font-30[_ngcontent-%COMP%]{font-size:30px!important}.font-32[_ngcontent-%COMP%]{font-size:32px!important}.fade-me-in[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_fadeIn .25s;-webkit-animation:_ngcontent-%COMP%_fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes _ngcontent-%COMP%_fadeIn{0%{opacity:0}to{opacity:1}}.radio-button[_ngcontent-%COMP%]{display:flex;position:relative;padding:8px 8px 8px 30px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:12px;font-weight:500;background:inherit}.radio-button[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{position:absolute;opacity:0;left:2px}.radio-button[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{background-color:#05d2f0}.radio-button[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]   .radio-dot[_ngcontent-%COMP%]{background:#05d2f0}.radio-button[_ngcontent-%COMP%]   .radio-mark[_ngcontent-%COMP%]{border:1px solid #a7a7a7;position:absolute;top:auto;left:-8px;height:25px;width:25px;border-radius:50%;padding:3px}.radio-button[_ngcontent-%COMP%]   .radio-text[_ngcontent-%COMP%]{line-height:26px;padding-left:5px}.radio-button[_ngcontent-%COMP%]   .radio-dot[_ngcontent-%COMP%]{display:block;width:17px;height:17px;border-radius:50%;background:#fff}.radio-button[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked + .radio-mark[_ngcontent-%COMP%]   .radio-dot[_ngcontent-%COMP%]{background-color:#036ce2}.radio-button.selected[_ngcontent-%COMP%]{-webkit-box-shadow:none;box-shadow:none}.ticket-widget-content[_nghost-%COMP%]   .radio-button[_ngcontent-%COMP%], .ticket-widget-content   [_nghost-%COMP%]   .radio-button[_ngcontent-%COMP%]{background-color:#eee;padding-left:40px}.ticket-widget-content[_nghost-%COMP%]   .radio-button[_ngcontent-%COMP%]   .radio-mark[_ngcontent-%COMP%], .ticket-widget-content   [_nghost-%COMP%]   .radio-button[_ngcontent-%COMP%]   .radio-mark[_ngcontent-%COMP%]{left:0}.ticket-widget-content[_nghost-%COMP%]   .radio-button.selected[_ngcontent-%COMP%], .ticket-widget-content   [_nghost-%COMP%]   .radio-button.selected[_ngcontent-%COMP%]{background-color:#fff;-webkit-box-shadow:inset 0 2px 3px 0 rgba(0,0,0,.3);box-shadow:inset 0 2px 3px #0000004d}.radio-disabled[_ngcontent-%COMP%]{opacity:.3;pointer-events:none;position:inherit;clear:both;margin:-30px 0 0 -10px}.white-background   [_nghost-%COMP%]   .radio-button[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked + .radio-mark[_ngcontent-%COMP%]   .radio-dot[_ngcontent-%COMP%]{background-color:#0368d9}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(RadioButtonComponent, [{
    type: Component,
    args: [{
      selector: 'upr-radio-button',
      standalone: false,
      template: "<span\r\n\t[formGroup]=\"radioButtonGroup\"\r\n\tclass=\"radio-button\"\r\n\trole=\"radiogroup\"\r\n\t[ngClass]=\"{ selected: selectedValue === value, 'radio-disabled': disabled }\"\r\n>\r\n\t<input\r\n\t\trole=\"radio\"\r\n\t\ttype=\"radio\"\r\n\t\tid=\"radio-{{ radioName }}\"\r\n\t\t[ngModel]=\"selectedValue\"\r\n\t\t[value]=\"value\"\r\n\t\tformControlName=\"radioButton\"\r\n\t\tattr.disabled=\"disabled\"\r\n\t\t[attr.tabindex]=\"selectedValue ? (selectedValue === value ? 0 : -1) : 0\"\r\n\t\t[attr.aria-checked]=\"selectedValue === value\"\r\n\t\t[attr.analytics-title]=\"analyticsTitle + ' | ' + (label || value)\"\r\n\t/>\r\n\r\n\t<label class=\"radio-mark\" for=\"radio-{{ radioName }}\">\r\n\t\t<span\r\n\t\t\tclass=\"radio-dot\"\r\n\t\t\t[ngStyle]=\"{ backgroundColor: bgColor ? bgColor : '' }\"\r\n\t\t>\r\n\t\t\t<span class=\"sr-only\">{{ label || value }}</span>\r\n\t\t</span>\r\n\t</label>\r\n\r\n\t<div class=\"radio-text\">\r\n\t\t<ng-content></ng-content>\r\n\t</div>\r\n</span>\r\n",
      styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.radio-button{display:flex;position:relative;padding:8px 8px 8px 30px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:12px;font-weight:500;background:inherit}.radio-button input{position:absolute;opacity:0;left:2px}.radio-button input:focus+label{background-color:#05d2f0}.radio-button input:focus+label .radio-dot{background:#05d2f0}.radio-button .radio-mark{border:1px solid #a7a7a7;position:absolute;top:auto;left:-8px;height:25px;width:25px;border-radius:50%;padding:3px}.radio-button .radio-text{line-height:26px;padding-left:5px}.radio-button .radio-dot{display:block;width:17px;height:17px;border-radius:50%;background:#fff}.radio-button input:checked+.radio-mark .radio-dot{background-color:#036ce2}.radio-button.selected{-webkit-box-shadow:none;box-shadow:none}:host-context(.ticket-widget-content) .radio-button{background-color:#eee;padding-left:40px}:host-context(.ticket-widget-content) .radio-button .radio-mark{left:0}:host-context(.ticket-widget-content) .radio-button.selected{background-color:#fff;-webkit-box-shadow:inset 0 2px 3px 0 rgba(0,0,0,.3);box-shadow:inset 0 2px 3px #0000004d}.radio-disabled{opacity:.3;pointer-events:none;position:inherit;clear:both;margin:-30px 0 0 -10px}.white-background :host-context .radio-button input:checked+.radio-mark .radio-dot{background-color:#0368d9}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    radioName: [{
      type: Input
    }],
    selectedValue: [{
      type: Input
    }],
    value: [{
      type: Input
    }],
    radioIndex: [{
      type: Input
    }],
    bgColor: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    analyticsTitle: [{
      type: Input
    }],
    formReady: [{
      type: Output
    }]
  });
})();
class SuffixFieldComponent {
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.formReady = new EventEmitter();
  }
  ngOnInit() {
    this.isReadOnly = this.formData.readOnly || false;
    this.suffixGroup = this.formBuilder.group({
      suffix: new FormControl('', Validators.compose([Validators.maxLength(formFieldRanges.MAX.SUFFIX), Validators.pattern(this.formData.pattern1)]))
    });
    this.formReady.emit(this.suffixGroup);
  }
  get suffix() {
    return this.suffixGroup.get(this.formData.key);
  }
  updateSuffixFieldValue(suffix) {
    this.formData.value = (suffix || '').trim();
  }
  static {
    this.ɵfac = function SuffixFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || SuffixFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SuffixFieldComponent,
      selectors: [["upr-suffix-field"]],
      inputs: {
        formData: "formData"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      decls: 6,
      vars: 13,
      consts: [[3, "formGroup"], [3, "for"], [4, "ngIf"], ["attr.disabled", "isReadOnly", 3, "ngModelChange", "formControlName", "id", "type", "ngModel", "placeholder"], ["class", "error", "role", "alert", 4, "ngIf"], ["role", "alert", 1, "error"], ["aria-hidden", "true", 1, "icon", "icon-alert"]],
      template: function SuffixFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "label", 1);
          i0.ɵɵtext(2);
          i0.ɵɵtemplate(3, SuffixFieldComponent_small_3_Template, 2, 1, "small", 2);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "input", 3);
          i0.ɵɵtwoWayListener("ngModelChange", function SuffixFieldComponent_Template_input_ngModelChange_4_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.formData.value, $event) || (ctx.formData.value = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function SuffixFieldComponent_Template_input_ngModelChange_4_listener($event) {
            return ctx.updateSuffixFieldValue($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(5, SuffixFieldComponent_div_5_Template, 4, 2, "div", 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.suffixGroup);
          i0.ɵɵadvance();
          i0.ɵɵproperty("for", ctx.formData.key);
          i0.ɵɵattribute("data-aui", ctx.formData.label);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.formData.label, " ");
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.formData == null ? null : ctx.formData.optionalLabel);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData.key, "-input");
          i0.ɵɵproperty("formControlName", ctx.formData.key)("id", ctx.formData.key)("type", ctx.formData.controlType);
          i0.ɵɵtwoWayProperty("ngModel", ctx.formData.value);
          i0.ɵɵproperty("placeholder", ctx.formData.placeholder);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.suffix.invalid && (ctx.suffix.dirty || ctx.suffix.touched));
        }
      },
      dependencies: [i2$1.NgIf, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SuffixFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-suffix-field',
      standalone: false,
      template: "<div [formGroup]=\"suffixGroup\">\r\n\t<label attr.data-aui=\"{{ formData.label }}\" [for]=\"formData.key\">\r\n\t\t{{ formData.label }}\r\n\t\t<small *ngIf=\"formData?.optionalLabel\">{{ formData.optionalLabel }}</small>\r\n\t</label>\r\n\t<input\r\n\t\tattr.data-aui=\"{{ formData.key }}-input\"\r\n\t\t[formControlName]=\"formData.key\"\r\n\t\t[id]=\"formData.key\"\r\n\t\t[type]=\"formData.controlType\"\r\n\t\t[(ngModel)]=\"formData.value\"\r\n\t\tattr.disabled=\"isReadOnly\"\r\n\t\t[placeholder]=\"formData.placeholder\"\r\n\t\t(ngModelChange)=\"updateSuffixFieldValue($event)\"\r\n\t/>\r\n\t<div\r\n\t\tclass=\"error\"\r\n\t\trole=\"alert\"\r\n\t\t*ngIf=\"suffix.invalid && (suffix.dirty || suffix.touched)\"\r\n\t>\r\n\t\t<i class=\"icon icon-alert\" aria-hidden=\"true\"></i>\r\n\t\t<small\r\n\t\t\t*ngIf=\"suffix.errors.maxlength\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t>\r\n\t\t\t{{ formData?.errors?.ER26 }}\r\n\t\t</small>\r\n\t\t<small\r\n\t\t\t*ngIf=\"suffix?.errors?.pattern\"\r\n\t\t\tattr.data-aui=\"{{ formData.label }}-error\"\r\n\t\t>\r\n\t\t\t{{ formData?.errors?.ER1 }}\r\n\t\t</small>\r\n\t</div>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formReady: [{
      type: Output
    }],
    formData: [{
      type: Input
    }]
  });
})();
class GdsEmailFieldComponent {
  constructor(fb) {
    this.fb = fb;
    this.theme = AvailableGdsThemes[0];
    this.formReady = new EventEmitter();
  }
  ngOnInit() {
    this.isReadOnly = this.formData?.readOnly ?? false;
    this.requiredLabel();
    this.emailGroup = this.fb.group({
      email: new FormControl({
        value: '',
        disabled: this.isReadOnly
      }, Validators.compose(this.validators))
    });
    this.onValueChange(this.formDataValue || this.formData?.value || '');
    this.formReady.emit(this.emailControl);
  }
  ngOnChanges() {
    this.requiredLabel();
    if (this.emailGroup && this.emailControl?.value) {
      this.updateEmailPattern(this.emailControl?.value);
    }
  }
  get emailControl() {
    return this.emailGroup?.get(this.formData?.key);
  }
  get validators() {
    const validators = [...(this.formData?.required ? [gdsRequiredValidator(this.formData?.errors?.ER26)] : []), gdsPatternValidator(this.formData?.pattern1, this.formData?.errors?.ER6)];
    return validators;
  }
  requiredLabel() {
    const labelRequired = this.formData.required ? ' *' : '';
    this.formData.label = trimEnd(this.formData.label, '*').trim();
    this.formData.label = `${this.formData.label}${labelRequired}`;
  }
  updateEmailPattern(value) {
    if (!value) {
      return;
    }
    const emailControl = this.emailGroup.get('email');
    emailControl.setValidators(this.validators);
    emailControl.updateValueAndValidity();
  }
  onValueChange(value) {
    this.emailControl?.setValue(value);
    this.updateEmailPattern(value);
  }
  onBlurChange() {
    this.emailControl?.markAsTouched();
    this.emailControl?.setValue(this.emailControl.value);
    this.emailControl.updateValueAndValidity();
  }
  static {
    this.ɵfac = function GdsEmailFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsEmailFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsEmailFieldComponent,
      selectors: [["upr-gds-email-field"]],
      inputs: {
        formData: "formData",
        formDataValue: "formDataValue",
        pattern: "pattern",
        theme: "theme"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 2,
      vars: 20,
      consts: [[1, "email-group", 3, "formGroup"], [3, "valueChange", "blurChange", "data", "type", "value", "theme", "errors"]],
      template: function GdsEmailFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "gds-input", 1);
          i0.ɵɵlistener("valueChange", function GdsEmailFieldComponent_Template_gds_input_valueChange_1_listener($event) {
            return ctx.onValueChange($event == null ? null : $event.detail);
          })("blurChange", function GdsEmailFieldComponent_Template_gds_input_blurChange_1_listener() {
            return ctx.onBlurChange();
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("formGroup", ctx.emailGroup);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData == null ? null : ctx.formData.key, "-input");
          i0.ɵɵproperty("data", i0.ɵɵpureFunctionV(8, _c16, [ctx.formData == null ? null : ctx.formData.label, ctx.formData == null ? null : ctx.formData.supportingText, ctx.formData == null ? null : ctx.formData.optionalLabel, ctx.formData == null ? null : ctx.formData.tooltip, ctx.formData == null ? null : ctx.formData.placeholder, ctx.pattern, ctx.formData == null ? null : ctx.formData.required, ctx.isReadOnly, ctx.isReadOnly, ((ctx.formData == null ? null : ctx.formData.optionalLabel) ? (ctx.formData == null ? null : ctx.formData.label) + " " + (ctx.formData == null ? null : ctx.formData.optionalLabel) : ctx.formData == null ? null : ctx.formData.label) || "Email", (ctx.formData == null ? null : ctx.formData.key) + "-error"]))("type", ctx.formData == null ? null : ctx.formData.controlType)("value", ctx.emailControl == null ? null : ctx.emailControl.value)("theme", ctx.theme)("errors", ctx.emailControl == null ? null : ctx.emailControl.errors == null ? null : ctx.emailControl.errors.message);
        }
      },
      dependencies: [i1.NgControlStatusGroup, i1.FormGroupDirective, i2$3.GdsInputHelperDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsEmailFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-email-field',
      standalone: false,
      template: "<div [formGroup]=\"emailGroup\" class=\"email-group\">\r\n\t<gds-input\r\n\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t[data]=\"{\r\n\t\t\tprimaryLabel: formData?.label,\r\n\t\t\tsupportingText: formData?.supportingText,\r\n\t\t\tsecondaryLabel: formData?.optionalLabel,\r\n\t\t\ttooltip: formData?.tooltip,\r\n\t\t\tplaceholder: formData?.placeholder,\r\n\t\t\tpattern: pattern,\r\n\t\t\trequired: formData?.required,\r\n\t\t\tdisabled: isReadOnly,\r\n\t\t\treadonly: isReadOnly,\r\n\t\t\tariaText:\r\n\t\t\t\t(formData?.optionalLabel\r\n\t\t\t\t\t? formData?.label + ' ' + formData?.optionalLabel\r\n\t\t\t\t\t: formData?.label) || 'Email',\r\n\t\t\tdescribedby: formData?.key + '-error'\r\n\t\t}\"\r\n\t\t[type]=\"formData?.controlType\"\r\n\t\t[value]=\"emailControl?.value\"\r\n\t\t[theme]=\"theme\"\r\n\t\t[errors]=\"emailControl?.errors?.message\"\r\n\t\t(valueChange)=\"onValueChange($event?.detail)\"\r\n\t\t(blurChange)=\"onBlurChange()\"\r\n\t></gds-input>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formData: [{
      type: Input
    }],
    formDataValue: [{
      type: Input
    }],
    pattern: [{
      type: Input
    }],
    theme: [{
      type: Input
    }],
    formReady: [{
      type: Output
    }]
  });
})();
class GdsDobFieldComponent {
  constructor(fb) {
    this.fb = fb;
    this.theme = AvailableGdsThemes[0];
    this.formReady = new EventEmitter();
  }
  ngOnInit() {
    this.requiredLabel();
    this.isReadOnly = this.formData?.readOnly ?? false;
    this.dobGroup = this.fb.group({
      dateOfBirth: new FormControl(this.formDataValue || this.formData?.value || '', Validators.compose([this.isRequired ? gdsRequiredValidator(this.formData?.errors?.ER26) : null, DateRangeValidator(this.formData?.errors?.ER19)]))
    });
    this.formReady.emit(this.dobControl);
  }
  get dobControl() {
    return this.dobGroup?.get(this.formData?.key);
  }
  get isRequired() {
    return [true, 'true'].includes(get(this.formData, 'required', false));
  }
  requiredLabel() {
    this.formData.label = RequiredLabel(this.isRequired, this.formData?.label);
  }
  static {
    this.ɵfac = function GdsDobFieldComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsDobFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: GdsDobFieldComponent,
      selectors: [["upr-gds-dob-field"]],
      inputs: {
        formData: "formData",
        formDataValue: "formDataValue",
        pattern: "pattern",
        theme: "theme"
      },
      outputs: {
        formReady: "formReady"
      },
      standalone: false,
      decls: 2,
      vars: 21,
      consts: [[1, "gds-dob-group", 3, "formGroup"], [3, "data", "type", "value", "theme", "errors", "formControlName"]],
      template: function GdsDobFieldComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "gds-input", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_3_0;
          i0.ɵɵproperty("formGroup", ctx.dobGroup);
          i0.ɵɵadvance();
          i0.ɵɵattributeInterpolate1("data-aui", "", ctx.formData == null ? null : ctx.formData.key, "-input");
          i0.ɵɵproperty("data", i0.ɵɵpureFunctionV(9, _c24, [ctx.formData == null ? null : ctx.formData.label, ctx.formData == null ? null : ctx.formData.supportingText, ctx.formData == null ? null : ctx.formData.tooltip, ctx.formData == null ? null : ctx.formData.placeholder, ctx.formData == null ? null : ctx.formData.required, ctx.isReadOnly, ctx.isReadOnly, ctx.pattern, (ctx.formData == null ? null : ctx.formData.inputmode) || "text", ((ctx.formData == null ? null : ctx.formData.optionalLabel) ? (ctx.formData == null ? null : ctx.formData.label) + " " + (ctx.formData == null ? null : ctx.formData.optionalLabel) : ctx.formData == null ? null : ctx.formData.label) || "Date of Birth", (ctx.formData == null ? null : ctx.formData.key) + "-error"]))("type", (tmp_3_0 = ctx.formData == null ? null : ctx.formData.controlType) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "date")("value", ctx.dobControl == null ? null : ctx.dobControl.value)("theme", ctx.theme)("errors", ctx.dobControl == null ? null : ctx.dobControl.errors == null ? null : ctx.dobControl.errors.message)("formControlName", ctx.formData == null ? null : ctx.formData.key);
        }
      },
      dependencies: [i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName, i2$3.GdsInputHelperDirective],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsDobFieldComponent, [{
    type: Component,
    args: [{
      selector: 'upr-gds-dob-field',
      standalone: false,
      template: "<div [formGroup]=\"dobGroup\" class=\"gds-dob-group\">\r\n\t<gds-input\r\n\t\tattr.data-aui=\"{{ formData?.key }}-input\"\r\n\t\t[data]=\"{\r\n\t\t\tprimaryLabel: formData?.label,\r\n\t\t\tsupportingText: formData?.supportingText,\r\n\t\t\ttooltip: formData?.tooltip,\r\n\t\t\tplaceholder: formData?.placeholder,\r\n\t\t\trequired: formData?.required,\r\n\t\t\tdisabled: isReadOnly,\r\n\t\t\treadonly: isReadOnly,\r\n\t\t\tpattern: pattern,\r\n\t\t\tinputmode: formData?.inputmode || 'text',\r\n\t\t\tariaText:\r\n\t\t\t\t(formData?.optionalLabel\r\n\t\t\t\t\t? formData?.label + ' ' + formData?.optionalLabel\r\n\t\t\t\t\t: formData?.label) || 'Date of Birth',\r\n\t\t\tdescribedby: formData?.key + '-error'\r\n\t\t}\"\r\n\t\t[type]=\"formData?.controlType ?? 'date'\"\r\n\t\t[value]=\"dobControl?.value\"\r\n\t\t[theme]=\"theme\"\r\n\t\t[errors]=\"dobControl?.errors?.message\"\r\n\t\t[formControlName]=\"formData?.key\"\r\n\t></gds-input>\r\n</div>\r\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    formData: [{
      type: Input
    }],
    formDataValue: [{
      type: Input
    }],
    pattern: [{
      type: Input
    }],
    theme: [{
      type: Input
    }],
    formReady: [{
      type: Output
    }]
  });
})();
class FormFieldsModule {
  static {
    this.ɵfac = function FormFieldsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormFieldsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FormFieldsModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxMyDatePickerModule.forRoot(), TooltipModule, MsUtilsModule, CardTypeModule, GdsInputHelperModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormFieldsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxMyDatePickerModule.forRoot(), TooltipModule, MsUtilsModule, CardTypeModule, GdsInputHelperModule],
      declarations: [AddressFieldComponent, DatepickerComponent, CheckboxComponent, DateFieldComponent, DropdownFieldComponent, EmailFieldComponent, GdsAddressFieldComponent, GdsDateFieldComponent, GdsNameFieldComponent, GdsPaymentCardFieldComponent, GdsPhoneFieldComponent, GdsEmailFieldComponent, GdsDobFieldComponent, NameFieldComponent, PasswordFieldComponent, PaymentCardFieldComponent, PhoneFieldComponent, RadioButtonComponent, SuffixFieldComponent],
      providers: [],
      exports: [AddressFieldComponent, DatepickerComponent, CheckboxComponent, DateFieldComponent, DropdownFieldComponent, EmailFieldComponent, GdsAddressFieldComponent, GdsDateFieldComponent, GdsNameFieldComponent, GdsPaymentCardFieldComponent, GdsPhoneFieldComponent, GdsEmailFieldComponent, GdsDobFieldComponent, NameFieldComponent, PasswordFieldComponent, PaymentCardFieldComponent, PhoneFieldComponent, RadioButtonComponent, SuffixFieldComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();
class FormControlService {
  getErrorMessage(errors) {
    const errorList = [];
    errors.forEach(code => {
      errorList[code] = get(this.pageLabels, code);
    });
    return errorList;
  }
  get nameControls() {
    return [{
      key: 'firstName',
      value: '',
      label: get(this.pageLabels, 'FirstNameLabel', 'First Name'),
      required: true,
      controlType: 'text',
      pattern1: NamePattern.NAME,
      placeholder: '',
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER54', 'ER1', 'maxLengthError'])
    }, {
      key: 'lastName',
      value: '',
      label: get(this.pageLabels, 'LastNameLabel', 'Last Name'),
      required: true,
      controlType: 'text',
      pattern1: NamePattern.NAME,
      placeholder: '',
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER54', 'ER1', 'maxLengthError'])
    }];
  }
  get suffixControl() {
    return {
      key: 'suffix',
      value: '',
      label: get(this.pageLabels, 'SuffixLabel', 'Suffix'),
      required: false,
      controlType: 'text',
      pattern1: NamePattern.NAME,
      placeholder: '',
      readOnly: false,
      optionalLabel: get(this.pageLabels, 'OptionalLabel', 'All Fields Are Optional'),
      errors: this.getErrorMessage(['ER26', 'ER54', 'ER1'])
    };
  }
  get emailControl() {
    return {
      key: 'email',
      value: '',
      label: get(this.pageLabels, 'EmailAddressLabel', 'Email Address'),
      required: true,
      controlType: 'text',
      pattern1: EmailPasswordPattern.EMAIL,
      placeholder: '',
      tooltip: get(this.pageLabels, 'EmailAddressToolTip', 'By changing your email you are also changing your login User ID.'),
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER6'])
    };
  }
  get phoneControl() {
    return {
      key: 'phone',
      value: '',
      label: get(this.pageLabels, 'PhoneNumberLabel', 'Phone'),
      required: true,
      controlType: 'tel',
      pattern1: PhonePattern.PHONE,
      placeholder: '',
      tooltip: get(this.pageLabels, 'PhoneNumberToolTip', 'Number will be used as a contact solely for delivery or purchase-related issues.'),
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER5', 'ER41', 'nonUSNumberError', 'minLengthError', 'maxLengthError'])
    };
  }
  get dateControl() {
    return {
      key: 'date',
      value: '',
      label: get(this.pageLabels, 'DOBLabel', 'Date of Birth'),
      placeholder: get(this.pageLabels, 'VPDOBFormat', 'MM/DD'),
      required: true,
      controlType: 'text',
      pattern1: MiscPattern.ANNUALPASS_DOB,
      tooltip: get(this.pageLabels, 'DOBToolTip', 'We collect date of birth to ensure compliance with applicable law.'),
      errors: this.getErrorMessage(['ER26', 'ER134', 'InValidDateError', 'ER19', 'futureDateError']),
      class: 'small-12'
    };
  }
  get dateOfBirthControl() {
    return {
      key: 'dateOfBirth',
      value: '',
      label: get(this.pageLabels, 'DOBLabel', 'Date of Birth'),
      required: false,
      controlType: 'date',
      pattern1: MiscPattern.DATE,
      tooltip: get(this.pageLabels, 'DOBToolTip', 'We collect date of birth to ensure compliance with applicable law.'),
      errors: this.getErrorMessage(['ER26', 'ER19', 'InValidDateError']),
      class: 'small-12'
    };
  }
  get passwordControl() {
    return [{
      key: 'passwordText',
      value: '',
      label: get(this.pageLabels, 'PasswordLabel', 'Password'),
      required: true,
      controlType: 'textbox',
      pattern1: EmailPasswordPattern.PASSWORD_REGEX,
      placeholder: '',
      readOnly: false,
      tooltip: get(this.pageLabels, 'PasswordInfoTooltip', "A minimum of 8 characters are required for a new password. Any standard US key board characters are permitted. Passwords are case sensitive (i.e. 'a' is not the same as 'A')"),
      errors: this.getErrorMessage(['ER26', 'ER54', 'ER113', 'ER51'])
    }, {
      key: 'passwordExt',
      value: '',
      label: get(this.pageLabels, 'PasswordLabel', 'Password'),
      required: true,
      controlType: 'textbox',
      pattern1: EmailPasswordPattern.PASSWORD_REGEX,
      placeholder: '',
      readOnly: false,
      tooltip: get(this.pageLabels, 'PasswordInfoTooltip', "A minimum of 8 characters are required for a new password. Any standard US key board characters are permitted. Passwords are case sensitive (i.e. 'a' is not the same as 'A')"),
      colors: JSON.parse(get(this.pageLabels, 'PasswordFlagColors', '["#F00","#F90","#FF0","#9F0","#0B0"]')),
      strength: JSON.parse(get(this.pageLabels, 'PasswordFlagStrength', '["Very Weak","Weak","Medium","Moderate","Strong"]')),
      errors: this.getErrorMessage(['ER26', 'ER54', 'ER113', 'ER9', 'CONST_PASSWORD_CAP', 'ER60', 'ER51'])
    }, {
      key: 'passwordValid',
      value: '',
      label: get(this.pageLabels, 'PasswordLabel', 'Password'),
      required: true,
      controlType: 'textbox',
      pattern1: EmailPasswordPattern.PASSWORD_LENGTH_REGEX,
      placeholder: '',
      readOnly: false,
      tooltip: get(this.pageLabels, 'PasswordInfoTooltip', "A minimum of 8 characters are required for a new password. Any standard US key board characters are permitted. Passwords are case sensitive (i.e. 'a' is not the same as 'A')"),
      colors: JSON.parse(get(this.pageLabels, 'PasswordFlagColors', '["#F00","#F90","#FF0","#9F0","#0B0"]')),
      strength: JSON.parse(get(this.pageLabels, 'PasswordFlagStrength', '["Very Weak","Weak","Medium","Moderate","Strong"]')),
      errors: this.getErrorMessage(['ER26', 'ER54', 'ER113', 'upr.com.errors.form.password.uppercase', 'ER51', 'ER9', 'CONST_PASSWORD_CAP', 'ER60', 'ER51'])
    }];
  }
  get addressControls() {
    return [{
      key: 'country',
      label: get(this.pageLabels, 'CountryLabel', 'Country'),
      controlType: 'dropdown',
      required: true,
      requiredSRText: get(this.pageLabels, 'requiredSRText', ''),
      selected: '',
      placeholder: '',
      iconTitleText: get(this.pageLabels, 'CountryTitleText', 'Country'),
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER56', 'ER15', 'maxLengthError'])
    }, {
      key: 'addressLine1',
      value: '',
      label: get(this.pageLabels, 'Address1Label', 'Address Line 1'),
      required: true,
      controlType: 'text',
      pattern1: NumberCharPattern.LETTER_NUMBER,
      placeholder: '',
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER56', 'ER15', 'maxLengthError'])
    }, {
      key: 'addressLine2',
      value: '',
      label: get(this.pageLabels, 'Address2Label', 'Address Line 2'),
      required: false,
      controlType: 'text',
      pattern1: NumberCharPattern.LETTER_NUMBER,
      placeholder: '',
      readOnly: false,
      optionalLabel: get(this.pageLabels, 'OptionalLabel', 'Optional'),
      errors: this.getErrorMessage(['ER26', 'ER56', 'ER15'])
    }, {
      key: 'zipPostalCode',
      value: '',
      label: get(this.pageLabels, 'ZipCodeLabel', 'Zip/Postal Code'),
      required: true,
      controlType: 'text',
      pattern1: ZipCodePattern.ZIP,
      pattern2: ZipCodePattern.NON_US_ZIP,
      placeholder: '',
      readOnly: false,
      errors: this.getErrorMessage(['ER32', 'ER26', 'ER40', 'maxLengthError'])
    }, {
      key: 'city',
      value: '',
      label: get(this.pageLabels, 'CityLabel', 'City'),
      required: true,
      controlType: 'text',
      pattern1: NumberCharPattern.LETTER_NUMBER,
      placeholder: '',
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER54', 'ER15', 'maxLengthError'])
    }, {
      key: 'state',
      value: '',
      label: get(this.pageLabels, 'StateProvinceLabel', 'State/Province/Region'),
      controlType: 'dropdown',
      required: true,
      requiredSRText: get(this.pageLabels, 'requiredSRText', ''),
      placeholder: 'Select',
      readOnly: false,
      errors: this.getErrorMessage(['ER26'])
    }];
  }
  get creditCardLabelsControl() {
    return {
      label1: get(this.pageLabels, 'AddCreditCardLabel', 'Add Credit Card'),
      label2: get(this.pageLabels, 'CreditCardExpiredLabel', 'Expired')
    };
  }
  get monthLabelsControl() {
    return {
      label1: 'Exp. Date'
    };
  }
  get paymentCardControls() {
    return [{
      key: 'creditCardDropdown',
      value: '',
      label: get(this.pageLabels, 'CreditCardLabel', 'Credit Card'),
      required: true,
      requiredSRText: get(this.pageLabels, 'requiredSRText', ''),
      controlType: 'creditCardDropdown',
      additionalLabel: this.creditCardLabelsControl,
      placeholder: '',
      readOnly: false,
      class: 'group-field'
    }, {
      key: 'creditCardTextbox',
      value: '',
      label: get(this.pageLabels, 'CreditCardNumberLabel', 'Credit Card Number'),
      required: true,
      controlType: 'tel',
      autocomplete: 'cc-number',
      inputmode: 'numeric',
      pattern1: [CardPattern.VISA, CardPattern.MASTER, CardPattern.AMEX, CardPattern.DISCOVER, CardPattern.DINERS, CardPattern.JCB, CardPattern.VISA_COBRAND, CardPattern.UNION_PAY],
      pattern2: NumberCharPattern.NON_NUMBER,
      placeholder: '',
      readOnly: false,
      class: 'small-12',
      errors: this.getErrorMessage(['ER26', 'ER34'])
    }, {
      key: 'month',
      label: get(this.pageLabels, 'MonthLabel', 'Month'),
      additionalLabel: this.monthLabelsControl,
      controlType: 'dropdown',
      required: true,
      requiredSRText: get(this.pageLabels, 'requiredSRText', ''),
      class: 'group-field',
      placeholder: 'Select',
      errors: this.getErrorMessage(['ER26'])
    }, {
      key: 'year',
      value: '',
      label: get(this.pageLabels, 'YearLabel', 'Year'),
      required: true,
      requiredSRText: get(this.pageLabels, 'requiredSRText', ''),
      controlType: 'dropdown',
      class: 'group-field',
      placeholder: 'Select',
      errors: this.getErrorMessage(['ER26'])
    }, {
      key: 'securityCode',
      value: '',
      label: get(this.pageLabels, 'SecurityCodeLabel', 'Security Code'),
      required: true,
      controlType: 'tel',
      inputmode: 'numeric',
      autocomplete: 'cc-csc',
      pattern1: CardPattern.SECURITY_CODE,
      pattern2: CardPattern.SECURITY_CODE_AMEX,
      placeholder: '',
      class: 'small-6',
      tooltip: get(this.pageLabels, 'SecurityCodeToolTip', 'Security code for Discover, MasterCard or Visa is the last three digits in the signature area on the back of your card. For AMEX it’s the four digits on the front of your card. '),
      readOnly: false,
      errors: this.getErrorMessage(['ER26', 'ER37'])
    }];
  }
  static {
    this.ɵfac = function FormControlService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FormControlService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FormControlService,
      factory: FormControlService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FormControlService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();

/*
 * Public API Surface of form-fields
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressFieldComponent, AddressFieldService, CheckboxComponent, DateFieldComponent, DatepickerComponent, DropdownFieldComponent, EN, ES, EmailFieldComponent, EmailPasswordPattern, FormControlService, FormFieldsModule, GdsAddressFieldComponent, GdsDateFieldComponent, GdsDobFieldComponent, GdsEmailFieldComponent, GdsNameFieldComponent, GdsPaymentCardFieldComponent, GdsPhoneFieldComponent, MiscPattern, NameFieldComponent, NamePattern, NumberCharPattern, PasswordFieldComponent, PaymentCardFieldComponent, PhoneFieldComponent, PhonePattern, RadioButtonComponent, SuffixFieldComponent, ZipCodePattern, formFieldRanges };
